const en: Record<string, string> = {
  // MCP self-service token UI (LEA-269)
  'mcp.live': 'Live',
  'mcp.tok.generate': 'Generate token',
  'mcp.tok.title': 'Connect an AI client',
  'mcp.tok.intro':
    'Generate a personal token to connect Claude, Cursor or your own agent to your Leadscraper account. The token is shown only once.',
  'mcp.tok.name': 'Token name',
  'mcp.tok.generating': 'Generating…',
  'mcp.tok.once': 'Copy this token now: for security it will never be shown again.',
  'mcp.tok.yourToken': 'Your token',
  'mcp.tok.copy': 'Copy',
  'mcp.tok.copied': 'Copied',
  'mcp.tok.claudeConfig': 'Claude Desktop config',
  'mcp.tok.copyConfig': 'Copy config',
  'mcp.tok.done': 'Done',
  'mcp.tok.limit': 'Token limit reached. Revoke an old one first.',
  'mcp.tok.mintFailed': 'Could not generate token. Please try again.',
  'mcp.tok.revoked': 'Token "{name}" revoked',
  'mcp.tok.revokeFailed': 'Could not revoke token.',
  'mcp.tok.expires': 'expires',
  'mcp.tok.lastUsed': 'last used',
  'mcp.tok.neverUsed': 'never used',
  'mcp.tok.revoke': 'Revoke',
  // LEA-349 Phase 3: Claude.ai (web) OAuth connect path
  'mcp.claude.connect': 'Connect to Claude',
  'mcp.claude.cardHint': 'Claude.ai (web) connects in one click via OAuth: no token needed.',
  'mcp.claude.intro':
    'Add Leadscraper to Claude.ai as a custom connector. You approve access once: no token to copy or paste.',
  'mcp.claude.cta': 'Open Claude connectors',
  'mcp.claude.urlLabel': 'Your MCP server URL',
  'mcp.claude.step1': 'Click "Open Claude connectors", then "Add custom connector".',
  'mcp.claude.step2': 'Paste the URL above and continue.',
  'mcp.claude.step3': 'Approve access ("Allow"). Claude can now use your leads.',
  'mcp.claude.desktopNote': 'Using Claude Desktop, Cursor or your own agent?',
  'mcp.claude.desktopCta': 'Generate a token instead',
  'acct.bill.addMethod': 'Add payment method',
  'acct.bill.cardEnds': 'Visa ending •• 4242',
  'acct.bill.cardExpHolder': 'Exp. 08/2028 · Janik Deimann',
  'acct.bill.col.amount': 'Amount',
  'acct.bill.col.credits': 'Credits',
  'acct.bill.col.date': 'Date',
  'acct.bill.col.desc': 'Description',
  'acct.bill.col.invoice': 'Invoice',
  'acct.bill.col.status': 'Status',
  'acct.bill.descSub': '{plan} subscription · {month} {year}',
  'acct.bill.empty': 'No transactions found',
  'acct.bill.emptySub': 'Your payment history will appear here after your first purchase.',
  'acct.bill.filter.30': 'Last 30 days',
  'acct.bill.filter.90': 'Last 90 days',
  'acct.bill.filter.all': 'All time',
  'acct.bill.history': 'Transaction history',
  'acct.bill.manageCards': 'Manage cards',
  'acct.bill.manageViaStripe': 'Manage via Stripe Customer Portal',
  'acct.bill.methodAutoAdded': 'Added automatically when your trial starts.',
  'acct.bill.methodOnFile': 'Payment method on file',
  'acct.bill.methods': 'Payment methods',
  'acct.bill.noMethods': 'No payment methods found',
  'acct.bill.paid': 'Paid',
  'acct.bill.pdfUnavailable': 'This invoice can’t be loaded as a PDF here right now. You can open and download it on Stripe.',
  'acct.bill.pdfOpenStripe': 'Open invoice on Stripe',
  'acct.bill.primary': 'Primary',
  'acct.dataAccount': 'Data & account',
  'acct.deleteAccount.btn': 'Delete account',
  'acct.deleteAccount.confirmBtn': 'Delete account permanently',
  'acct.deleteAccount.confirmPwLabel': 'Enter your password to confirm',
  'acct.deleteAccount.deleting': 'Deleting …',
  'acct.deleteAccount.errFailed': 'Could not delete account.',
  'acct.deleteAccount.errPwRequired': 'Please enter your password.',
  'acct.deleteAccount.modalBody':
    'Your account will be deactivated and permanently deleted after 30 days. During this period you can reactivate it via email + password. All your leads, profiles and ratings will then be irrevocably deleted.',
  'acct.deleteAccount.modalTitle': 'Delete account',
  'acct.deleteAccount.title': 'Delete account',
  'acct.deleteAccount.warn':
    'Your account will be permanently deleted in 30 days. You can reactivate it during this period.',
  'acct.seedimport.title': 'Import existing-customer list',
  'acct.seedimport.desc':
    'Upload a CSV or text file of your existing customers — one domain or URL per line (or a column of domains). These companies are never delivered as a new lead on ANY audience.',
  'acct.seedimport.hint': 'CSV or .txt · max 5 MB',
  'acct.seedimport.cta': 'Upload CSV',
  'acct.seedimport.uploading': 'Importing …',
  'acct.seedimport.report':
    '{rows} rows · {resolved} domains recognised · {added} new · {total} in your list',
  'acct.seedimport.unresolved': '{n} rows skipped (no recognisable domain)',
  'acct.seedimport.capped': 'Import limit reached — not all domains were added.',
  'acct.seedimport.failed': 'Import failed. Check the file and try again.',
  'acct.export.btn': 'Export',
  'acct.export.failed': 'Export failed. Please try again.',
  'acct.export.preparing':
    'Preparing export: this can take a little while if you have a lot of data.',
  'acct.export.ready': 'Download started.',
  'acct.export.sub': 'GDPR Art. 20: all your data as a JSON download.',
  'acct.export.title': 'Export data',
  'acct.int.apiKey': 'API key',
  'acct.int.apiKeyP': 'From your CRM developer settings',
  'acct.int.autoPush': 'Auto-push on "Fits"',
  'acct.int.autoPushSub': 'Leads are pushed to your CRM as soon as you confirm them.',
  'acct.int.bulkPush': 'Send {n} to CRM',
  // LEA-282: HubSpot OAuth strings (Wave 2)
  'acct.int.oauthFail': 'OAuth connect failed',
  'acct.int.reconnect': 'Reconnect',
  'acct.int.reconnectRequired': 'Reconnect required',
  'acct.int.connectedVia': 'Connected via OAuth',
  // LEA-268 backfill: CRM-button strings missing from the initial deploy
  // (Om bug-report 2026-05-26 — keys rendered as bracketed [det.crmOpenRecord]).
  'det.crmPushing': 'Pushing…',
  'det.crmPushFail': 'CRM push failed',
  'det.crmSubRequired': 'CRM push requires a paid plan.',
  'det.crmDuplicate': 'Already in CRM',
  'det.crmNotConnected': 'No CRM connected. Set one up in Account → Integrations',
  'det.crmOpenRecord': 'View record',
  'acct.int.pushFail': 'CRM push failed',
  'acct.int.pushDuplicate': 'Already in CRM',
  'acct.int.pushSubRequired': 'CRM push requires a paid plan.',
  'acct.int.bulkSummary': '{pushed} pushed · {skipped} skipped · {failed} failed',
  'leads.bulkPushBtn': 'Push {n} to {crm}',
  'leads.bulkPushPickBtn': 'Push {n} to CRM ▾',
  'leads.bulkPushTitle': 'Push the leads currently visible (max 50) to your CRM',
  'acct.int.cancel': 'Cancel',
  'acct.int.connect': 'Connect',
  // LEA-317: friendly free/expired-plan gate (replaces the raw 402 JSON the
  // OAuth connect tab used to render).
  'acct.int.subRequired':
    'CRM integrations are available on paid plans only. Upgrade your plan to connect your CRM.',
  'acct.int.upgradeTitle': 'Upgrade to connect your CRM',
  'acct.int.upgradeCta': 'Upgrade',
  'acct.int.connectFirst': 'Connect your CRM in Account settings to push leads automatically.',
  'acct.int.connectSuccess': 'Connected to {name}',
  'acct.int.connected': 'Connected',
  'acct.int.disconnect': 'Disconnect',
  'acct.int.disconnectSuccess': 'Disconnected from {name}',
  'acct.int.manage': 'Manage',
  'acct.int.mapping': 'Field mapping',
  'acct.int.mappingSub': 'Leadscraper fields → CRM fields',
  'acct.int.none': 'No CRM connected',
  'acct.int.notConnected': 'Not connected',
  'acct.int.notPushedYet': 'Not pushed yet',
  'acct.int.object': 'Object type',
  'acct.int.openInCRM': 'Open in {name}',
  'acct.int.owner': 'Owner',
  'acct.int.pipeline': 'Pipeline',
  'acct.int.pushSuccess': 'Sent {n} lead(s) to {name}',
  'acct.int.pushToCRM': 'Send to CRM',
  'acct.int.pushedAt': 'Pushed {when}',
  'acct.int.pushedTo': 'In {name}',
  'acct.int.save': 'Save connection',
  'acct.int.sectionLead': 'CRM status',
  'acct.int.stage': 'Stage for new leads',
  'acct.int.sub': 'Connect your CRM and push qualified leads automatically, or one at a time.',
  // LEA-334: webhook signing secret
  'acct.int.whsec.title': 'Webhook signing secret',
  'acct.int.whsec.sub':
    'We sign every webhook delivery with HMAC-SHA256 so your endpoint can verify it really came from Leadscraper.',
  'acct.int.whsec.revealed': 'Copy this now: it is shown only once.',
  'acct.int.whsec.copy': 'Copy',
  'acct.int.whsec.copied': 'Copied',
  'acct.int.whsec.rotate': 'Rotate & reveal secret',
  'acct.int.whsec.rotating': 'Rotating…',
  'acct.int.whsec.rotateHint':
    'Rotating generates a new secret and reveals it once. Update your endpoint afterwards.',
  'acct.int.whsec.fail': 'Could not rotate the signing secret.',
  'acct.int.whsec.docs':
    'Verify: header X-Leadscraper-Signature: t=<unix>,v1=<hex>, where hex = HMAC-SHA256(secret, "<t>.<rawBody>"). Reject the request if it does not match or the timestamp is stale.',
  // LEA-334: webhook connect-modal copy
  'acct.int.webhookUrl': 'Webhook URL',
  'acct.int.webhookUrlP': 'https://your-endpoint.example.com/leadscraper',
  'acct.int.autoPushSubWebhook':
    'New leads are sent to your webhook automatically once their contacts are enriched.',
  // LEA-334: webhook verification handshake
  'acct.int.whverify.title': 'Verify your endpoint',
  'acct.int.whverify.sub':
    'A reachable endpoint (returns 2xx) is not the same as a verified one. Confirm a one-time code so we know leads actually arrive. Until then, none are delivered.',
  'acct.int.whverify.verified': '✓ Verified',
  'acct.int.whverify.unverified': 'Not verified',
  'acct.int.whverify.send': 'Send test event',
  'acct.int.whverify.sending': 'Sending…',
  'acct.int.whverify.resend': 'Resend test event',
  'acct.int.whverify.sent': 'Test event sent. Check your endpoint for the code.',
  'acct.int.whverify.sendFail': 'Could not send the test event.',
  'acct.int.whverify.enter': 'Enter the code (LSWH-…) that arrived at your endpoint:',
  'acct.int.whverify.confirm': 'Confirm',
  'acct.int.whverify.ok': 'Webhook verified. Leads can now be delivered.',
  'acct.int.whverify.mismatch': "That code doesn't match. Check your endpoint and try again.",
  'acct.int.whverify.expired': 'That code expired. Send a new test event.',
  'acct.int.testing': 'Testing connection …',
  'acct.int.title': 'CRM integrations',
  'acct.menu.logout': 'Sign out',
  'acct.menu.settings': 'Account settings',
  'acct.plan.trialFirstCharge': 'First charge on {date}. Cancel any time with one click.',
  'acct.plan.active': 'Active',
  'acct.plan.canceled': 'Canceled',
  'acct.plan.refundedEnded': 'Subscription refunded. Plan ended. Choose a plan to continue.',
  'acct.plan.addOneOff': 'Add one-off pack',
  'acct.plan.afterTrial': 'After trial',
  'acct.plan.bonusCredits': 'pack credits',
  'acct.plan.bonusCreditsTip':
    'Paid credits from one-off packs, added on top of this month\u2019s allowance and never expire.',
  'acct.plan.dayLeft': '1 day left to try for free, then your subscription starts automatically.',
  'acct.plan.daysLeft':
    '{n} days left to try for free, then your subscription starts automatically.',
  'acct.plan.endsToday': 'Trial ends today. Your subscription starts automatically.',
  'acct.plan.leftOf': 'of {total} left',
  'acct.plan.monthUsage': 'Leads this month',
  'acct.plan.nextBill': 'Next billing on {date} · {leads} leads/month',
  'acct.plan.cancelsOn': 'Cancels {date}',
  'acct.plan.cancelNote': 'No further charges, active until {date}.',
  'acct.plan.perMonth': '/ month',
  'acct.plan.secureSub': 'Start subscription',
  'acct.plan.switch': 'Switch plan',
  'acct.plan.downgradeScheduled': 'Plan change scheduled',
  'acct.plan.downgradeScheduledDetail':
    "You'll move to {plan} on {date}. You keep your current plan until then, and your credits stay.",
  'acct.plan.downgradeCancel': 'Cancel plan change',
  'acct.plan.downgradeCanceling': 'Canceling …',
  'acct.plan.trial': 'Trial',
  'acct.plan.trialCredits': 'trial credits',
  'acct.plan.trialCreditsTip':
    'Free signup credits from your trial offer, added on top of this month\u2019s allowance and never expire.',
  // LEA-704: surplus of a migrated account = the balance carried over, not trial credits.
  'acct.plan.carriedOverCredits': 'carried-over credits',
  'acct.plan.carriedOverCreditsTip':
    'Your balance from before the switch to pay-per-contact, on top of this month\u2019s allowance and never expires.',
  'acct.plan.trialUsage': 'Trial leads this phase',
  'acct.plan.usedThisMonth': '{used} / {total} used this month · resets {date}',

  // LEA-333: inline cancellation + churn feedback (config-driven, §312k).
  // LEA-555 — trial intercept.
  // LEA-557 — retention discount (30% x 3 Monate).
  // LEA-560 — Win-back-Banner.
  'acct.winback.title': 'Your welcome-back offer',
  'acct.winback.body':
    '{plan} at 30% off for 3 months. The checkout shows price and charge date before anything happens.',
  'acct.winback.cta': 'Go to checkout',
  'acct.winback.starting': 'Opening …',

  // LEA-524 — Pausendauer + Wiederaufnahme-Datum.
  'acct.cancel.save.offerTitle': 'Before you cancel — maybe one of these fits better',
  'acct.cancel.save.offerSub': 'No pressure. Cancelling stays one click away.',
  'acct.cancel.pauseMonthsLabel': 'Pause for',
  'acct.cancel.pauseMonths1': '1 month',
  'acct.cancel.pauseMonths': '{n} months',
  'acct.cancel.pauseResumeHint':
    'Your subscription resumes automatically on {date} — billing restarts then.',
  'acct.cancel.pausedDetailUntil':
    'Nothing is being charged. You keep access and your remaining credits. Your subscription resumes automatically on {date}; you can resume earlier any time.',
  'acct.cancel.pausedNoteUntil': 'Paused until {date}, no charges. Your credits stay usable.',

  'acct.cancel.save.discountTitle': '30% off for the next 3 months',
  'acct.cancel.save.discountBody':
    'Stay on and pay 30% less for three months — the discount sits directly on your subscription, your card stays as it is, no new checkout.',
  'acct.cancel.save.discountCta': 'Activate 30% discount',
  'acct.cancel.save.discounting': 'Activating …',
  'acct.cancel.save.discountDoneTitle': 'Discount is active',
  'acct.cancel.save.discountDoneBody':
    'Your next three monthly invoices are reduced by 30%. After that your plan continues at the normal price — you can still cancel any time with one click.',

  'acct.cancel.trial.interceptTitle': 'Hold on — your trial runs until {date}.',
  'acct.cancel.trial.interceptTitleNoDate': 'Hold on — your trial is still running.',
  'acct.cancel.trial.interceptSub': "You won't be charged before then.",
  'acct.cancel.trial.reminderTitle': "We'll remind you in time",
  'acct.cancel.trial.reminderBody':
    "Nothing to note down, nothing to remember. We'll email you 24 hours before it ends — and if you don't want to continue, you can cancel straight from that email.",
  'acct.cancel.trial.reminderPointMail': 'The cancel link is right there in the email.',
  'acct.cancel.trial.reminderPointNoCharge': 'Nothing is charged before then.',
  'acct.cancel.trial.reminderCta': 'Keep testing & remind me',
  'acct.cancel.trial.keepTestingCta': 'Keep testing',
  'acct.cancel.trial.reminderSaving': 'Activating …',
  'acct.cancel.trial.reminderDoneTitle': 'Reminder is on',
  'acct.cancel.trial.reminderDoneBody':
    "We'll email you on {date} — 24 hours before your trial ends, with the cancel link right in the email.",
  'acct.cancel.trial.reminderDoneBodyNoDate':
    "We'll email you 24 hours before your trial ends, with the cancel link right in the email.",
  // LEA-558 (Janik 04.09.): 990 € ist VERGLEICHSGROESSE ('im Gegenwert
  // von'), nie 'regulaer' — es gibt keinen kaufbaren 990-€-SKU, und die
  // Copy darf keinen erfinden.
  'acct.cancel.trial.vipTitle': 'Janik sets up your account personally',
  'acct.cancel.trial.vipBody':
    'Target groups, search profiles, first searches — the founder sets up your account with you personally. A service worth €990 — free for you if you keep testing.',
  'acct.cancel.trial.vipCta': 'Request personal setup',
  'acct.cancel.trial.vipRequesting': 'Requesting …',
  'acct.cancel.trial.vipDoneTitle': 'Request sent',
  'acct.cancel.trial.vipDoneBody':
    'Janik will get in touch personally within 24 hours. Your trial continues as normal — nothing was cancelled and nothing was charged.',
  'acct.cancel.trial.cancelNowLink': 'Cancel for good now',
  'acct.cancel.trial.confirm.endsNow':
    'Your trial access ends immediately — not on the expiry date.',
  'acct.cancel.trial.confirm.forfeits': 'Your search profiles and remaining credits are forfeited.',
  'acct.cancel.trial.confirm.noCharge': 'You will not be charged.',
  'acct.cancel.trial.done.title': 'Trial access ended',
  'acct.cancel.trial.done.body':
    'Your trial is over and you were not charged. If you change your mind, you can start a subscription any time.',

  'acct.cancel.trigger': 'Cancel subscription',
  'acct.cancel.manageHint': 'Manage subscription',
  'acct.cancel.scheduledTitle': 'Cancellation scheduled',
  'acct.cancel.scheduledDetail':
    'Your subscription ends on {date}. You keep full access until then.',
  'acct.cancel.reactivate': 'Undo cancellation',
  'acct.cancel.reactivating': 'Undoing …',
  'acct.cancel.restored': 'Subscription restored. Your plan continues.',
  'acct.cancel.title': 'Cancel subscription',
  'acct.cancel.stepOf': 'Step {n} of {total}',
  'acct.cancel.reasonTitle': 'Why are you cancelling?',
  'acct.cancel.reasonSub': 'Optional: your answer helps us make Leadscraper better.',
  'acct.cancel.reason.too_expensive': 'Too expensive',
  'acct.cancel.reason.too_few_leads': 'Too few (good) leads',
  'acct.cancel.reason.wrong_contacts': 'Wrong contacts',
  'acct.cancel.reason.unreliable_data': 'Unreliable emails/contact data',
  'acct.cancel.reason.too_complicated': 'Too complicated',
  'acct.cancel.reason.missing_feature': 'A feature is missing',
  'acct.cancel.reason.temporary_only': 'Only needed temporarily',
  'acct.cancel.reason.switched_tool': 'Switching to another tool',
  'acct.cancel.reason.other': 'Other',
  'acct.cancel.freeTextPlaceholder': 'Tell us more (optional) …',
  'acct.cancel.save.downgradeTitle': 'Maybe a smaller plan fits?',
  'acct.cancel.save.downgradeBody':
    'Instead of cancelling, you can switch to a cheaper plan: you keep your credits and pay less from the next cycle.',
  'acct.cancel.save.downgradeCta': 'See cheaper plans',
  // LEA-333 Phase 5: inline downgrade offer (concrete next-lower plan).
  'acct.cancel.save.downgradeOffer':
    'Switch to {plan}: €{price}/mo · {leads} leads/month. You keep your credits and pay less from the next cycle.',
  'acct.cancel.save.downgradeCtaPlan': 'Switch to {plan}',
  'acct.cancel.save.downgrading': 'Switching …',
  'acct.cancel.save.seeAllPlans': 'See all plans',
  'acct.cancel.save.helpTitle': "Let's make it right",
  'acct.cancel.save.helpBody':
    "We're actively improving a lot of this. Tell us what was missing: we can often re-tune your search quickly.",
  'acct.cancel.confirm.accessUntil': 'You keep full access until {date}.',
  'acct.cancel.confirm.noCharge': "You won't be charged again after that.",
  'acct.cancel.confirm.reactivate': 'You can undo the cancellation any time before then.',
  'acct.cancel.audit.title': 'One last thing (optional)',
  'acct.cancel.audit.sub': "What worked, what didn't? It feeds directly into improvements.",
  'acct.cancel.audit.rightCompanies': 'The right companies?',
  'acct.cancel.audit.rightContacts': 'The right contacts?',
  'acct.cancel.audit.contactDataUsable': 'Email/phone/LinkedIn usable?',
  'acct.cancel.audit.enoughLeads': 'Enough leads?',
  'acct.cancel.audit.helpedWin': 'Did it help you win customers?',
  'acct.cancel.audit.good': 'Good',
  'acct.cancel.audit.bad': 'Poor',
  // LEA-333 Phase 7: "which lead disappointed you?" picker (crown jewel).
  'acct.cancel.lead.title': 'Which lead disappointed you? (optional)',
  'acct.cancel.lead.sub': 'If one specific lead was off, naming it helps us the most.',
  'acct.cancel.lead.pick': 'Pick a lead',
  'acct.cancel.lead.loading': 'Loading …',
  'acct.cancel.lead.none': 'No delivered leads found.',
  // LEA-333: counterfactual + competitive (point C) — last, optional.
  'acct.cancel.cf.title': 'Help us do better (optional)',
  'acct.cancel.cf.gapPlaceholder': "What did you need that we couldn't deliver?",
  'acct.cancel.cf.toolPlaceholder': 'Switching to another tool? Which one?',
  'acct.cancel.cf.betterPlaceholder': 'What does it do better?',
  'acct.cancel.justCancel': 'Cancel now',
  'acct.cancel.keep': 'Keep it',
  'acct.cancel.next': 'Continue',
  'acct.cancel.back': 'Back',
  'acct.cancel.stillCancel': 'Cancel anyway',
  'acct.cancel.confirmBtn': 'Confirm cancellation',
  'acct.cancel.confirming': 'Cancelling …',
  'acct.cancel.done.title': 'Cancellation confirmed',
  'acct.cancel.done.body':
    'Your subscription ends on {date}. You keep full access until then, and you can undo the cancellation any time before that.',
  'acct.cancel.done.close': 'Close',
  // LEA-333 Phase 4: pause as a save lever + standalone action.
  'acct.cancel.save.pauseTitle': 'Pause instead of cancelling?',
  'acct.cancel.save.pauseBody':
    'Freeze your subscription instead of cancelling: no charges, your credits and data stay, and you can resume any time with one click.',
  'acct.cancel.save.pauseCta': 'Pause subscription',
  'acct.cancel.save.pausing': 'Pausing …',
  'acct.cancel.pauseTrigger': 'Pause',
  'acct.cancel.pausing': 'Pausing …',
  'acct.cancel.pausedBadge': 'Paused',
  'acct.cancel.pausedNote': 'Subscription paused: no charges. Your credits stay usable.',
  'acct.cancel.pausedTitle': 'Subscription paused',
  'acct.cancel.pausedDetail':
    'Nothing is being charged. You keep access and your remaining credits. Resume any time.',
  'acct.cancel.resume': 'Resume subscription',
  'acct.cancel.resuming': 'Resuming …',
  'acct.plan.your': 'Your plan',
  'acct.prof.avatarErr': 'Could not upload image. Please try again.',
  'acct.prof.avatarMime': 'Please choose a JPG, PNG, or WebP file.',
  'acct.prof.avatarSize': 'File too large (max 2 MB).',
  'acct.prof.avatarUpdated': 'Profile photo updated.',
  'acct.prof.email': 'Email address',
  'acct.prof.first': 'First name',
  'acct.prof.lang': 'Language',
  'acct.prof.last': 'Last name',
  'acct.prof.save': 'Save',
  'acct.prof.title': 'Profile Information',
  'acct.prof.upload': 'Upload image',
  'acct.prof.uploadHint': 'JPG, PNG or WebP. Max. 2 MB.',
  'acct.pw.changing': 'Changing …',
  'acct.pw.complexity':
    'New password must be at least 8 characters and include upper- and lowercase letters, a digit and a special character (@$!%*?&).',
  'acct.pw.confirm': 'Confirm new password',
  'acct.pw.cta': 'Change password',
  'acct.pw.current': 'Current password',
  'acct.pw.failed': 'Could not change password.',
  'acct.pw.minErr': 'At least 8 characters.',
  'acct.pw.minHint': 'At least 8 characters',
  'acct.pw.mismatch': 'Passwords don\u2019t match.',
  'acct.pw.new': 'New password',
  'acct.pw.sameAsCurrent': 'New password must be different from the current one.',
  'acct.pw.success': 'Password changed \u2713',
  'acct.pw.title': 'Change password',
  'acct.pw.wrongCurrent': 'Current password is incorrect.',
  'acct.sec.active': 'Active',
  'acct.sec.change': 'Change',
  'acct.sec.inactive': 'Inactive',
  'acct.sec.pw': 'Change password',
  'acct.sec.pwSub': 'Change your account password here',
  'acct.sec.title': 'Security settings',
  'acct.sec.twofa': 'Two-factor authentication',
  'acct.sec.twofaActivate': 'Enable 2FA',
  'acct.sec.twofaDeactivate': 'Disable 2FA',
  'acct.sec.twofaSoon':
    'Authenticator-based two-factor login is not wired here yet: the old control only toggled locally. Real 2FA enrollment is coming next.',
  'acct.sec.twofaSub':
    'Authentication is disabled. Enable it to add an extra layer of security to your account.',
  'acct.sub':
    'Manage profile settings, change payment methods and download invoices for past transactions.',
  'acct.tab.billing': 'Billing',
  'acct.tab.integrations': 'Integrations',
  'acct.tab.profile': 'Profile',
  'acct.founder.title': 'A direct line to the founder',
  'acct.founder.body':
    'Feedback, a question, a problem? Your message goes straight to Janik, not into a ticket system.',
  'acct.founder.cta': 'Message Janik',
  'acct.title': 'Profile',
  'acct.toast.failed': 'Could not save. Please try again.',
  'acct.toast.saved': 'Profile saved.',

  'ai.collapse': 'Collapse',
  'ai.cortex': 'Leadscraper',
  'ai.dismiss': 'Hide',
  'ai.errorReply':
    "I can't reach my data right now. Try again in a second, or phrase the question more briefly.",
  'ai.footer': 'Leadscraper only knows your audiences and feedback: no external data.',
  'ai.greeting':
    'Hey 👋 I\'m your Leadscraper assistant. I see your active profile "{profile}" and every pattern the system has learned. What\'s on your mind?',
  'ai.inputP': 'Ask the assistant something …',
  'ai.ins.edge.cta': 'Open lead',
  'ai.ins.edge.fallback': 'Leadscraper is unsure here. Your verdict helps sharpen the pattern.',
  'ai.ins.edge.title': 'Edge case: {company}',
  'ai.ins.pattern.cta': 'Review pattern',
  'ai.ins.pattern.title': 'New pattern in "{profile}"',
  'ai.ins.tune.body':
    'Match rate is {rate} %. I can help you frame the next search run more precisely.',
  'ai.ins.tune.cta': 'Sharpen search',
  'ai.ins.tune.title': '"{profile}" is still training',
  'ai.intro':
    'I watch your profiles 24/7 and help you write sharper search runs and cleaner learning signals.',
  'ai.langHint':
    'Respond in English. Max 3-4 short sentences per answer, except for concrete instructions.',
  'ai.moreN': '+{n} more',
  'ai.now': 'now',
  'ai.onlinePrefix': 'Online · knows your {n} audiences',
  'ai.openChat': 'Open chat',
  'ai.quickStart': 'Quick start',
  'ai.seedRefine': 'Suggest a refined search for my audience "{profile}".',
  'ai.send': 'Send',
  'ai.sp1.label': 'Where does my active audience stand?',
  'ai.sp1.prompt':
    "Summarize in 3 sentences how well Leadscraper already understands my active profile: what has it learned, what hasn't it?",
  'ai.sp2.label': 'Which patterns should I confirm?',
  'ai.sp2.prompt':
    'Which learned patterns should I confirm or reject next so the system learns faster?',
  'ai.sp3.label': 'Suggest a search run',
  'ai.sp3.prompt':
    'Based on my active profile, suggest a precise next search run, with industry, location, size and extras.',
  'ai.sp4.label': 'Where am I losing quality?',
  'ai.sp4.prompt':
    'Where across my profiles do you see potential for higher match rates? What should I adjust?',
  'ai.tag.confirmed': 'confirmed',
  'ai.tag.uncertain': 'uncertain',
  'ai.tag.unconfirmed': 'unconfirmed',
  'ai.thinkingAbout': "What I'm thinking about",

  'api.confidence.cautiously_optimistic': 'cautiously optimistic',
  'api.confidence.fairly_sure': 'fairly sure',
  'api.confidence.uncertain': 'uncertain',
  'api.confidence.very_sure': 'very sure',

  'apierr.intentParseTimeout': "Our AI took too long to read your description — please try again in a moment.",

  'auth.login.docTitle': 'Sign in · Leadscraper',
  'auth.login.email': 'Email',
  'auth.login.errCredentials': 'Email or password is incorrect.',
  'auth.login.errEmail': 'Invalid email address.',
  'auth.login.errEmpty': 'Please fill in all fields.',
  'auth.login.errGeneric': 'Login failed. Please try again.',
  'auth.login.errUnverified': 'Please confirm your email address first.',
  'auth.login.forgot': 'Forgot password?',
  'auth.login.google': 'Sign in with Google',
  'auth.login.googleBusy': 'Signing in with Google …',
  'auth.login.hidePassword': 'Hide password',
  'auth.login.microsoft': 'Sign in with Microsoft',
  'auth.login.microsoftBusy': 'Signing in with Microsoft …',
  'auth.login.noAccount': 'No account yet?',
  'auth.login.or': 'Or',
  'auth.login.password': 'Password',
  'auth.login.remember': 'Stay logged in',
  'auth.login.showPassword': 'Show password',
  'auth.login.signUp': 'Sign up',
  'auth.login.sub': 'Sign in to your account to access your dashboard.',
  'auth.login.submit': 'Sign in',
  'auth.login.submitting': 'Signing in …',
  'auth.login.title': 'Welcome back',
  'auth.register.docTitle': 'Sign up · Leadscraper',
  'auth.register.email': 'Email',
  'auth.register.errEmail': 'Invalid email address.',
  'auth.register.errEmpty': 'Please fill in all fields.',
  'auth.register.errBotCheck': 'Please complete the bot check.',
  'auth.register.errPwMismatch': 'Passwords do not match.',
  'auth.register.errPwShort': 'Password must be at least 8 characters long.',
  'auth.register.firstName': 'First name',
  'auth.register.google': 'Sign up with Google',
  'auth.register.googleBusy': 'Signing up with Google …',
  'auth.register.haveAccount': 'Already have an account?',
  'auth.register.hidePassword': 'Hide password',
  'auth.register.lastName': 'Last name',
  'auth.register.microsoft': 'Sign up with Microsoft',
  'auth.register.microsoftBusy': 'Signing up with Microsoft …',
  'auth.register.or': 'Or',
  'auth.register.password': 'Password',
  'auth.register.passwordConfirm': 'Confirm password',
  'auth.register.showPassword': 'Show password',
  'auth.register.signIn': 'Sign in',
  'auth.register.sub': 'See how easy it is to generate precise lead lists with AI agents today.',
  'auth.register.submit': 'Create account',
  'auth.register.submitting': 'Creating …',
  'auth.register.title': 'Create free account',
  'auth.reset.backToLogin': 'Back to sign in',
  'auth.reset.confirmLabel': 'Confirm password*',
  'auth.reset.confirmPlaceholder': 'Enter password again',
  'auth.reset.docTitle': 'Reset password · Leadscraper',
  'auth.reset.doneSub': 'You can now sign in with your new password.',
  'auth.reset.doneTitle': 'Password successfully changed',
  'auth.reset.emailLabel': 'Email*',
  'auth.reset.emailPlaceholder': 'Enter your email address',
  'auth.reset.errInvalidEmail': 'Please enter a valid email address.',
  'auth.reset.errPwMismatch': 'Passwords do not match.',
  'auth.reset.errPwShort': 'Password must be at least 8 characters long.',
  'auth.reset.errPwWeak':
    'The password must include upper and lower case letters, a number and a special character.',
  'auth.reset.pwRules':
    'At least 8 characters, with upper and lower case letters, a number and a special character.',
  'auth.reset.errRequest': 'Request failed. Please try again.',
  'auth.reset.goToLogin': 'Go to sign in',
  'auth.reset.haveAccount': 'Already have an account?',
  'auth.reset.hidePassword': 'Hide password',
  'auth.reset.invalidSub': 'This password reset link is no longer valid. Please request a new one.',
  'auth.reset.invalidTitle': 'Link invalid or expired',
  'auth.reset.newPwLabel': 'New password*',
  'auth.reset.newPwPlaceholder': 'At least 8 characters',
  'auth.reset.newPwSub': 'Choose a new password for your account.',
  'auth.reset.newPwTitle': 'Set new password',
  'auth.reset.requestNew': 'Request new link',
  'auth.reset.oauthTitle': 'This account uses {provider} sign-in',
  'auth.reset.oauthSub':
    'There is no password set for this account. Please sign in with {provider} instead.',
  'auth.reset.resetBtn': 'Reset password',
  'auth.reset.saving': 'Saving …',
  'auth.reset.send': 'Send link',
  'auth.reset.sending': 'Sending …',
  'auth.reset.sentSub':
    'If an account with this email exists, we have sent you a reset link. Check your inbox (and spam folder).',
  'auth.reset.sentTitle': 'Email sent',
  'auth.reset.showPassword': 'Show password',
  'auth.reset.signIn': 'Sign in',
  'auth.reset.sub': 'Enter your email address and we will send you a link to reset your password.',
  'auth.reset.title': 'Reset password',
  'auth.shell.nextSlide': 'Next slide',
  // LEA-285: auth slide carousel — mirrors apps/auth/src/lib/i18n.ts.
  // Source copy from Janik's standalone HTML design.
  'auth.slides.1.headline':
    'AI agents find B2B companies that match your exact target customer profile.',
  'auth.slides.2.headline':
    'Every lead list is generated fresh from public sources: no outdated or resold data.',
  'auth.slides.3.headline':
    'Each lead includes relevant decision-makers, source links and a clear reason why it fits.',
  'auth.slides.aria.region': 'Product highlights',
  'auth.slides.aria.slide': 'Slide {n} of {total}',
  'auth.slides.aria.goTo': 'Go to slide {n}',

  // --- Login + Registrierung, Revision 19 (Janik 17.09.2026) ---
  // Uebersetzung; das deutsche Original ist die Referenz.
  'auth.r19.skip': 'Skip to content',
  'auth.r19.header.haveAccount': 'Already a user?',
  'auth.r19.hero.titleLead': 'Find the',
  'auth.r19.hero.titleGrad': 'customers',
  'auth.r19.hero.titleTail': 'your offer is made for.',
  'auth.r19.hero.lead':
    'Describe who you want to reach. Leadscraper finds matching companies, researches contacts and shows you where to start the conversation.',
  'auth.r19.demo.caption': 'Your research. Step by step.',
  'auth.r19.demo.play': 'Play walkthrough',
  'auth.r19.form.title': 'Get started with Leadscraper.',
  'auth.r19.form.google': 'With Google',
  'auth.r19.form.microsoft': 'With Microsoft',
  'auth.r19.form.separator': 'or with your email',
  'auth.r19.form.businessEmail': 'Business email',
  'auth.r19.form.emailPlaceholder': 'you@company.com',
  'auth.r19.form.show': 'Show',
  'auth.r19.form.hide': 'Hide',
  'auth.r19.legal.accept':
    'By signing up, you accept our {terms}. You can find information about your data in our {privacy}.',
  'auth.r19.legal.privacyLink': 'privacy policy',
  'auth.r19.proof.founderTitle': 'Personally supported by the founder.',
  'auth.r19.proof.founderBody': 'Janik is your direct point of contact.',
  'auth.r19.confidence.eyebrow': 'Before your first conversation',
  'auth.r19.confidence.title1': 'You know who you are contacting.',
  'auth.r19.confidence.title2': 'And why.',
  'auth.r19.confidence.p1.title': 'Sources are included.',
  'auth.r19.confidence.p1.body':
    'You see what the research is based on and can check the details yourself.',
  'auth.r19.confidence.p2.title': 'Gaps stay visible.',
  'auth.r19.confidence.p2.body':
    'If a detail is missing, you can see it. You decide how to research further.',
  'auth.r19.confidence.p3.title': 'You get an angle.',
  'auth.r19.confidence.p3.body':
    'Company insight helps you prepare your first contact around a concrete reason to reach out.',
  'auth.r19.founder.eyebrow': 'Personally at your side',
  'auth.r19.founder.role': 'Founder of Leadscraper',
  'auth.r19.founder.photoAlt': 'Janik Deimann, founder of Leadscraper',
  'auth.r19.founder.body':
    'I personally help you with your search and your questions about Leadscraper.',
  'auth.r19.founder.contact': 'Ask in chat',
  'auth.r19.footer.copyright': '© Leadscraper · Deimann Com GmbH',
  'auth.r19.footer.privacy': 'Privacy',
  'auth.r19.footer.imprint': 'Legal notice',
  // Geprueft 17.09.2026: HTTP 200.
  'auth.r19.footer.imprintUrl': 'https://www.leadscraper.de/en/legal-notice',
  'auth.r19.footer.navLabel': 'Legal',
  'auth.verify.defaultError': 'An error occurred.',
  // Auth — Set Password (LEA-527)
  'auth.setPw.docTitle': 'Set your password · Leadscraper',
  'auth.setPw.loading': 'One moment …',
  'auth.setPw.greeting': 'Welcome, {name}!',
  'auth.setPw.title': 'Your account is ready',
  'auth.setPw.sub':
    'Set your password to get started — your leads are already waiting inside your account.',
  'auth.setPw.pwLabel': 'Password*',
  'auth.setPw.pwPlaceholder': 'At least 8 characters',
  'auth.setPw.confirmLabel': 'Confirm password*',
  'auth.setPw.confirmPlaceholder': 'Re-enter password',
  'auth.setPw.submit': 'Set password & start',
  'auth.setPw.saving': 'Setting up your account …',
  'auth.setPw.errPwShort': 'Password must be at least 8 characters.',
  'auth.setPw.errPwWeak':
    'The password must include upper and lower case letters, a number and a special character.',
  'auth.setPw.pwRules':
    'At least 8 characters, with upper and lower case letters, a number and a special character.',
  'auth.setPw.errPwMismatch': 'Passwords do not match.',
  'auth.setPw.errGeneric': 'Something went wrong. Please try again.',
  'auth.setPw.doneTitle': "You're all set!",
  'auth.setPw.doneSub': 'Taking you to your account …',
  'auth.setPw.invalidTitle': 'Link invalid or expired',
  'auth.setPw.invalidSub':
    'This setup link is no longer valid. Please reach out to your Leadscraper contact.',
  'auth.setPw.backToLogin': 'Go to sign in',
  'auth.setPw.resend': 'Send me a new link',
  'auth.setPw.resending': 'Sending …',
  'auth.setPw.resentTitle': 'New link sent',
  'auth.setPw.resentSub': "We've emailed a fresh link to your inbox — it's valid for 14 days.",
  'auth.setPw.resendErr': "Couldn't send. Please try again.",

  'auth.verify.docTitle': 'Verify email · Leadscraper',
  'auth.verify.error': 'Verification failed',
  'auth.verify.goToDashboard': 'Go to dashboard now',
  'auth.verify.noToken': 'Verification link missing',
  'auth.verify.noTokenSub':
    "Click the link in the email we sent you. If you didn't receive one, you can request a new one.",
  'auth.verify.resendError': 'Request new verification email',
  'auth.verify.resendFailed': 'Email could not be resent.',
  'auth.verify.resendNoToken': 'Resend verification email',
  'auth.verify.resending': 'Sending …',
  'auth.verify.resent': 'Email resent ✓',
  'auth.verify.success': 'Success!',
  'auth.verify.successSub': 'Your email has been verified. Redirecting to dashboard …',
  'auth.verify.title': 'Verify email',
  'auth.verify.toLogin': 'Go to sign in',
  'auth.verify.verifying': 'Verifying email …',
  'auth.verify.verifyingSub': 'One moment please.',

  'bill.ret.cancelBody': 'Nothing was charged. You can restart checkout any time.',
  'bill.ret.cancelCta': 'Back to dashboard',
  'bill.ret.cancelTitle': 'Cancelled',
  'bill.ret.cta': 'Go to dashboard',
  'bill.ret.docTitleCancel': 'Cancelled · Leadscraper',
  'bill.ret.docTitleSuccess': 'Payment successful · Leadscraper',
  'bill.ret.errorBody':
    'Your payment may have succeeded. We could not load the status right now. Please check your account under "Billing".',
  'bill.ret.errorTitle': 'Status unavailable',
  'bill.ret.rowCredits': 'Credits',
  'bill.ret.rowCreditsAvail': '{n} available',
  'bill.ret.rowNextRenewal': 'Next billing',
  'bill.ret.rowPlan': 'Plan',
  'bill.ret.seedCta': 'Go to my leads',
  'bill.ret.seedDone': "All {delivered} leads are in. Let's go.",
  'bill.ret.seedPartial':
    '{delivered} leads are in. The rest of your credits stays available for your own searches.',
  'bill.ret.seedWorking':
    '{delivered} of {total} leads are done, the rest is being enriched right now. The whole delivery takes 10 to 30 minutes.',
  'bill.ret.seedWorkingCreated':
    'Your {created} leads are created. Researching the contacts takes 10 to 30 minutes. Best to export once they are all in.',
  'bill.ret.seedWorkingZero':
    'Your leads are being created right now. Researching the contacts takes 10 to 30 minutes. Best to export once they are all in.',
  'bill.ret.successBodyCredits': 'Your credits have been added.',
  'bill.ret.successBodySub': 'Your subscription is active. You now have access to your leads.',
  'bill.ret.successTitle': 'Payment successful',
  'bill.ret.verifying': 'Processing payment …',
  'bill.ret.verifyingSub': "We're updating your account. This only takes a moment.",

  'billing.disabled': 'Payments are currently unavailable. Please try again later.',
  'billing.errorClose': 'Close',
  'billing.errorRetry': 'Try again',
  'billing.errorTitle': 'Something went wrong',
  'billing.transientError': 'Temporarily unavailable. Please try again in a moment.',
  'billing.portalNoCustomer':
    'Subscription management is only available after your first purchase.',
  'billing.trialStarted': 'Welcome to the {plan} plan: trial is active.',
  'billing.downgradeScheduled':
    "Plan change scheduled: you'll move to {plan} on {date}. Your credits stay.",
  'billing.downgradeAlready': 'A change to {plan} is already scheduled for {date}.',
  // LEA-546: der Tarifwechsel wurde serverseitig abgelehnt, weil das Abo
  // gerade nicht änderbar ist (Kündigung vorgemerkt bzw. Zahlung offen).
  'billing.reactivateFirst':
    'Your subscription is scheduled to end. Reactivate it first, then you can change plan.',
  'billing.manageInPortal':
    "This subscription can't be changed right now. Open the billing portal to sort out the payment first.",
  'billing.unknownError': 'Unknown billing error.',
  'billing.alreadySubscribed': 'You already have this subscription. Your current plan is under Billing.',

  'boot.connectionError': 'Connection error',
  'boot.connectionErrorDesc': 'Could not connect to the server: {msg}',
  'boot.retry': 'Try again',
  'boot.reconnecting': 'Reconnecting… (attempt {n})',

  'common.cancel': 'Cancel',
  'common.collapse': 'Collapse',
  'common.edit': 'Edit',
  'common.hide': 'Hide',
  'common.loading': 'Loading …',
  'common.month.apr': 'April',
  'common.month.aug': 'August',
  'common.month.dec': 'December',
  'common.month.feb': 'February',
  'common.month.jan': 'January',
  'common.month.jul': 'July',
  'common.month.jun': 'June',
  'common.month.mar': 'March',
  'common.month.may': 'May',
  'common.month.nov': 'November',
  'common.month.oct': 'October',
  'common.month.sep': 'September',
  'common.refresh': 'Refresh',
  'common.save': 'Save',
  'common.saving': 'Saving …',

  'cortex.activeSince': 'Audience active since',
  'cortex.confirm': 'Confirm',
  'cortex.confirmed': 'confirmed by you',
  'cortex.correct': 'Correct',
  'cortex.ctaRate': 'Rate your first leads',
  'cortex.feedbacks': 'Ratings',
  'cortex.fits': 'Fit',
  'cortex.fitsNot': 'Not a fit',
  'cortex.footer':
    'If you correct or forget a statement, it will no longer be used to rank your leads.',
  'cortex.forget': 'Forget',
  'cortex.hero': 'This is what Leadscraper learned from your {n} ratings.',
  'cortex.heroEmpty':
    'Empty for now. Leadscraper starts learning as soon as you rate the first leads.',
  'cortex.heroEmptySub':
    "Leadscraper is your profile's memory: what you prefer, what you reject, and where the system is still unsure.",
  'cortex.heroSub':
    'You can confirm, correct, or forget any statement. Changes take effect on the next ranking pass.',
  'cortex.learned': 'What Leadscraper learned',
  'cortex.matchRate': 'Match rate',
  'cortex.medium': 'medium',
  'cortex.mediumNote': 'still observing',
  'cortex.patterns': 'Learned patterns',
  'cortex.patternsPending': 'Awaiting your confirmation',
  'cortex.perWeek': 'per week',
  'cortex.plain': "In plain words: the way you'd read it.",
  'cortex.roi.avgOrder': 'Avg. order value',
  'cortex.roi.disclaimer':
    'Estimate: based on your current match rate. The more the cortex learns, the more realistic the numbers.',
  'cortex.roi.expectedFits': 'Expected fit leads',
  'cortex.roi.leads': 'Leads',
  'cortex.roi.newCustomers': 'New customers',
  'cortex.roi.revenue': 'Projected revenue',
  'cortex.roi.revenueSub': 'at current state',
  'cortex.roi.sub': 'What your current state could be worth.',
  'cortex.roi.title': 'ROI estimate',
  'cortex.roi.viaRate': 'Ø match rate',
  'cortex.roi.winLabel': 'win rate',
  'cortex.roi.winRate': 'Win rate',
  'cortex.runs.col.action': 'Action',
  'cortex.runs.col.date': 'Date',
  'cortex.runs.col.leads': 'Leads',
  'cortex.runs.col.matchrate': 'Match rate',
  'cortex.runs.col.params': 'Search parameters',
  'cortex.runs.count': 'runs',
  'cortex.runs.repeat': 'Repeat',
  'cortex.runs.sub': 'All queries you have started for this audience.',
  'cortex.runs.title': 'Search runs',
  'cortex.sinceStart': 'since start',
  'cortex.step': 'Step',
  'cortex.step1': 'Open leads',
  'cortex.step1d': 'Browse the first cards in your list.',
  'cortex.step2': "Fit / Doesn't fit",
  'cortex.step2d': 'Rate each lead. When rejecting, pick a short reason.',
  'cortex.step3': 'Read it here',
  'cortex.step3d': 'After ~20 ratings, the first plain-text insights appear here.',
  'cortex.strong': 'strong',
  'cortex.strongNote': 'reliable patterns',
  'cortex.tierMedium': 'Medium',
  'cortex.tierStrong': 'Strong',
  'cortex.tierWeak': 'Weak',
  'cortex.title': 'My profile',
  'cortex.uncertain': 'Leadscraper is unsure here',
  'cortex.weak': 'weak',
  'cortex.weakNote': 'Leadscraper is unsure here',

  'crm.bald': 'SOON',
  'crm.comingSoon': 'Coming soon',
  'crm.customAgent': 'Your own agent',
  'crm.history.duplicate': 'Already in CRM',
  'crm.history.empty': 'No pushes yet. Use "Push to CRM" on a lead to get started.',
  'crm.history.failed': 'Failed',
  'crm.history.loading': 'Loading…',
  'crm.history.sent': 'Sent',
  'crm.picker.title': 'Push to which CRM?',
  'crm.picker.subtitle': 'Choose where this lead should land. You can switch any time.',
  'crm.history.sub': 'Last 50 leads pushed to your CRM, most recent first.',
  'crm.history.title': 'Push history',
  'crm.mcpComingSoon': 'Available once the MCP server goes live.',
  'crm.mcpSub':
    'Connect Leadscraper directly to Claude, ChatGPT, Cursor or your own agent via Model Context Protocol. Your leads, profiles and memory become natively available as tools.',
  'crm.mcpTitle': 'Leadscraper as MCP server',
  'crm.preview.bulkBody':
    'Will create {n} Organization records (and Persons for leads with contact info). Duplicates already in your CRM will be skipped. You keep your existing records.',
  'crm.preview.bulkSub': '{n} leads will be pushed to your CRM',
  'crm.preview.dedupNote':
    'If this lead is already in your CRM (matched by domain), the push is recorded but no new record is created. You keep what you have.',
  'crm.preview.noContact': 'Org only',
  'crm.preview.plusMore': '+ {n} more …',
  'crm.preview.pushBtn': 'Push now',
  'crm.preview.pushNBtn': 'Push {n} now',
  'crm.preview.pushing': 'Pushing…',
  'crm.preview.singleSub': 'This is what will be created in your CRM',
  'crm.preview.skipPerson': ', skipped (no email or phone on this lead)',
  'crm.preview.title': 'Preview push to {crm}',
  'crm.preview.willCreate': 'Will create',
  'crm.preview.willCreatePerson': ', primary contact with email/phone',
  'crm.preview.withContact': 'Org + Person',
  'crm.section.available': 'Available',
  'crm.section.comingNext': 'Coming next',
  'crm.section.comingNextLabel': 'Soon',
  'crm.section.connected': 'Connected',
  'crm.section.morePlanned': 'More integrations planned',
  'crm.tooltipComingSoon':
    '{name} integration is coming soon. You\u2019ll be notified once it\u2019s available.',

  'dash.actNow': 'Open',
  'dash.action': 'Action',
  'dash.activeRuns.run': 'run',
  'dash.activeRuns.runs': 'runs',
  'dash.activeRuns.title': 'Leadscraper is working for you',
  'dash.avgOrder': 'Avg. order size',
  'dash.cadence.daily': 'daily',
  'dash.cadence.hourly': 'hourly',
  'dash.cadence.manual': 'manually',
  'dash.cadence.monthly': 'monthly',
  'dash.cadence.weekly': 'weekly',
  'dash.close': 'Close',
  'dash.col.lastRun': 'Last run',
  'dash.col.leads': 'Leads',
  'dash.col.matchrate': 'Match rate',
  'dash.col.profile': 'Audience',
  'dash.col.profileH': 'Audience',
  'dash.col.query': 'Audience',
  'dash.col.queryName': 'Query',
  'dash.col.statusH': 'Status',
  'dash.col.trained': 'Trained',
  'dash.col.whenH': 'When',
  'dash.company.analyzeBtn': 'Analyze',
  'dash.company.analyzeFresh': '✨ Teach Leadscraper',
  'dash.company.analyzing': 'Leadscraper is reading…',
  'dash.company.cachedToast': 'Profile loaded from cache.',
  'dash.company.collapsed':
    'Leadscraper knows your company: all justifications are tailored to you.',
  'dash.company.doneToast': '✓ Leadscraper knows you now.',
  'dash.company.editBody':
    'Enter your company website. Leadscraper reads it and permanently remembers what you offer, who you sell to, and what arguments you use, so every justification on your leads becomes a tailored pitch strategy instead of just "fits the industry".',
  'dash.company.editTitle': 'Help Leadscraper sharpen your pitches: tell us what you sell',
  'dash.company.emptyBody':
    'Enter your company website and Leadscraper understands what you sell in 10 seconds. From then on, every lead justification explains specifically why YOUR offering fits THIS lead, instead of just "fits the industry". That\'s the aha moment.',
  'dash.company.emptyTitle': "Leadscraper doesn't know you yet",
  'dash.company.errorFallback': 'Analysis failed. Please try again.',
  'dash.company.setupBadge': 'Setup required',
  'dash.company.stage1': 'Loading your website…',
  'dash.company.stage2': 'Understanding what you offer…',
  'dash.company.stage3': 'Identifying your target audience…',
  'dash.company.stage4': 'Connecting everything with your value…',
  'dash.company.stage5': 'Almost done…',
  'dash.company.urlHint': 'Enter your website. Once the URL is in, you can teach Leadscraper.',
  'dash.company.urlPlaceholder': 'https://my-company.com',
  'dash.cortex.reanalyze': 'Re-analyze: Leadscraper takes a fresh look at the site',
  'dash.cortex.reanalyzeKeepTitle': 'Keep your manual edits?',
  'dash.cortex.reanalyzeKeepBody':
    "You've manually edited this company profile. Re-analyzing can keep your edits and only refresh the rest, or reset everything to fresh AI suggestions.",
  'dash.cortex.reanalyzeKeepCta': 'Keep my edits',
  'dash.cortex.reanalyzeResetCta': 'Reset to AI suggestions',
  'dash.cortex.sells': 'What you sell',
  'dash.cortex.title': 'What Leadscraper knows about your company',
  'dash.cortex.toWhom': 'To whom',
  'dash.cortex.valueProps': 'Value props',
  'dash.date': 'Date',
  'dash.done': 'Done',
  'dash.empty.defineAudience': '+ Define your target audience now',
  'dash.empty.noFiltered': 'No queries in this filter.',
  'dash.empty.noProfile': 'No audience created yet.',
  'dash.empty.noQueryStartedAll': 'No lead query started across all audiences yet.',
  'dash.empty.noQueryStartedForProfile': 'No lead query started yet for "{profile}".',
  'dash.empty.showAll': 'Show all ({n})',
  'dash.empty.startHint': 'Click "Start search run" to define a query (industry, region, role, …).',
  'dash.filter.all': 'All',
  'dash.filter.oneshot': 'One-time',
  'dash.filter.running': 'Running',
  'dash.filter.scheduled': 'Scheduled',
  'dash.fmtNext.inDays': 'in {n}d',
  'dash.fmtNext.inH': 'in {n}h',
  'dash.fmtNext.inMin': 'in {n}m',
  'dash.fmtNext.soon': 'starts soon',
  'dash.fmtNext.tomorrow': 'tomorrow',
  'dash.funnel.deepened': 'Deepened',
  'dash.funnel.evaluated': 'Evaluated',
  'dash.funnel.identified': 'Identified',
  'dash.funnel.ready': 'Ready',
  'dash.inProgress': 'In progress',
  'dash.inbox.edge': 'Edge case',
  'dash.inbox.edges': 'Edge cases',
  'dash.inbox.hint': 'Note',
  'dash.inbox.leadsFrom': '{leads} leads from {profiles} {profileWord}',
  'dash.inbox.less': 'Show less',
  'dash.inbox.more': '+ {n} more',
  'dash.inbox.profileWord': 'audience',
  'dash.inbox.profilesWord': 'audiences',
  'dash.inbox.showAll': 'Show all {n}',
  'dash.inbox.title': 'To do today',
  'dash.lastQueries.subAll':
    'Your most recently started searches across all profiles. Click to open the details and repeat the search.',
  'dash.lastQueries.subForProfile':
    'Your most recently started searches for "{profile}". Click to open the details and repeat the search.',
  'dash.lastQueries.title': 'Latest lead queries',
  'dash.lastSearch': 'Last search: {result}',
  'dash.lastSearch.error': 'Error',
  'dash.lastSearch.zero': '0 leads',
  'dash.lastYear': 'Last year',
  'dash.leads': 'Leads',
  'dash.leadsGen': 'Leads',
  'dash.leadsGenerated': 'Leads generated',
  'dash.learning.body':
    'With every ✓ "fits" or ✗ "doesn\'t fit" {scope}, Leadscraper sharpens its understanding of your ideal lead, and filters the next results accordingly.',
  'dash.learning.cta': 'Rate {n} leads',
  'dash.learning.hint': 'Start a search run above. Once leads arrive, you can rate them.',
  'dash.learning.scopeAll': 'across your audiences',
  'dash.learning.scopeProfile': 'for "{name}"',
  'dash.learning.title': 'Leadscraper is waiting for your first feedback',
  'dash.maturity.label': 'Maturity: {label}',
  'dash.maturity.next.many': '{n} more ratings until {stage}.',
  'dash.maturity.next.one': '{n} more rating until {stage}.',
  'dash.maturity.stage.calibrated': 'Calibrated',
  'dash.maturity.stage.early': 'Learning',
  'dash.maturity.stage.mature': 'Mature',
  'dash.maturity.usage':
    'Leadscraper uses your feedback with varying weight depending on maturity for the next run.',
  'dash.months': 'May,Jun,Jul,Aug,Sep,Oct,Nov,Dec,Jan,Feb,Mar,Apr',
  'dash.newBadge': 'new',
  'dash.newCust': 'New customers',
  'dash.newCustomers': 'New customers',
  'dash.newProfile': 'New audience',
  'dash.nextRun.autoPaused': 'Auto-paused · 3 empty runs',
  'dash.nextRun.in': 'Next run in {time}',
  'dash.nextRun.manual': 'Manual · no schedule',
  'dash.nextRun.paused': 'Paused',
  'dash.nextRun.pausedCredits': 'Paused · credits used up',
  'dash.nextRun.soon': 'Soon',
  'dash.nextUp': 'Up next',
  'dash.onlyFavorites': 'Favorites only',
  'dash.openLeads': 'Open leads →',
  'dash.openProfile': 'Open leads',
  'dash.profileDrop.create': 'Create first audience',
  'dash.profileDrop.createSub': "Define your audience, then you're good to go",
  'dash.profiles': 'active',
  'dash.progress': 'Progress',
  'dash.projRevenue': 'Projected revenue',
  'dash.projectedRevenue': 'Projected revenue',
  'dash.query.businessType': 'Industry',
  'dash.query.contact': 'Contact person',
  'dash.query.dashExplain':
    '"—" means: Leadscraper did not track this value (full run trace coming in V1.13).',
  'dash.query.deepAnalysis': 'Deep analysis',
  'dash.query.deepAnalysisHint': 'Website + legal notice analyzed',
  'dash.query.delivered': 'Delivered',
  'dash.query.deliveredHint': 'Actual matches',
  'dash.query.evaluated': 'Evaluated',
  'dash.query.evaluatedHint': 'Leadscraper reasoning applied',
  'dash.query.extras': 'Additional criteria',
  'dash.query.failedTitle': 'Search run failed',
  'dash.query.header': 'Lead query',
  'dash.query.howWorked': 'How Leadscraper worked',
  'dash.query.identified': 'Identified',
  'dash.query.identifiedHint': 'Companies found from web search + directories',
  'dash.query.leadsSoFar': '{n} leads so far · still running',
  'dash.query.loading': 'loading…',
  'dash.query.alreadyKnown': '{n} already-known companies skipped',
  'dash.query.alreadyKnownTip':
    "Companies you already know (exclusion list / CRM import) were skipped before delivery — you didn't pay for them.",
  'dash.query.noLeads': 'No leads found',
  'dash.query.profile': 'Audience: {name}',
  'dash.query.region': 'Region / Location',
  'dash.query.rerun': 'Run again',
  'dash.query.rerunTitle': 'Run this query through Leadscraper again (e.g. after audience updates)',
  'dash.query.restart': 'Restart',
  'dash.query.runHistory': 'Run history',
  'dash.query.runningNoLeads': 'Still running, leads coming shortly',
  'dash.query.showLeads': 'Show {n} leads',
  'dash.query.rerunRow': 'Repeat',
  'dash.query.rerunCta': 'Repeat search',
  'dash.query.searchedLabel': 'What you searched for',
  'dash.query.autoRepeat': 'Repeat automatically',
  'dash.query.openSettings': 'Open settings',
  'dash.query.startedAt': 'Started: {date}',
  'dash.query.suggestions': 'Leadscraper suggestions',
  'dash.query.technicalDetails': 'Technical details',
  'dash.query.unfeasibleTitle': 'Leadscraper considers the query unfeasible',
  'dash.query.unnamed': 'Unnamed query',
  'dash.query.whenRuns': 'When does this search run?',
  'dash.queryHint': 'Search run hint',
  'dash.queryId': 'Query ID',
  'dash.renameQuery': 'Rename query',
  'dash.roi': 'ROI calculator',
  'dash.roiShort': 'ROI',
  'dash.run.audience': 'Audience:',
  'dash.run.suggHeading': 'Example searches for your business',
  'dash.run.intent.broad': 'Classic',
  'dash.run.intent.growth': 'Growth signal',
  'dash.run.intent.tool': 'Tool signal',
  'dash.run.intent.default': 'Suggestion',
  'dash.run.businessType': 'Industry',
  'dash.run.businessTypeP': 'e.g. Folding carton maker with own die-cutting',
  'dash.run.cancel': 'Cancel',
  'dash.run.contact': 'Contact person',
  'dash.run.contactP': 'e.g. Managing director, purchasing manager',
  'dash.run.extras': 'Additional constraints',
  'dash.run.extrasP':
    'e.g. no corporation, family-owned preferred, FSC-certified, 50–250 employees',
  'dash.run.forWhich': 'For which audience?',
  'dash.run.minField': 'At least specify an industry',
  'dash.run.notBackendProfile':
    'This audience is not yet registered in the backend. Create a real one via',
  'dash.run.notBackendProfileCta': '+ New audience',
  'dash.run.notBackendProfileEnd': ', then the scraper can run.',
  'dash.run.optional': '(optional)',
  'dash.run.pastQueries': 'Latest lead queries',
  'dash.run.pastQueriesHint': 'Click to apply values',
  'dash.run.region': 'Region / Location',
  'dash.run.regionHint': 'City, state, region or "nationwide". Write it the way you would search.',
  'dash.run.regionP': 'e.g. Cologne, NRW, greater Hamburg, or nationwide',
  'dash.run.searchBtn': 'Search 10 leads',
  // LEA-338 Part A / LEA-355 — "auto-enrich contact persons" toggle. Slimmed copy
  // (LEA-355): label uses "enrich" instead of "connect", cost as a subtle sub-line.
  'dash.run.withContact.label': 'Auto-enrich contact person',
  'dash.run.withContact.hint':
    "Every new lead is enriched right away with the matching contact persons and their details. You can also review the leads first and enrich them individually, recommended when you're starting out.",
  'dash.run.withContact.cost': 'Up to {n} credits, only charged on successful enrichment.',
  // LEA-418: per-phase credit-cost transparency
  'dash.run.cost.base': 'Cost: {n} leads = {n} credits (1 per delivered lead).',
  'dash.run.cost.extras': 'Contacts & full insights: +1 credit/lead each, only on request.',
  'lt.next.connectCostHint': 'Only 1 credit if a reachable contact is found, otherwise free.',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'lt.next.connectFreeHint': 'Free — you only pay when you unlock a contact person.',
  // LEA-356 — cascading Phase-3 "auto-generate acquisition plan" toggle.
  'dash.run.withPlan.label': 'Auto-generate acquisition plan',
  'dash.run.withPlan.hint':
    'For each enriched lead, a tailored acquisition plan is created, a concrete outreach approach based on the contacts found.',
  'dash.run.withPlan.cost': 'Up to {n} credits, only charged when a plan is successfully created.',
  'dash.run.costPreview': 'up to {n} credits',
  'dash.run.sub': '10 Credits · 10 Leads · typically 5–12 min',
  'dash.run.title': 'Start lead search',
  'dash.sched.change': 'change',
  'dash.sched.daily': 'Daily',
  'dash.sched.dailySub': '10 fresh leads every day',
  'dash.sched.manual': 'Manual',
  'dash.sched.manualSub': 'No schedule, on demand only',
  'dash.sched.pause': '⏸ Pause',
  'dash.sched.resume': '▶ Resume',
  'dash.sched.sub': 'Leadscraper regularly pulls 10 fresh leads for this audience.',
  'dash.sched.time': 'Schedule query',
  'dash.sched.title': 'Schedule query',
  'dash.sched.toast.error': 'Could not save schedule: {err}',
  'dash.sched.toast.manual': 'Schedule removed. Audience runs manually only.',
  'dash.sched.toast.paused': 'Audience paused, no automatic runs.',
  'dash.sched.toast.set': 'Schedule set. Leadscraper runs automatically ({cadence}).',
  'dash.sched.twiceWeekly': 'Mon / Thu',
  'dash.sched.twiceWeeklySub': '2× per week, ~20 leads/week',
  'dash.sched.weekly': 'Weekly',
  'dash.sched.weeklySub': '10 leads once a week',
  'dash.schedInd.nextRun': 'next run',
  'dash.schedInfo.everyNh': 'every {n}h',
  'dash.schedInfo.hourly': 'hourly',
  'dash.schedInfo.oneshot': 'one-time',
  'dash.schedInfo.paused': 'paused',
  'dash.simulation': 'Simulation',
  'dash.startRun': 'Start new run',
  'dash.startRunDisabledHint': 'Create an audience first, then start a search',
  'dash.status': 'Status',
  'dash.status.delivered.many': '{n} leads delivered',
  'dash.status.delivered.one': '{n} lead delivered',
  'dash.status.deliveredSuffix.many': 'leads delivered',
  'dash.status.deliveredSuffix.one': 'lead delivered',
  'dash.status.done': 'Done',
  'dash.status.empty': 'No matches',
  'dash.status.failed': 'Failed',
  'dash.status.running': 'Running',
  'dash.status.runningEllipsis': 'Running\u2026',
  'dash.status.runningPrefix': 'Running \u00b7 ',
  'dash.status.unfeasible': 'Not feasible',
  'dash.step.delivery': 'Assembling leads',
  'dash.step.discovery': 'Identifying companies',
  'dash.step.done': 'Done',
  'dash.step.fallbackProfile': 'Audience',
  'dash.step.hydration': 'Deep-analyzing companies',
  'dash.step.planning': 'Leadscraper is remembering',
  'dash.step.reasoning': 'Leadscraper is evaluating',
  'dash.step.starting': 'Starting…',
  'dash.timeline': 'Metrics over time',
  'dash.totalLeads': 'Total leads',
  'dash.whenCell.next': 'next {label}',
  'dash.winRate': 'Win rate',
  'dash.yourLeads': 'Your leads',
  'dash.yourProfiles': 'Your audiences',
  'dash.yourProfilesSub':
    'All audiences you are training. A click opens the leads of this audience.',

  'det.accepted': 'Accepted',
  'det.back': 'Back to results',
  'det.city': 'Location',
  'det.companyProfile': 'Company profile',
  'det.contact': 'Contact',
  'det.contactsEmpty':
    'No contacts extracted yet. Leadscraper searches the legal notice and LinkedIn.',
  'det.crmSoonTitle':
    'CRM integration is coming soon. You will be notified once HubSpot, Pipedrive & Co. are connected.',
  'det.decider': 'Decision maker',
  'det.delivers': 'Provides:',
  'det.draftMail': 'Prepare email draft',
  'det.draftMailSoonToast': 'Email drafts from a lead are not available yet, coming soon.',
  'det.fetched': 'fetched',
  'det.fits': 'Fits',
  'det.fitsNot': "Doesn't fit",
  'det.founded': 'Founded',
  'det.markedFit': '✓ Marked as a fit',
  'det.rejectAnyway': '↩ Not a fit after all?',
  'det.markedNotFit': '× Marked as not a fit',
  'det.memoryHint': 'Note for your memory',
  'det.memoryHintText':
    'If you accept or reject this lead, it affects similar leads in "{profile}", but not your other profiles.',
  'det.open': 'Open',
  'det.patterns': 'Learned patterns that apply here',
  'det.publicOnly':
    'All sources are publicly accessible. Leadscraper never stores data from private or paid directories.',
  'det.research.footer':
    'Leadscraper tries several search paths (LinkedIn, company site, press, Xing) before falling back to the managing director. That is why this contact is shown.',
  'det.research.hit': '✓ Match',
  'det.research.label': 'Research path',
  'det.research.noHit': '○ no match',
  'det.research.resultMany': 'results',
  'det.research.resultOne': 'result',
  'det.research.summaryFallback':
    '{n} search paths tried, no specific role found, managing director as fallback',
  'det.research.summaryFound': 'Contact found at stage {stage}: {label}',
  'det.research.summaryNoHit': '{n} search paths with no hit',
  'det.sector': 'Industry',
  'det.shortProfile': 'Short profile',
  'det.similar': 'Similar to leads you accepted before',
  'det.size': 'Employees',
  'det.sourcesCount': 'sources',
  'det.sourcesPending':
    'The source evidence for this lead is still being compiled. It will appear here once verified.',
  'det.sourcesSub': 'You can trace every field in this lead back to a concrete public source.',
  'det.sourcesTitle': 'Where this information comes from',
  'det.trail.searched': 'Cortex searched {n} public sources',
  'det.trail.website': 'Company website',
  'det.trail.register': 'Commercial register',
  'det.trail.google': 'Google search',
  'det.trail.press': 'Press',
  'det.trail.pages': '{n} pages',
  'det.trail.profiles': '{n} profiles',
  'det.capturedAt': 'recorded',
  'det.derivedAt': 'inferred',
  'det.sourcePage': 'Source page',
  'det.sourcesBelegtCount': '{n} sourced',
  'det.sourcesTagline': 'Where every detail comes from, open and verifiable.',
  'det.sourcesBelegt': '{n} of {total} sourced',
  'det.sourcesFieldCount': '{n} fields',
  'det.lastChecked': 'last checked',
  'det.sourcesUnsourced': 'Not yet sourced',
  'det.sourcesHonesty':
    'Official and public details are sourced directly; AI estimates are clearly marked as such. Leadscraper uses no paid databases.',
  'det.sourcesFlex': 'Others hide where their data comes from. We show every source, verifiable.',
  'ld.tier.officialName': 'Officially sourced',
  'ld.tier.officialSub': 'Official register and legally required disclosures',
  'ld.tier.publicName': 'Publicly sourced',
  'ld.tier.publicSub': 'Publicly visible on the web',
  'ld.tier.inferredName': 'Inferred by Cortex',
  'ld.tier.inferredSub': 'Estimate: verify before sending',
  'ld.tier.officialFallback': 'Official source',
  'ld.tier.publicFallback': 'Public source',
  'ld.tier.inferredFallback': 'Inferred by Cortex',
  'ld.tier.legendOfficial': 'official',
  'ld.tier.legendPublic': 'public',
  'ld.tier.legendInferred': 'inferred · verify',
  'ld.tier.legendUnsourced': 'still open',
  'ld.srcLabel.dork': 'Public web search',
  'ld.srcLabel.icypeas_finder': 'Inferred email',
  'ld.srcLabel.role_match': 'Role match',
  'ld.srcLabel.cortexNace': 'Cortex industry analysis',
  'ld.field.vatId': 'VAT ID',
  'ld.field.facebook': 'Facebook',
  'ld.field.instagram': 'Instagram',
  'ld.field.country': 'Country',
  'ld.field.contactPhone': 'Phone (contact)',
  'det.toCRM': 'Send to CRM',
  'det.webExcerpts': 'Website excerpts',
  'det.website': 'Website',
  'det.whyFits': 'Why this fits you',
  'det.whyFitsSub': 'based on what Leadscraper has learned about you',

  'error.account_deleted': 'This account has been deleted.',
  'error.email_unverified': 'Please verify your email address first (link in the signup email).',
  'error.demo_read_only': 'This is switched off in the demo. Nothing was changed.',
  'error.impersonate_target_not_found':
    'Test account not found: the UID does not exist in this DB env (Mini / Staging / Production).',
  'error.invalidInput': 'Invalid input.',
  'error.noProfile': 'No audience selected.',
  'error.profileNotRegistered': 'Audience not yet registered in the backend. Opening the wizard.',
  'error.unauthenticated': 'You are not logged in. Please reload the page and sign in again.',

  // LEA-704: welcome-back screen for expired accounts moved into the reveal model.
  'revealMigration.title': 'Welcome back',
  'revealMigration.subtitle': 'Leadscraper now charges per contact',
  'revealMigration.free': 'Searching and contact research are free',
  'revealMigration.payPerContact': 'You only pay when you unlock a contact person',
  'revealMigration.units': 'Your balance carries over: {n} contacts to unlock',
  'revealMigration.unitsOne': 'Your balance carries over: 1 contact to unlock',
  'revealMigration.unitsNone': 'Buy contacts in packs whenever you need them',
  'revealMigration.cta': 'Continue',
  'revealMigration.ctaLoading': 'One moment…',
  'revealMigration.error': "That didn't work. Please try again.",

  'fb.blocked.headline': 'The query is too broad',
  'fb.blocked.subline':
    'Leadscraper would mainly find portals, associations, or consultancies, not real individual companies.',
  'fb.cta.adjust': 'Adjust query',
  'fb.cta.bypass': 'Start anyway',
  'fb.cta.bypassTitle': 'The query will be processed by Leadscraper anyway, at your own risk',
  'fb.cta.sharpen': 'Go back & refine',
  'fb.field.ansprechpartner': 'Contact person',
  'fb.field.ort': 'City',
  'fb.field.rawQuery': 'Free text',
  'fb.field.region': 'Region',
  'fb.field.unternehmensart': 'Business type',
  'fb.field.zusatz': 'Additional criteria',
  'fb.fieldWarnings': 'Fields with notes',
  'fb.suggestions': 'More specific suggestions',
  'fb.suggestionsHint':
    'Copy one of the suggestions back into the field or write your own. This measurably improves the hit rate.',
  'fb.warning.headline': 'This query is very specific',
  'fb.warning.subline':
    'With this combination of filters, Leadscraper might find only a few or no matches. You can start anyway or loosen the query a bit.',

  'find.amount': 'Number of leads',
  'find.amountHint': 'Must be between 1 and 1000',
  'find.businessType': 'Industry',
  'find.businessTypeP': 'e.g. Restaurant, attorney, tax advisor',
  'find.contact': 'Contact',
  'find.contactP': 'e.g. Owner, sales rep, managing director',
  'find.creditNote': '(1 lead = 1 credit)',
  'find.extras': 'Additional constraints',
  'find.extrasP': 'Describe your target audience more precisely',
  'find.forProfile': 'For which audience?',
  'find.forProfileHint': 'Your ratings train Leadscraper for this audience.',
  'find.location': 'Location',
  'find.locationP': 'e.g. Berlin, Hamburg, Munich',
  'find.start': 'Start Leadscraper',
  'find.title': 'Find new leads',
  'find.trainsProfile': 'Trains',

  'hero.eyebrow': 'Leadscraper is getting to know you',
  'hero.stat.feedbacks': 'Feedbacks total',
  'hero.stat.matchrate': '⌀ match rate',
  'hero.stat.profiles': 'active audiences',
  'hero.sub':
    'Each "Fits / Doesn\u2019t fit" shapes which leads show up tomorrow. Here are your current numbers.',
  'hero.title': 'Across all audiences, Leadscraper gets sharper, with every piece of feedback.',

  'inbox.sched.body': 'Next run {rel}. New leads will land automatically {where}.',
  'inbox.sched.cta': 'View',
  'inbox.sched.inCRM': 'in your CRM',
  'inbox.sched.inList': 'in your list',
  'inbox.sched.title': '{n} scheduled runs active',

  'ld.aggregatorWarn':
    "The company's own website is still being determined. In the meantime we show the source URL (directory/press) this company came from.",
  'ld.comingSoon': '· soon',
  'ld.company': 'Company',
  'ld.companySite': 'Company website',
  'ld.contactPhoneUnknown': 'Direct dial not public',
  'ld.contacts': 'Contacts',
  'ld.decisionMaker': '· Decision maker',
  'ld.email.apply': 'Apply pattern',
  'ld.email.confGuessed': 'guessed',
  'ld.email.confLikely': 'likely',
  'ld.email.confPlausible': 'plausible',
  'ld.email.copied': 'Guessed email copied to clipboard.',
  'ld.contact.emailCopied': 'Email address copied.',
  'ld.contact.phoneCopied': 'Phone number copied.',
  'ld.contact.copy': 'Copy',
  'ld.contact.copied': 'Copied.',
  'ld.contact.tagCentral': 'Switchboard',
  'ld.contact.tagUnconfirmed': 'unconfirmed',
  'ld.contact.tagPattern': 'Pattern',
  'ld.contact.centralTooltip': 'Direct line not public. Call and ask for {name}.',
  'ld.contact.centralTooltipNoName': 'Direct line not public: this reaches the switchboard.',
  'ld.contact.verifiedSmtp': 'Email mailbox confirmed (SMTP).',
  'ld.contact.unverifiedHint': 'Taken from a public source, not yet SMTP-checked.',
  'ld.contact.patternTooltip': 'Likely address based on the company email pattern, unconfirmed.',
  'ld.contact.derivePattern': 'Derive email from company pattern',
  'ld.contact.bestRoute': 'Best route:',
  'ld.contact.route.central': 'Call via the switchboard',
  'ld.contact.route.centralEmail': 'Email the switchboard',
  'ld.contact.route.linkedin': 'LinkedIn message',
  'ld.contact.route.xing': 'Xing message',
  'ld.contact.route.phone': 'Call (direct line)',
  'ld.contact.route.email': 'Email',
  'ld.contact.route.pattern': 'Email via company pattern',
  'ld.contact.provMailbox': 'Mailbox confirmed',
  'ld.contact.provImpressum': 'Named in the imprint',
  'ld.contact.provFound': 'Found in public sources',
  'ld.contact.provVia': 'confirmed via',
  'ld.contact.confHigh': 'High',
  'ld.contact.confMid': 'Medium',
  'ld.contact.confLow': 'Low',
  'ld.contact.photoVia': 'Photo: {src} ↗',
  'ld.contact.roleProof': 'Role publicly confirmed ↗',
  'ld.section.roleFallback':
    'Requested role ({roles}) is not publicly confirmed, showing the next-best contacts.',
  'ld.section.noDirect': 'Direct contacts are not public here, reachable via the switchboard.',
  'ld.email.derivedFrom':
    'Derived from {n} email{s} on the company website. {conf}. Verify before mailing.',
  'ld.email.noDirectExplain':
    "We couldn't find a direct email for {first} {last}. However, we identified the company's email pattern. Click to reveal the likely address. You bear responsibility.",
  'ld.email.notFound': 'No direct email found for this contact.',
  'ld.emailLabel': 'Email',
  'ld.emailPattern': 'Email pattern',
  'ld.emailPattern.confHigh': 'high',
  'ld.emailPattern.confLow': 'low',
  'ld.emailPattern.confMid': 'medium',
  'ld.emailPattern.hint': 'All contacts at this company likely follow this pattern.',
  'ld.emailPattern.noPattern': "Found emails ({n}) don't follow a clear pattern.",
  'ld.emailPattern.noSamples': 'No employee emails found on the website.',
  'ld.emailPattern.notFound': 'No pattern found',
  'ld.emailPattern.notRecognized': 'not recognized',
  'ld.emailPattern.sourceMany': 'sources',
  'ld.emailPattern.sourceOne': 'source',
  'ld.fetchedThisWeek': 'this week',
  'ld.field.acquisitionHook': 'Leadscraper acquisition hook',
  'ld.field.centralEmail': 'Central email',
  'ld.field.centralPhone': 'Central phone',
  'ld.field.certs': 'Certifications',
  'ld.field.city': 'City',
  'ld.field.companyName': 'Company name',
  'ld.field.customerRefs': 'Customer references',
  'ld.field.description': 'Short profile',
  'ld.field.email': 'Email (decision maker)',
  'ld.field.employees': 'Employee count',
  'ld.field.firstName': 'First name (decision maker)',
  'ld.field.foundedYear': 'Founded year',
  'ld.field.hrNumber': 'Trade register number',
  'ld.field.jobSnapshot': 'Open positions',
  'ld.field.lastName': 'Last name (decision maker)',
  'ld.field.legalForm': 'Legal form',
  'ld.field.linkedin': 'LinkedIn (decision maker)',
  'ld.field.locations': 'Locations',
  'ld.field.nace': 'NACE industry',
  'ld.field.ownership': 'Ownership / history',
  'ld.field.revenueRange': 'Revenue range',
  'ld.field.role': 'Role (decision maker)',
  'ld.field.sizeClass': 'Size class',
  'ld.field.street': 'Street',
  'ld.field.triggerEvent': 'Trigger event',
  'ld.field.website': 'Website URL',
  'ld.field.xing': 'XING (decision maker)',
  'ld.field.deciderProfile': 'Decision-maker profile',
  'ld.field.zip': 'ZIP code',
  'ld.linkedinPublic': 'LinkedIn · public',
  'ld.match.borderline': 'borderline',
  'ld.match.excellent': 'excellent',
  'ld.match.solid': 'solid match',
  'ld.match.strong': 'strong match',
  'ld.sparkle.certs': 'Certifications & Awards',
  'ld.sparkle.customers': 'Customer references',
  'ld.sparkle.hookFake':
    'You can connect here because {company} shows a classic mid-market profile with concrete demand, matches your offering directly.',
  'ld.sparkle.hookLabel': 'Leadscraper acquisition hook',
  'ld.sparkle.hookUnlockLink': 'your company website',
  'ld.sparkle.hookUnlockPost':
    ' in the dashboard above. Leadscraper will then generate a personalized hook for each lead.',
  'ld.sparkle.hookUnlockPre': 'Enter ',
  'ld.sparkle.jobs': 'Jobs snapshot',
  'ld.sparkle.jobsBadge': '{n} open positions',
  'ld.sparkle.locations': 'Locations',
  'ld.sparkle.locked': ', locked',
  'ld.sparkle.ownerSince': 'since {year}',
  'ld.sparkle.ownership': 'Ownership structure',
  'ld.sparkle.staleAction':
    "Restart the query in the dashboard. We'll then generate a personalized acquisition hook plus all sales signals (trigger events, open positions, customers, …) for THIS lead.",
  'ld.sparkle.staleMsg':
    'This lead was generated before your company profile was set up in Leadscraper.',
  'ld.sparkle.sub': ', what Leadscraper just found',
  'ld.sparkle.title': 'Live signals',
  'ld.sparkle.trigger': 'Trigger event',
  'ld.sparkle.waitLabel': ', waiting for re-run',
  'ld.specialization': 'Specialization',
  'ld.srcDesc.firecrawl': 'Main page of the company website (cached).',
  'ld.srcDesc.footer': 'Website footer: locations, certifications, alternative contact methods.',
  'ld.srcDesc.haiku_extracted':
    'Leadscraper extracted structured fields from the hydrated website content (description, customers, trigger events).',
  'ld.srcDesc.handelsregister':
    'Official German trade register: HRB number, seat, registration date.',
  'ld.srcDesc.impressum':
    'Legal notice page with company name, legal form, address, management. Fetched + parsed.',
  'ld.srcDesc.json_ld': 'Machine-readable Schema.org metadata of the website (org profile).',
  'ld.srcDesc.karriere': 'Careers page: open positions, profiles sought (growth trigger signal).',
  'ld.srcDesc.kontakt': 'Contact/location page: phone numbers, email addresses, contacts.',
  'ld.srcDesc.llm_haiku':
    'Leadscraper extracted structured fields from the hydrated website content (description, customers, trigger events).',
  'ld.srcDesc.llm_sonnet': 'Leadscraper rated the lead against your audience + memory.',
  'ld.srcDesc.news': 'Press/news page: latest events, facility expansions, awards.',
  'ld.srcDesc.regex_derived':
    'Derived from other data, e.g. email pattern from known company email + name.',
  'ld.srcDesc.serp': 'Google results for targeted domain or person search.',
  'ld.srcDesc.team': 'Team/employee page: people + roles.',
  'ld.srcDesc.ueber_uns': 'Company self-description: history, owners, values, customer references.',
  'ld.srcDesc.user_feedback': 'You manually confirmed or rejected this lead, highest trust level.',
  'ld.srcLabel.firecrawl': 'Company website (main page)',
  'ld.srcLabel.footer': 'Website footer',
  'ld.srcLabel.haiku_extracted': 'AI extraction',
  'ld.srcLabel.handelsregister': 'Trade register',
  'ld.srcLabel.impressum': 'Imprint',
  'ld.srcLabel.json_ld': 'Structured data (Schema.org)',
  'ld.srcLabel.karriere': 'Careers page',
  'ld.srcLabel.kontakt': 'Contact page',
  'ld.srcLabel.llm_haiku': 'AI extraction',
  'ld.srcLabel.llm_sonnet': 'AI evaluation',
  'ld.srcLabel.news': 'Press / News',
  'ld.srcLabel.regex_derived': 'Pattern derivation',
  'ld.srcLabel.serp': 'Google search',
  'ld.srcLabel.team': 'Team page',
  'ld.srcLabel.ueber_uns': 'About us page',
  'ld.srcLabel.user_feedback': 'Your feedback',
  'ld.toast.accepted': '"{company}" saved as a fit.',
  'ld.toast.feedbackErr': 'Feedback could not be saved. Please try again.',
  'ld.toast.rejected': '"{company}" marked as not a fit.',
  'ld.trust.inferred': '🔵 AI-derived',
  'ld.trust.inferredTitle': 'Derived by Leadscraper AI, not an official source.',
  'ld.trust.official': '🛡 Official',
  'ld.trust.officialTitle': 'Legally authoritative source (trade register/imprint).',
  'ld.trust.public': '🟡 Public',
  'ld.trust.publicTitle': 'Publicly visible on the company website.',
  'ld.uncertainty': 'Leadscraper is {score} here: {text}.',
  'ld.unverified.body':
    'Generic industry match: the specialization was not mentioned in the website content. If strictly needed, refine the query (e.g. "{token} specialty store").',
  'ld.unverified.title': '"{token}" could not be verified by Leadscraper for this company',
  'ld.viaCentralPhone': 'Via switchboard',
  'ld.websiteExcerpt': 'Website excerpt',
  'ld.xingPublic': 'XING · public',

  'leads.act.cancel': 'Cancel',
  'leads.act.details': 'Details',
  'leads.act.fits': 'Fits',
  'leads.act.fitsDone': 'Saved as Fits',
  'leads.act.fitsNot': 'Doesn\u2019t fit',
  'leads.act.fitsNotDone': 'Saved as doesn\u2019t fit',
  'leads.act.reason': 'Pick a reason',
  'leads.allProfiles': 'All audiences',
  'leads.allProfilesHeader': 'All audiences',
  'leads.allProfilesShow': 'Show all audiences',
  'leads.backToActive': '← back to active audience',
  'leads.cardView': 'Cards',
  'leads.chip.edge': 'Edge case · verdict?',
  'leads.chip.pattern': 'Shapes a pattern',
  'leads.col.actions': 'Actions',
  'leads.col.centralEmail': 'Email',
  'leads.col.centralPhone': 'Phone',
  'leads.col.city': 'Location',
  'leads.col.company': 'Company',
  'leads.col.crm': 'CRM',
  'leads.col.decider': 'Decision maker',
  'leads.col.founded': 'Founded',
  'leads.col.lastActivity': 'Last activity',
  'leads.col.legalForm': 'Legal form',
  'leads.col.match': 'Match',
  'leads.col.nace': 'Industry',
  'leads.col.phase': 'Phase',
  'leads.col.phone': 'Phone',
  'leads.col.profile': 'Audience',
  'leads.col.revenue': 'Revenue',
  'leads.col.sector': 'Sub-Industry',
  'leads.col.size': 'Size',
  'leads.col.status': 'Status',
  'leads.col.website': 'Website',
  'leads.cols.btn': 'Columns',
  'leads.cols.fixed': 'Fixed',
  'leads.cols.reset': 'Reset to default',
  'leads.cols.sub': 'Show only what you need.',
  'leads.cols.title': 'Show columns',
  'leads.count': '{shown} of {total} leads',
  'leads.crm.push': 'Push',
  'leads.crm.notSynced': 'Not synced',
  'leads.crm.syncedTo': 'Synced to {crm}',
  'leads.crm.pushFailed': 'Push failed',
  'leads.crossOverview.many': '{n} leads · across audiences',
  'leads.crossOverview.one': '{n} lead · across audiences',
  'leads.daysAgo': '{n} days ago',
  'leads.empty': 'No leads for this profile. Start a new run via "Find new leads".',
  'leads.exp.memoryRefs': 'From your memory',
  'leads.exp.uncertain': 'Leadscraper is {score} here: {note}.',
  'leads.exp.whyShown': 'Why Leadscraper shows you this lead',
  'leads.export': 'Export',
  'leads.filter.all': 'All',
  'leads.filter.fits': 'Fits',
  'leads.filter.fitsNot': 'Doesn\u2019t fit',
  'leads.filter.unrated': 'Unrated',
  'leads.filterBy': 'Filter by audience',
  'leads.footerHint':
    'Click a row to reveal the short reasoning. The "Details" button opens the 360° view.',
  'leads.searchP': 'Company, sector, city, decision-maker …',
  'leads.status.accepted': 'Fit',
  'leads.status.rejected': 'Not a fit',
  'leads.status.unseen': 'Unseen',
  'leads.sub': '{n} leads · grouped by your profiles. Click opens the 360° view of the company.',
  'leads.tableView': 'Table',
  'leads.title': 'Your leads',
  'leads.toast.accepted': '\u201E{c}\u201D saved as Fits.',
  'leads.toast.export': 'Export is coming soon.',
  'leads.toast.rejected':
    '„{c}" rejected · reason: {r}. Leadscraper is learning from this for future runs.',

  'lp.card.examplesHint': '(Lead IDs from your rating history for this cluster)',
  'lp.card.hideExamples': 'Hide examples',
  'lp.card.showExamplesMany': 'Show {n} example leads',
  'lp.card.showExamplesOne': 'Show {n} example lead',
  'lp.cl.age': 'Company age',
  'lp.cl.age.mock': 'Established companies founded before 2010 preferred',
  'lp.cl.bizModel': 'Business model',
  'lp.cl.bizModel.mock': 'Operational providers, no agencies or intermediaries',
  'lp.cl.buyingSignals': 'Buying signals',
  'lp.cl.buyingSignals.mock': 'Active trigger events (growth, hiring) sought',
  'lp.cl.domainBlock': 'Domain block',
  'lp.cl.domainBlock.mock': 'Competitor domains are consistently excluded',
  'lp.cl.geo': 'Location',
  'lp.cl.geo.mock': 'NRW + Baden-Württemberg strongly preferred, East Germany less so',
  'lp.cl.industry': 'Industry',
  'lp.cl.industry.mock': 'Prefers service-provider sector (M-N) over manufacturing',
  'lp.cl.ownership': 'Ownership',
  'lp.cl.ownership.mock': 'Family businesses >> PE subsidiaries and corporations',
  'lp.cl.role': 'Contact person',
  'lp.cl.role.mock': 'C-level expected, department heads too junior',
  'lp.cl.size': 'Company size',
  'lp.cl.size.mock': 'Tendency towards smaller operators (10-50 employees)',
  'lp.cl.techStack': 'Tech stack',
  'lp.cl.techStack.mock': 'Certain technologies are consistently sought/avoided',
  'lp.cta.count': 'Rate {n} leads',
  'lp.cta.open': 'Open leads',
  'lp.cta.rate': 'Rate leads',
  'lp.error.load': 'Error loading data',
  'lp.evidence.many': '{n} evidences',
  'lp.evidence.one': '{n} evidence',
  'lp.journey.active': 'Actively personalized',
  'lp.journey.matchRate': 'Match rate',
  'lp.journey.matched': 'matched',
  'lp.journey.notMatched': 'did not match',
  'lp.journey.preview': 'Initial training',
  'lp.journey.title': '{n} ratings: {accepted} match · {rejected} no match',
  'lp.loading': 'Loading learning status…',
  'lp.locked.pill': 'from {n} ratings',
  'lp.ps.bizModel.analyse':
    "Leadscraper has the default filter active: agencies, distributors and marketplaces are automatically deprioritized in reasoning when they don't match the query.",
  'lp.ps.bizModel.content': 'Operational providers (no pure intermediaries)',
  'lp.ps.bodyDefault':
    'These cards show what Leadscraper has concretely **analyzed** from your profile + the confirmed leads. Rate more specifically with reasons so the clusters sharpen.',
  'lp.ps.bodyHigh':
    'With only {rejected} {rejectWord}, Leadscraper cannot form hard exclusion clusters: these cards show what Leadscraper has concretely **analyzed** from your profile + the {accepted} confirmed leads. Once you reject more specifically, the clusters will mature into hard filters.',
  'lp.ps.footerBody':
    'From **50 ratings** onwards, Leadscraper considers not just your input and what your company sells for every new search, but also your **learned profile as a tendency**: industry, size class, location, role, ownership structure. Not as a hard filter, but as additional weighting in the reasoning. This means a new query for "tax advisor Hamburg" doesn\'t generically search all tax firms, but automatically prefers owner-operated mid-market firms, analogous to the profile you\'ve built here.',
  'lp.ps.footerTitle': 'How this influences your next searches',
  'lp.ps.geo.analyseNo':
    'Leadscraper prioritizes hits from this region and curates nearby matches when the core region runs thin.',
  'lp.ps.geo.analyseYes':
    'Leadscraper confirmed {n} companies from this region as matching: the geographic anchor is solid.',
  'lp.ps.geo.fallback': 'DACH region',
  'lp.ps.industry.analyseNo':
    'Leadscraper systematically searches for companies matching your industry description.',
  'lp.ps.industry.analyseYes':
    'Leadscraper confirms this industry through {n} accepted leads: the industry focus is on target.',
  'lp.ps.industry.anyBranche':
    'Your profile is open to all industries. Cortex derives the actual tendency from your ratings. Currently {n} accepted leads as anchors. The more ratings you provide, the sharper the derived industry tendency becomes.',
  'lp.ps.industry.fallback': 'Derived from your profile intent',
  'lp.ps.ownership.analyseHigh':
    'Leadscraper recognizes from confirmed leads that your focus is on owner-operated companies. Corporate subsidiaries are suggested more conservatively.',
  'lp.ps.ownership.analyseLow':
    'Rate a corporate subsidiary with "no match" so Leadscraper can form a hard ownership cluster here.',
  'lp.ps.ownership.contentHigh': 'Owner-operated / mid-market profile confirmed',
  'lp.ps.ownership.contentLow': 'Mix of owner-operated and smaller corporate structures',
  'lp.ps.ownership.label': 'Ownership structure',
  'lp.ps.rejectionMany': 'rejections',
  'lp.ps.rejectionOne': 'rejection',
  'lp.ps.role.analyseHigh':
    'Leadscraper actively searches for this role in its reasoning: imprint, career pages + LinkedIn are specifically filtered for it.',
  'lp.ps.role.analyseLow':
    'Leadscraper specifically searches for these roles on imprint + career pages, only falls back to CEO if the specific role is not listed.',
  'lp.ps.role.fallback': 'C-level',
  'lp.ps.size.analyseHigh':
    'With a {pct}% match rate, Leadscraper sees your target size class is consistently hit, no correction needed.',
  'lp.ps.size.analyseLow':
    'Leadscraper refines the employee range with each rejection to better match your expectations.',
  'lp.ps.size.contentHigh': 'Leadscraper hits the size class precisely',
  'lp.ps.size.contentLow': 'Mid-market tendency from confirmed leads',
  'lp.ps.titleDefault': 'What Leadscraper understands from your ratings',
  'lp.ps.titleHigh': 'Leadscraper understands your audience: {pct}% hit rate',
  'lp.ps.understands': 'Leadscraper understands',
  'lp.s0.body':
    'At {preview} rated leads we show you the first impression. At {active}, Leadscraper actively searches for YOU, based on your specific patterns.',
  'lp.s0.eyebrow': 'Leadscraper learns with you',
  'lp.s0.headline': 'Leadscraper is building your audience',
  'lp.s0.openMany': '{n} leads still unrated. Rate them to progress faster.',
  'lp.s0.openOne': '{n} lead still unrated. Rate it to progress faster.',
  'lp.s1.body':
    'First trends are visible. At {n} ratings this will actively influence your searches.',
  'lp.s1.eyebrow': 'First impression',
  'lp.s1.headline': 'Leadscraper is still gathering evidence',
  'lp.s1.morePatterns': 'More patterns: will become visible at {n} ratings',
  'lp.s1.strongestLabel': 'Strongest trend so far',
  'lp.s2.headline': 'Leadscraper searches for YOU',
  'lp.s2.ignoredMany':
    '{n} ratings were "already known" or "wrong data": these are intentionally excluded from learning.',
  'lp.s2.ignoredOne':
    '{n} rating was "already known" or "wrong data": these are intentionally excluded from learning.',
  'lp.s2.pillActive': 'Actively personalized',
  'lp.s2.pillSharp': 'Audience is sharp',
  'lp.s2.pillUpdating': 'Update in progress',
  'lp.s2.reanalysisAgo': 'Last re-analysis: {n} ratings ago · Next at {next}',
  'lp.s2.reanalysisCurrent': 'Re-analysis up to date · Next at {n}',
  'lp.s2.weakLabel': 'Weak trends: will solidify with more data',
  'lp.sq.activeSubS1': 'Based on your first {n} ratings, will sharpen with each re-analysis step.',
  'lp.sq.activeSubS2': 'Updated after {n} ratings · Re-analysis every {interval} ratings.',
  'lp.sq.activeTitle': 'Leadscraper suggests these searches',
  'lp.sq.badge.crossSell': 'Cross-sell',
  'lp.sq.badge.expansion': 'Expansion',
  'lp.sq.badge.pattern': 'Pattern',
  'lp.sq.badge.salesFit': 'Sales fit',
  'lp.sq.badge.zoomOut': 'Zoom-out',
  'lp.sq.emptyBody':
    'Suggestions will be computed with your next pattern re-analysis (every {n} ratings).',
  'lp.sq.eyebrow': 'Optimized search queries',
  'lp.sq.launch': 'Start search',
  'lp.sq.loading': 'Leadscraper is computing suggestions…',
  'lp.sq.lockedBody':
    "Once you've rated {n} leads, Leadscraper will suggest 3-5 search queries, structured like your inputs, with match probability and a brief rationale.",
  'lp.sq.lockedTitle': 'Leadscraper is preparing specific suggestions',
  'lp.sq.mockA.contact': 'Management',
  'lp.sq.mockA.rationale': 'Example suggestion showing how Leadscraper proposes searches.',
  'lp.sq.mockA.region': 'Bavaria',
  'lp.sq.mockA.type': 'Mid-market machine builders',
  'lp.sq.mockB.rationale': 'Example suggestion showing how Leadscraper proposes searches.',
  'lp.sq.mockB.region': 'DACH',
  'lp.sq.mockB.type': 'HVAC planners hospital sector',
  'lp.sq.tier.hypothesis': 'Test hypothesis',
  'lp.sq.tier.solid': 'Solid',
  'lp.sq.tier.strong': 'Strong',
  'lp.sq.tier.veryStrong': 'Very strong',
  'lp.tone.drop': 'STRONG DROP',
  'lp.tone.keep': 'STRONG KEEP',
  'lp.tone.softDrop': 'SLIGHT DROP',
  'lp.tone.softKeep': 'SLIGHT KEEP',

  'lt.badge.soft': 'possible',
  'lt.dashHint1': 'You can find a hint in the Dashboard (symbol',
  'lt.dashHint2': 'next to the status).',
  'lt.exp.btn': 'Export',
  'lt.exp.csvHint': '.csv (comma-separated)',
  'lt.exp.fail': 'Export failed: {err}',
  'lt.exp.ing': 'Exporting…',
  'lt.exp.noRows': 'No leads found for export.',
  'lt.exp.success': '{n} rows exported as {fmt}.',
  // LEA-482: rating nudges to break feedback-loop starvation (88 delivered leads, 0 rated).
  'rateNudge.viewToast':
    "You've opened {n} leads without rating any. One tap on ✓ or ✕ is enough — and the next round gets sharper.",
  'rateNudge.exportToast':
    'Exported. Rate a few leads with ✓ or ✕ — your next round will fit better.',
  'lt.exp.tipNoLeads': 'Only leads with contacts or a finished plan can be exported',
  'lt.exp.tipReady': 'Export {n} leads',
  'lt.exp.tipWrongFilter': 'Only matching leads can be exported. Switch to the "Fits" filter.',
  'lt.exp.toastNoLeads': 'Only leads with contacts or a finished acquisition plan can be exported.',
  'lt.exp.unknownErr': 'Unknown error',
  'lt.expH.city': 'Location',
  'lt.expH.company': 'Company',
  'lt.expH.companyEmail': 'Company Email',
  'lt.expH.companyPhone': 'Company Phone',
  'lt.expH.contact': 'Contact Person',
  'lt.expH.direct': 'direct',
  'lt.expH.email': 'Email',
  'lt.expH.emailSource': 'Email Source',
  'lt.expH.guessed': 'guessed ({n}%)',
  'lt.expH.profile': 'Audience',
  'lt.expH.role': 'Role',
  'lt.expH.sector': 'Industry',
  'lt.expH.legalForm': 'Legal form',
  'lt.expH.street': 'Street',
  'lt.expH.zip': 'ZIP',
  'lt.expH.website': 'Website',
  'lt.expH.vatId': 'VAT ID',
  'lt.expH.hr': 'Commercial register',
  'lt.expH.founded': 'Founded',
  'lt.expH.size': 'Employees',
  'lt.expH.revenue': 'Revenue range',
  'lt.expH.description': 'Description',
  'lt.expH.techStack': 'Tech stack',
  'lt.expH.triggers': 'Signals/Triggers',
  'lt.expH.scoreCompany': 'Company-fit score',
  'lt.expH.scoreData': 'Data quality',
  'lt.expH.seniority': 'Seniority',
  'lt.expH.department': 'Department',
  'lt.expH.phone': 'Phone',
  'lt.expH.linkedin': 'LinkedIn',
  'lt.expH.xing': 'Xing',
  'lt.expH.qualification': 'Qualification',
  'lt.expH.confidence': 'Confidence',
  'lt.expH.channel': 'Recommended channel',
  'lt.feedbackFail': 'Failed to save feedback. Please try again.',
  'lt.payoff.avoided': 'The dossier now avoids:',
  'lt.payoff.flowsIn': 'Feeds into the next analysis.',
  // LEA-287: Kanban / funnel view (LeadsFunnel.tsx + LeadsTable.jsx)
  'lt.filter.all': 'All',
  'lt.filter.torate': 'To rate',
  'lt.filter.identified': 'Company added',
  'lt.filter.connected': 'With contacts',
  'lt.filter.planned': 'Plan ready',
  'lt.filter.archived': 'Archived',
  'lt.view.list': 'List',
  'lt.view.listSubheader': 'Table: all columns visible',
  'lt.funnel.subheader': 'Funnel: leads grouped by phase',
  'lt.funnel.addCompany': 'Add company',
  'lt.funnel.add': 'Add',
  'lt.funnel.addTooltip': 'Add company via URL · 1 credit',
  'lt.funnel.pullAllContacts': 'Pull all contacts',
  'lt.funnel.empty': 'No leads in this phase yet',
  'lt.funnel.dropHint': 'Drop here to start the phase',
  'lt.col.planned': 'Acquisition plan ready',
  'lt.card.new': 'New',
  'lt.card.viewPlan': 'View plan',
  'lt.card.findContacts': 'Find contacts',
  'lt.card.createPlan': 'Create acquisition plan',
  'lt.card.contactsCount': '{n} contacts',
  'lt.card.fitTooltip': 'Fit {score}%: how well this company matches your target audience',
  'lt.card.noContacts': 'No contacts yet',
  'lt.card.noJustification': 'No Cortex reasoning yet: the lead will be enriched on the next run.',
  'lt.card.rejectTitle': 'Mark as not a fit',
  'lt.card.rejectAria': 'Mark {company} as not a fit',
  'lt.card.openWebsite': 'Open {website}',
  'lt.next.title': 'Next steps',
  'lt.next.verifyContacts': 'Verify contacts',
  'lt.next.verifyingContacts': 'Verifying contacts …',
  'lt.next.contactsVerified': '{n} contacts verified',
  'lt.next.contactVerified': 'Contact verified',
  'lt.next.openPlan': 'Open plan',
  'lt.next.generatingPlan': 'Generating acquisition plan …',
  'lt.next.credit': '1 credit',
  'lt.next.retry': 'Try again',
  'lt.next.verifyFirst': 'Verify contacts first',
  'lt.next.failedHint': 'Last attempt failed. You can try again.',
  'lt.loading.connecting': 'Researching contacts …',
  'lt.loading.planning': 'Generating acquisition plan …',
  'lt.loading.adding': 'Adding …',
  'lt.loading.verifying': 'Verifying …',
  'lt.loading.connectingLive': 'Verifying contacts …',
  'lt.loading.planningLive': 'Creating acquisition plan …',
  'lt.manual.verifyingDesc': 'Verifying website, extracting base data …',
  'lt.manual.addedDesc':
    'Added via URL: industry, address and contact details are filled in during verification.',
  // AddCompanyManualModal — manual add via URL
  'lt.manual.modal.eyebrow': 'Pipeline · manual',
  'lt.manual.modal.title': 'Add company',
  'lt.manual.modal.desc':
    'Leadscraper verifies the website and extracts base company data. The lead then lands in {phase}, and from there you can pull contacts + an acquisition plan.',
  'lt.manual.modal.phase': '"Company added"',
  'lt.manual.modal.websiteLabel': 'Website',
  'lt.manual.modal.placeholder': 'e.g. heuerlogistics.de',
  'lt.manual.modal.hint': "We'll try to reach the website. No credit is charged if it fails.",
  'lt.manual.modal.cancel': 'Cancel',
  'lt.manual.modal.close': 'Close',
  'lt.manual.modal.submit': 'Add',
  'lt.manual.modal.submitting': 'Adding …',
  'lt.manual.modal.creditOne': '{n} credit',
  'lt.manual.modal.creditMany': '{n} credits',
  'lt.manual.modal.errEmpty': 'Please enter a website.',
  'lt.manual.modal.errInvalid': "That doesn't look like a valid website (e.g. heuerlogistics.de).",
  'lt.phaseChip.identified': 'Added',
  'lt.phaseChip.connected': 'Contacts',
  'lt.phaseChip.planned': 'Plan ready',
  'lt.naceF.A': 'Agriculture, Forestry and Fishing',
  'lt.naceF.B': 'Mining and Quarrying',
  'lt.naceF.C': 'Manufacturing',
  'lt.naceF.D': 'Electricity, Gas, Steam and Air Conditioning Supply',
  'lt.naceF.E': 'Water Supply; Sewerage, Waste Management',
  'lt.naceF.F': 'Construction',
  'lt.naceF.G': 'Wholesale and Retail Trade; Repair of Motor Vehicles',
  'lt.naceF.H': 'Transportation and Storage',
  'lt.naceF.I': 'Accommodation and Food Service',
  'lt.naceF.J': 'Information and Communication',
  'lt.naceF.K': 'Financial and Insurance Activities',
  'lt.naceF.L': 'Real Estate Activities',
  'lt.naceF.M': 'Professional, Scientific and Technical Activities',
  'lt.naceF.N': 'Administrative and Support Service Activities',
  'lt.naceF.O': 'Public Administration, Defence; Social Security',
  'lt.naceF.P': 'Education',
  'lt.naceF.Q': 'Human Health and Social Work',
  'lt.naceF.R': 'Arts, Entertainment and Recreation',
  'lt.naceF.S': 'Other Service Activities',
  'lt.naceF.T': 'Activities of Households as Employers',
  'lt.naceF.U': 'Extraterritorial Organisations and Bodies',
  'lt.naceS.A': 'Agri/Forestry',
  'lt.naceS.B': 'Mining',
  'lt.naceS.C': 'Manufacturing',
  'lt.naceS.D': 'Energy',
  'lt.naceS.E': 'Water/Waste',
  'lt.naceS.F': 'Construction',
  'lt.naceS.G': 'Trade',
  'lt.naceS.H': 'Transport/Storage',
  'lt.naceS.I': 'Hospitality',
  'lt.naceS.J': 'IT/Media',
  'lt.naceS.K': 'Finance/Insurance',
  'lt.naceS.L': 'Real Estate',
  'lt.naceS.M': 'Professional',
  'lt.naceS.N': 'Other Services',
  'lt.naceS.O': 'Public Admin',
  'lt.naceS.P': 'Education',
  'lt.naceS.Q': 'Healthcare',
  'lt.naceS.R': 'Arts/Entertainment',
  'lt.naceS.S': 'Other Svc.',
  'lt.naceS.T': 'Private Households',
  'lt.naceS.U': 'Extraterritorial',
  'lt.profileLeads': 'Leads · {name}',
  'lt.profileSub': '{n} leads · all queries of this audience land here',
  'lt.profileSubOne': '1 lead · all queries of this audience land here',
  'lt.queryClear': 'Clear filter',
  'lt.queryLabel': 'Filtered by query:',
  'lt.resetToast': 'Rating for {c} reset',
  'lt.ring.match': 'Match {pct}%',
  'lt.ring.rejected': 'Rejected: scored as 0',
  'lt.rm.cancel': 'Cancel',
  'lt.rm.header': 'Reject lead',
  'lt.rm.noteOptional': 'Note for Leadscraper (optional)',
  'lt.rm.noteRequired': 'Please describe briefly (required)',
  'lt.rm.placeholderOpt':
    'What did Leadscraper miss or misclassify? (The more specific, the better the system learns.)',
  'lt.rm.placeholderReq': 'E.g. "Competitor: sells a similar solution"',
  'lt.rm.sub': 'Tell us why: Leadscraper learns from this and delivers better next time.',
  'lt.rm.submit': 'Reject lead',
  'lt.rr.already_known': 'Already known',
  'lt.rr.already_known.hint': 'Already in CRM or previously contacted (no learning signal)',
  'lt.rr.bad_data': 'Incorrect data',
  'lt.rr.bad_data.hint': 'Address, name or contact info is wrong',
  'lt.rr.no_buying_signal': 'No recognisable demand',
  'lt.rr.no_buying_signal.hint': 'No trigger events, no open positions, no growth signal',
  'lt.rr.not_operator': 'Not an operator',
  'lt.rr.not_operator.hint': 'Agency, intermediary or developer instead of operational provider',
  'lt.rr.other': 'Other reason',
  'lt.rr.other.hint': 'Briefly describe why below (free text)',
  'lt.rr.wrong_industry': 'Wrong industry',
  'lt.rr.wrong_industry.hint': 'Leadscraper misidentified the business field',
  'lt.rr.wrong_ownership': 'Wrong ownership structure',
  'lt.rr.wrong_ownership.hint':
    'Corporate subsidiary instead of family-owned, wrong legal form, etc.',
  'lt.rr.wrong_region': 'Wrong location',
  'lt.rr.wrong_region.hint': 'Headquarters / region does not match the search',
  'lt.rr.wrong_role': 'Wrong contact person',
  'lt.rr.wrong_role.hint': 'Person or role is not the decision-maker',
  'lt.rr.wrong_size': 'Wrong company size',
  'lt.rr.wrong_size.hint': 'Too small, too large, or corporate instead of mid-market',
  'lt.tip.accepted': 'Accepted: click to undo',
  'lt.tip.contacts': 'Show {n} contacts',
  'lt.tip.dragCol': 'Drag to resize column',
  'lt.tip.openCompany': 'Open company details',
  'lt.tip.openLead': 'Open lead details',
  'lt.tip.rejected': 'Rejected: click to undo',
  'lt.tip.softKeep': 'Possibly relevant: Leadscraper has uncertainty here, see details',
  'lt.tip.unseen': 'Not yet seen',

  'mem.cancel': 'Cancel',
  'mem.editHint': 'Leadscraper uses this statement from the next sorting run.',
  'mem.editKicker': 'Correct learned assumption',
  'mem.editTitle': 'How should Leadscraper learn this?',
  'mem.param.contact': 'Contact',
  'mem.param.extras': 'Extras',
  'mem.param.leads': 'Leads',
  'mem.param.location': 'Location',
  'mem.param.sector': 'Sector',
  'mem.profile': 'Profile',
  'mem.save': 'Save assumption',
  'mem.screenLabel': 'Memory',
  'mem.screenLabelEmpty': 'Memory · empty',
  'mem.toast.confirmed': 'Assumption confirmed.',
  'mem.toast.corrected': 'Correction saved.',
  'mem.toast.forgotten': 'Assumption forgotten.',
  'mem.today': 'Today',

  'mob.abo': 'Plan & Credits',
  'mob.acct.aria': 'My account',
  'mob.active': 'Active',
  'mob.back': '← Back',
  'mob.changePassword': 'Change password',
  'mob.changePlan': 'Change plan',
  'mob.detail.contacts': 'Contacts ({n})',
  'mob.detail.fits': '✓ Fits',
  'mob.detail.label.email': 'Email',
  'mob.detail.label.phone': 'Phone',
  'mob.detail.label.website': 'Website',
  'mob.detail.notFitting': '✗ Not a fit',
  'mob.detail.rejected': '✗ Rejected',
  'mob.detail.section.company': 'Company',
  'mob.fb.fits': '✓ Fits',
  'mob.fb.rejected': '✗ Rejected',
  'mob.home.activeProfile': 'Active audience',
  'mob.home.cta.newSearch': 'Start new search',
  'mob.home.emptyHint': 'Start a new search or switch the audience.',
  'mob.home.newLeads': 'New leads',
  'mob.home.stat.fits': 'Fits',
  'mob.home.stat.leads': 'Leads',
  'mob.home.stat.matchRate': 'Match rate',
  'mob.home.viewAll': 'View all →',
  'mob.leads.cta.newSearch': 'Start new search',
  'mob.leads.filter.all': 'All',
  'mob.leads.filter.fits': 'Fits',
  'mob.leads.filter.open': 'Open',
  'mob.leads.filter.rejected': 'Rejected',
  'mob.leads.new': '＋ New',
  'mob.leads.title': 'Leads',
  'mob.logout': 'Log out',
  'mob.logoutConfirm': 'Really log out?',
  'mob.more.help': 'Help & contact',
  'mob.more.invoices': 'Invoices',
  'mob.more.label.email': 'Email',
  'mob.more.plan.monthly': 'Monthly plan',
  'mob.more.plan.trial': 'Trial',
  'mob.more.section.account': 'My account',
  'mob.more.section.help': 'Help & app',
  'mob.more.title': 'More',
  'mob.more.toDesktop': 'Switch to desktop',
  'mob.more.toDesktop.value': 'Full feature set',
  'mob.nav.account': 'Account',
  'mob.nav.home': 'Home',
  'mob.nav.leads': 'Leads',
  'mob.nav.profile': 'Audiences',
  'mob.onDesktop': 'On desktop',
  'mob.profile.active': 'Active',
  'mob.profile.leadsCount': '{n} leads',
  'mob.profile.newCount': '{n} new',
  'mob.profile.stat.match': 'Match',
  'mob.profile.switchTo': 'Switch to',
  'mob.profile.title': 'Audiences',
  'mob.queryPlaceholder': 'e.g. bakeries, tax consultants, shoe stores',
  'mob.search.askWho': 'Who are you looking for?',
  'mob.search.cancel': 'Cancel',
  'mob.search.profileLabel': 'Audience: {name}',
  'mob.search.region': 'Region (optional)',
  'mob.search.regionPlaceholder': 'e.g. Bavaria, Hamburg, NRW',
  'mob.search.start': 'Start search',
  'mob.search.title': 'New search',
  'mob.toast.accepted': '✓ Marked as a fit',
  'mob.toast.rejected': '✗ Rejected',
  'mob.toast.runStarted': 'Search started: arrives in ~2 min',
  'mob.trialLeads': 'trial leads left',
  'mob.upgrade': 'Upgrade to Pro',
  'mob.upgradeHint': 'More leads + scheduling',
  'mob.wizardHint':
    'Create your first profile on a desktop: the wizard is not yet available on mobile.',

  'mobile.empty.noContactData': 'No contact data available.',
  'mobile.empty.noOpenLeads': 'No open leads.',
  'mobile.empty.noProfileSelected': 'No audience selected.',
  'mobile.empty.noProfileShort': 'No audience.',
  'mobile.empty.nothingFound': 'Nothing found.',
  'mobile.note.label': 'Note:',
  'mobile.note.scheduleDesktop': 'You edit schedules and audience memory on desktop.',
  'mobile.tip.label': 'Tip:',
  'mobile.tip.profilesDesktop':
    'You create multiple audiences (e.g. by industry or region) on desktop.',

  'ms.aud.computingBody':
    'In a few seconds, Leadscraper will describe your target audience here in its own words.',
  'ms.aud.computingEyebrow': 'Leadscraper is analyzing your ratings',
  'ms.aud.computingTitle': 'Pattern recognition running…',
  'ms.aud.derivedFrom': 'Derived from your {n} ratings',
  'ms.aud.eyebrowS1': 'First assessment from Leadscraper',
  'ms.aud.eyebrowS2': 'Current assessment from Leadscraper',
  'ms.aud.fallbackBody':
    'Once the re-analysis is complete (in a few seconds), a specific description of your target audience will appear here.',
  'ms.aud.fallbackEyebrow': 'First assessment from Leadscraper',
  'ms.aud.fallbackTitle': 'Leadscraper is updating the assessment with your latest {n} ratings.',
  'ms.aud.learnedLabel': 'Specifically learned',
  'ms.aud.lockedEyebrow': "Target audience in Leadscraper's words",
  'ms.aud.lockedMock':
    "You're looking for smaller operators in NRW with active hiring, C-level contacts, family-owned with a clear industry tendency towards mechanical engineering.",
  'ms.aud.lockedPill': 'from {n} ratings',
  'ms.aud.nextReanalysis': ' · Next re-analysis at {n}',
  'ms.aud.recomputeEyebrow': 'Leadscraper is updating your assessment',
  'ms.aud.recomputeTitle': 'The assessment is being recalculated with your latest ratings…',
  'ms.aud.trainS1':
    "Keep training the scraper and you'll get **really strong results**: every rating makes Leadscraper more precise.",
  'ms.aud.trainS2':
    'Keep training Leadscraper: **every rating sharpens the searches** that now run automatically for you.',
  'ms.card.label': 'Leadscraper status',
  'ms.card.ratings': '{n} / {threshold} ratings',
  'ms.card.s2active': '{n} ratings · active in reasoning',
  'ms.card.s2reanalysis': '{n} ratings · being re-analyzed',
  'ms.cv.age': 'Company age: {rule}',
  'ms.cv.bizModel': 'Business model: {rule}',
  'ms.cv.buyingSignals': 'Buying signals: {rule}',
  'ms.cv.domainBlock': 'Exclusion: {rule}',
  'ms.cv.geo': 'Region: {rule}',
  'ms.cv.industry': 'Industry: {rule}',
  'ms.cv.ownership': 'Ownership: {rule}',
  'ms.cv.role': 'Contact: {rule}',
  'ms.cv.size': 'Size: {rule}',
  'ms.cv.techStack': 'Tech stack: {rule}',
  'ms.donut.match': 'match',
  'ms.donut.matchRate': 'Match rate',
  'ms.donut.noMatch': 'no match',
  'ms.donut.ratings': 'Ratings',
  'ms.donut.title': 'Rating status',
  'ms.error': 'Error',
  'ms.msg.s0': 'Learning with you · {n}/{threshold} until preview',
  'ms.msg.s1': 'First impression · {n}/{threshold} until active',
  'ms.msg.s2active': 'Actively personalized · {n} ratings',
  'ms.msg.s2reanalysis': 'Being re-analyzed · {n}',
  'ms.stage0.eyebrow': 'Learning with you',
  'ms.stage1.eyebrow': 'First impression',
  'ms.stage2.eyebrow': 'Actively personalized',

  'nace.A': 'Agriculture, Forestry and Fishing',
  'nace.B': 'Mining and Quarrying',
  'nace.C': 'Manufacturing',
  'nace.D': 'Electricity, Gas, Steam and AC Supply',
  'nace.E': 'Water Supply; Sewerage, Waste Management',
  'nace.F': 'Construction',
  'nace.G': 'Wholesale and Retail Trade; Motor Vehicle Repair',
  'nace.H': 'Transportation and Storage',
  'nace.I': 'Accommodation and Food Service',
  'nace.J': 'Information and Communication',
  'nace.K': 'Financial and Insurance Activities',
  'nace.L': 'Real Estate Activities',
  'nace.M': 'Professional, Scientific and Technical Activities',
  'nace.N': 'Administrative and Support Service Activities',
  'nace.O': 'Public Administration and Defence; Social Security',
  'nace.P': 'Education',
  'nace.Q': 'Human Health and Social Work',
  'nace.R': 'Arts, Entertainment and Recreation',
  'nace.S': 'Other Service Activities',
  'nace.T': 'Activities of Households as Employers',
  'nace.U': 'Activities of Extraterritorial Organisations',

  'naceShort.A': 'Agri/Forestry',
  'naceShort.B': 'Mining',
  'naceShort.C': 'Manufacturing',
  'naceShort.D': 'Energy',
  'naceShort.E': 'Water/Waste',
  'naceShort.F': 'Construction',
  'naceShort.G': 'Trade',
  'naceShort.H': 'Transport/Storage',
  'naceShort.I': 'Hospitality',
  'naceShort.J': 'IT/Media',
  'naceShort.K': 'Finance/Insurance',
  'naceShort.L': 'Real Estate',
  'naceShort.M': 'Professional',
  'naceShort.N': 'Other Services',
  'naceShort.O': 'Public Admin',
  'naceShort.P': 'Education',
  'naceShort.Q': 'Health',
  'naceShort.R': 'Arts/Entert.',
  'naceShort.S': 'Other Services',
  'naceShort.T': 'Households',
  'naceShort.U': 'Extraterritorial',

  'nav.activeProfile': 'Active audience',
  'nav.apiStatus.checking': 'Checking API status \u2026',
  'nav.apiStatus.down': 'API unreachable. Please reload the page',
  'nav.apiStatus.ok': 'API reachable',
  'nav.apiStatus.slow': 'API responding slowly',
  'nav.buyLeads': 'Buy leads',
  'nav.cortex': 'Audience',
  'nav.credits': 'Available credits',
  'nav.credits.available': 'Available',
  'nav.credits.label': 'Balance',
  'nav.credits.remaining': 'Remaining',
  'nav.credits.total': 'Total',
  'nav.credits.upgrade': 'Upgrade',
  'nav.dashboard': 'Dashboard',
  'nav.deleteProfile': 'Delete audience',
  'nav.deleteProfileBody':
    'All leads, ratings and learned patterns for "{name}" will be permanently deleted. This action cannot be undone.',
  'nav.deleteProfileBusy': 'Deleting …',
  'nav.deleteProfileCta': 'Delete permanently',
  'nav.deleteProfileError': 'Audience could not be deleted. Please try again.',
  'nav.deleteProfileInFlight':
    'A search is currently running for this audience. Please wait until it finishes.',
  'nav.deleteProfileSuccess': 'Audience deleted.',
  'nav.deleteProfileTitle': 'Delete audience?',
  'nav.feedbacks': 'ratings',
  'nav.leads': 'Leads',
  'nav.matchRate': 'match rate',
  'nav.matchRateMin': 'Match rate is shown from 5 ratings',
  'nav.rated': 'rated',
  'nav.open': 'open',
  'nav.rateNudge.title': 'Jump to the leads you haven’t rated yet',
  'nav.allRated': 'All rated',
  'nav.newProfile': 'Create new audience',
  'nav.onboardingRequired': 'Please complete the 3 onboarding steps first.',
  'nav.openSettings': 'Open settings & learnings of "{name}"',
  'nav.profileName': 'Audience name',
  'nav.profileNameP': 'e.g. IT services provider DACH',
  'nav.renameProfile': 'Rename audience',
  'nav.renameProfileSub': 'Choose a new name for this audience.',
  'nav.runs.footer': 'Click an audience to see progress. You can keep working.',
  'nav.runs.leadsReady': '{n} lead{s} ready',
  'nav.runs.many': '{n} searches running',
  'nav.runs.one': '1 search running',
  'nav.runs.title': 'Active searches',
  'nav.startSubscription': 'Start subscription',
  'nav.switchProfiles': 'Switch audiences',

  'notif.act.edge': 'Look at edge cases',
  'notif.act.pattern': 'Confirm in Leadscraper',
  'notif.act.review': 'Open leads',
  'notif.dismiss': 'Dismiss',
  'notif.edge.body': '{n} uncertain leads in {profile}: your verdict teaches Leadscraper the most.',
  'notif.edge.title': 'Edge cases need your verdict',
  'notif.empty.sub': 'Leadscraper is learning.',
  'notif.empty.title': 'All flowing.',
  'notif.kind.edge': 'Edge case',
  'notif.kind.pattern': 'Pattern',
  'notif.kind.review': 'Review',
  'notif.pattern.back': 'Back',
  'notif.pattern.badge': 'Learned pattern',
  'notif.pattern.confirmedLabel': 'Pattern confirmed.',
  'notif.pattern.needsConfirm': 'Is this right?',
  'notif.pattern.no': 'No, reject',
  'notif.pattern.rejectedLabel': 'Pattern rejected.',
  'notif.pattern.saveAndClose': 'Save',
  'notif.pattern.stage2': 'Saved',
  'notif.pattern.title': 'Pattern detected',
  'notif.pattern.whyLabel': 'Why? (optional)',
  'notif.pattern.whyPlaceholder': 'Helps Leadscraper learn the nuance, but not required.',
  'notif.pattern.yes': 'Yes, it is',
  'notif.review.body': 'You still have {n} unrated leads.',
  'notif.review.bodyAll': '{n} unrated leads across {m} audiences.',
  'notif.review.cta': 'Review now',
  'notif.review.title': 'Rate new leads',
  'notif.sub': 'Hints that make your searches sharper.',
  'notif.title': 'Heads-up',

  'np.abort': 'Cancel',
  'np.audience': 'Describe your audience',
  'np.audienceHint':
    'The more specific, the better the first ranking pass. You can refine anytime.',
  'np.audienceHintLong':
    'Write it the way you would explain it to a new sales rep. Leadscraper extracts your goals, channels, arguments and hooks from this, and uses it per lead for the acquisition plan.',
  'np.audienceLabel': 'Sales briefing',
  'np.audienceP':
    'Example: We want to win mid-market tax firms for our recruiting solution. The goal is a first call with the managing partner.',
  'np.back': 'Back',
  'np.briefingHelp.q1': 'What is your goal with this audience?',
  'np.briefingHelp.q2': 'What do you offer?',
  'np.briefingHelp.q3': 'Why is your offer relevant for this audience?',
  'np.briefingHelp.q4': 'What is your strongest USP?',
  'np.briefingHelp.q5': 'Which problems do you solve?',
  'np.briefingHelp.q6': 'Who would you like to address first?',
  'np.briefingHelp.q7': 'Which channel works for you: email, phone, LinkedIn?',
  'np.briefingHelp.q8': 'What should the next step be: reply, meeting, demo, offer?',
  'np.briefingHelp.q9': 'What should be avoided in the outreach?',
  'np.briefingHelpFooter': 'These are not required fields, just guidance for the free text.',
  'np.briefingHelpTitle': 'Helpful for Leadscraper',
  'np.coldStart': 'Cold start: no seed parameters',
  'np.coldStartDesc':
    'The profile starts completely empty. After ~20 ratings the first plain-text statements appear in Leadscraper.',
  'np.companySize': 'Company size',
  'np.companySizeP': 'e.g. 50–250 employees',
  'np.continue': 'Continue',
  'np.create': 'Create audience',
  'np.created': 'Audience created. Leadscraper is ready.',
  'np.creating': 'Creating …',
  'np.header': 'New audience',
  'np.headline': 'Create sales briefing',
  'np.suggHeading': 'Suggestions for your audience',
  'np.suggHint':
    'Click applies the suggestion. You can switch between them, type your own text, or create directly.',
  'np.draftWriting': 'Leadscraper is writing your briefing …',
  'np.draftErrorLabel': 'Note:',
  'np.draftErrorFallback':
    'The briefing draft could not be generated. You can keep writing manually.',
  'np.industry': 'Industry',
  'np.industryP': 'e.g. Packaging, folding cartons',
  'np.name': 'Audience name',
  'np.nameP': 'e.g. Folding carton makers NRW',
  'np.notes': 'Additional notes',
  'np.notesP': 'Exclusions, customer types, signal words …',
  'np.nothingYet': ', nothing pre-defined. Leadscraper will be shaped entirely by your feedback.',
  'np.optional': 'Optional',
  'np.region': 'Region / state',
  'np.regionP': 'e.g. NRW, DACH, all of Germany',
  'np.skip': 'Skip',
  'np.step1Sub':
    'Give the profile a clear name. Leadscraper uses this description as a starting point before your feedback sharpens the pattern.',
  'np.step1Title': 'Who or what are you looking for?',
  'np.step2Sub':
    'Optional: Leadscraper uses these as a seed. The profile learns as you rate leads.',
  'np.step2Title': 'Seed parameters',
  'np.stepOf': 'Step {n} of 2',
  'np.summaryTitle': 'Leadscraper starts with',
  'np.title': 'Create new audience',
  'np.whatHappens': 'What happens next?',
  'np.whatHappensBody':
    'In the dashboard you start a <b>search query</b> and set industry, region and size. Leadscraper finds matching companies with contacts and builds a per-lead acquisition plan from this briefing.',

  'offer.beta.pricing.intro': 'Beta invitation · 55% off your first month',

  'og.beta.cardCta': 'Activate beta package',
  'og.beta.cardFeature.1': '500 leads / month at Growth scope',
  'og.beta.cardFeature.2': 'Instant activation. No trial.',
  'og.beta.cardFeature.3': 'Cancel anytime with one click',
  'og.beta.cardFoot': 'Card required · secure payment via Stripe',
  'og.beta.cardName': 'Your beta package',
  'og.beta.feature.1.bold': '500 leads',
  'og.beta.feature.1.lead': '',
  'og.beta.feature.1.tail': ' per month, verified emails & phone numbers',
  'og.beta.feature.2': 'AI targeting in natural language',
  'og.beta.feature.3': 'CRM integrations + CSV/Excel export',
  'og.beta.feature.4': 'GDPR-compliant · data in the EU',
  'og.beta.feature.5.bold': 'WhatsApp access to Janik',
  'og.beta.feature.5.lead': 'Direct ',
  'og.beta.feature.5.tail': ' for any questions',
  'og.beta.narrativeBody':
    "We're looking for {profis} who use our system early, give honest feedback, and shape how Leadscraper evolves. In return you pay just {price} for your first month of our Growth package, instead of the regular € 490 — after that the regular price applies, cancel anytime.",
  'og.beta.narrativePrice': '€ 220',
  'og.beta.narrativeProfis': '30 active sales pros',
  'og.beta.narrativeTitle': 'Why this offer?',
  'og.beta.priceNowSuffix': '/ first month',
  'og.beta.priceFootnote': 'then € {n} / month · cancel anytime',
  'og.beta.priceOld': '€ {n} / month regular',
  'og.beta.savings': 'You save € {n} in your first month',
  'og.cancelAny': 'Cancel anytime',
  'og.cta': 'Start 3-day free trial: {plan}',
  'og.ctaBeta': 'Get beta access: € {price} / month',
  'og.ctaPlain': 'Continue with {plan}',
  'og.ctaSub':
    'No charge for the first 3 days · then € {price}.00 / month · {leads} trial leads included',
  'og.ctaSubPlain': '€ {price}.00 / month · activated immediately',
  'og.dsgvo': 'GDPR-compliant · servers in DE',
  'og.eyebrow.beta': 'Personal beta invitation',
  'og.eyebrow.trial50': '50 credits on the house',
  'og.hlBanner.trial50.body':
    "After picking a plan you get {credits} on your account immediately. Use them in the next 3 days. If you don't cancel, you switch automatically into the chosen plan.",
  'og.hlBanner.trial50.credits': '{n} credits',
  'og.hlBanner.trial50.title': 'How your trial works:',
  'og.later': 'Decide later →',
  'og.leadsIncl': '{n} leads per month included',
  'og.maiOffer.cta': 'Claim the May deal: 100 B2B leads for € 49',
  'og.maiOffer.detail': 'Perfect to dip your toes in, no commitment.',
  'og.maiOffer.feature.1': 'Verified emails & phone numbers',
  'og.maiOffer.feature.2': 'AI targeting in natural language',
  'og.maiOffer.feature.3': 'CRM integrations + CSV/Excel export',
  'og.maiOffer.feature.4': 'GDPR-compliant · data in the EU',
  'og.maiOffer.feature.5': 'From month 2: € 190/month, 1-click cancellable',
  'og.maiOffer.leadsNum': '100',
  'og.maiOffer.leadsUnit': 'leads / month',
  'og.maiOffer.planName': 'Basic',
  'og.maiOffer.price': '€ 49',
  'og.maiOffer.priceNote': '€ 0.49 instead of € 1.90 per lead, this month only.',
  'og.maiOffer.priceOriginal': 'Instead of € 190 / month',
  'og.maiOffer.priceSuffix': '/ month',
  // --- LEA-319 Trust-Redesign (variant '50credits-trust'). Pixel source:
  //     sandbox/pricing-trust-50credits-en.html (approved Janik 2026-06-10).
  'og.title.trust.lead': 'Try Leadscraper ',
  'og.title.trust.grad': '3 days free',
  'og.title.trust.tail': ' with 50 real leads.',
  'og.subtitle.trust':
    "Nothing is charged today. You test with real leads from your target market, and if it's not a fit, you end the trial with one click. No call, no notice period.",
  'og.trust.demo.tag': 'Live demo · not a marketing video',
  'og.trust.demo.title': 'Watch how Leadscraper finds your leads',
  'og.trust.demo.body':
    'Real search, real dashboard, real results: founder Janik walks you through the full flow, from describing your target market to the finished lead list.',
  'og.trust.demo.play': 'Play demo video',
  'og.trust.demo.close': 'Close',
  'og.trust.timeline.1.when': 'Today',
  'og.trust.timeline.1.body':
    'Pick a plan, add a payment method. {s}: your 50 credits are available right away.',
  'og.trust.timeline.1.strong': '€0 charged',
  'og.trust.timeline.2.when': 'Days 1–3',
  'og.trust.timeline.2.body':
    'You test with real leads. Not convinced? {s} ends the trial instantly, no contact, no questions asked.',
  'og.trust.timeline.2.strong': 'One click in your account',
  'og.trust.timeline.3.when': 'From day 3',
  'og.trust.timeline.3.body': 'Only now does your subscription start. {s}, no minimum term.',
  'og.trust.timeline.3.strong': 'Cancel monthly',
  'og.trust.ctaNote': '€0 today · Cancel = 1 click',
  'og.trust.proof.head': 'Sales teams that already switched',
  // Nachfolger des geloeschten og.trust.proof.pill (behauptete Google & OMR ohne Beleg; LEA-619). Nur aus
  // lib/verifiedReviews gerendert, {platform} = Plattformen der gezeigten Bewertungen.
  'og.trust.proof.pillVerified': 'Reviews on {platform}',
  'og.trust.bar.card.title': '€0 today',
  'og.trust.bar.card.body': 'Card, PayPal or SEPA direct debit, secured by Stripe',
  'og.trust.bar.cancel.title': 'Canceled in 5 seconds',
  'og.trust.bar.cancel.body': 'One click in your account, no contact, effective immediately',
  'og.trust.bar.gdpr.title': 'Public data only',
  'og.trust.bar.gdpr.body': 'GDPR by design · EU servers · public sources only',
  'og.trust.founderLine.title': 'Built in Hamburg, Germany',
  'og.trust.founderLine.name': ', Janik Deimann, Founder',
  'og.trust.founderLine.sub':
    'German engineering, EU data protection, and a human answers when you write to us.',
  'og.trust.founderLine.ask': 'Still unsure? Email us: support@leadscraper.eu, a human will reply.',

  // --- Paywall revision 19 (approved by Janik 2026-09-11) ---
  // The German source wording is the approved original; keep the qualified
  // "up to 50" and the extra-credit-cost note intact in every translation.
  'og.r19.accountReady': 'Account created · Activate your trial',
  'og.r19.headline.lead': 'Find up to',
  'og.r19.headline.grad': '50 free leads.',
  'og.r19.lead':
    'Start today with companies that match what you offer. Your trial includes {credits} credits for up to {credits} company leads.',
  'og.r19.offerNote':
    'Contacts and company research cost additional credits. Credits spent on those reduce the number of companies.',
  'og.r19.rating.value': '4.8 / 5',
  'og.r19.rating.caption': 'Excellent user feedback',
  'og.r19.rating.aria': 'Customer rating: 4.8 out of 5 stars',
  'og.r19.product.footnote': 'You decide which companies you research in more depth.',
  'og.r19.picker.title': 'Start now, free of charge.',
  'og.r19.picker.trialCredits': '{credits} trial credits',
  'og.r19.picker.trialPlan': '{plan} · {days} days at €0, then {renewal}, cancel any month',
  'og.r19.picker.trialPlanAll': '{plan} · trial at €0, then {renewal}, cancel any month',
  'og.r19.picker.today': '€0',
  'og.r19.picker.todayLabel': 'today',
  'og.r19.picker.description': 'Choose your package for the time after the trial.',
  'og.r19.credits.title': 'Find 1 company',
  'og.r19.credits.equals': '=',
  'og.r19.credits.unit': '1 credit',
  'og.r19.credits.note': 'Contacts & company research cost additional credits.',
  'og.r19.credits.info': 'See an example of credit usage',
  'og.r19.credits.example':
    'Example: you find 20 companies and add contacts and company research for 10 of them. That is 40 credits.',
  'og.r19.credits.exampleRest': '{rest} of your {credits} trial credits are left.',
  'og.r19.credits.disclaimer':
    '{credits} credits are not automatically {credits} fully researched contacts.',
  'og.r19.plans.legend': 'Choose your package for after the trial',
  'og.r19.plans.creditsPerMonth': '{credits} credits / month',
  'og.r19.plans.perMonth': '/ month',
  'og.r19.plans.caption.basic': 'To get you started',
  'og.r19.plans.caption.starter': 'For regular outreach',
  'og.r19.plans.caption.growth': 'For a larger sales team',
  'og.r19.cta': 'Start free now',
  'og.r19.renewal': 'Then {s} for {credits} credits.',
  'og.r19.renewal.strong': '€{price} / month',
  'og.r19.renewal.cancel': 'Cancel before the trial ends and you pay nothing.',
  'og.r19.security': 'Payment method in the next step',
  'og.r19.help.faq': 'Trial & cancellation',
  'og.r19.help.features': 'Packages in detail',
  'og.moneyBack': '14-day money-back',
  'og.perMonth': '€ / month',
  'og.plan': 'Plan',
  'og.planBadge.recommended': 'Recommended',
  'og.planCta.loading': 'Continuing to checkout …',
  'og.planCta.pick.basic': 'Pick Basic',
  'og.planCta.pick.growth': 'Pick Growth',
  'og.planCta.pick.starter': 'Pick Starter',
  'og.planCta.trial.basic': 'Try free for 3 days',
  'og.planCta.trial.growth': 'Try free for 3 days',
  'og.planCta.trial.starter': 'Try free for 3 days',
  'og.planDetail.basic': 'For small sales teams that follow up deliberately.',
  'og.planDetail.growth': 'For teams scaling outbound.',
  'og.planDetail.starter': 'Best price-performance for active teams.',
  'og.planFeature.basic.1': 'Verified emails & phone numbers',
  'og.planFeature.basic.2': 'AI targeting in natural language',
  'og.planFeature.basic.3': 'CRM integrations + CSV/Excel export',
  'og.planFeature.basic.4': 'GDPR-compliant · data in the EU',
  'og.planFeature.growth.1': 'Everything in Starter',
  'og.planFeature.growth.2': '5× more leads per month',
  'og.planFeature.growth.3': 'Personal onboarding call',
  'og.planFeature.growth.4': 'Premium support directly with Janik',
  'og.planFeature.starter.1': 'Everything in Basic',
  'og.planFeature.starter.2': '2.5× more leads per month',
  'og.planFeature.starter.3': 'Prioritised lead queue',
  'og.planFeature.starter.4': 'Email support < 4 h',
  'og.planLeadsUnit': 'leads / month',
  'og.planPriceNote.basic.default': '€ 1.90 per lead',
  'og.planPriceNote.basic.trial': 'Then {price}\u00A0€/month · 100 credits included',
  'og.planPriceNote.growth.default': '€ 0.98 per lead, save 48%',
  'og.planPriceNote.growth.trial': 'Then {price}\u00A0€/month · 500 credits included · Save 48%',
  'og.planPriceNote.starter.default': '€ 1.16 per lead, save 39%',
  'og.planPriceNote.starter.trial': 'Then {price}\u00A0€/month · 250 credits included · Save 39%',
  'og.planPriceSuffix.default': '/ month',
  'og.planPriceSuffix.trial': '/ month after trial',
  'og.planPriceSuffix.trialToday': 'today',
  'og.ready': 'Your account is ready',
  'og.recommended': 'Recommended',
  'og.split.badge.start': 'Perfect to get started',
  'og.split.rating.note': '· Excellent customer feedback',
  'og.split.rating.score': '4.8 / 5.0',
  'og.split.trust.cancel': '1-click cancellable',
  'og.split.trust.gdpr': 'GDPR-compliant',
  'og.step.activateBeta': 'Activate beta package',
  'og.step.created': 'Account created',
  'og.step.pickPlan': 'Pick plan',
  'og.step.start': 'Get started',
  'og.step.startTrial': 'Start 3-day free trial',
  'og.sub1': 'Pick your plan to try Leadscraper',
  'og.sub1b': 'free for 3 days',
  'og.sub2': 'No payment now, cancel anytime during the trial.',
  'og.subtitle.beta':
    'As a beta tester you get our top package (500 leads per month) at a special price: your first month is € 220 instead of € 490. No minimum term, cancel anytime.',
  'og.subtitle.default':
    'Three plans, the same data quality. Choose how many leads you need per month, switch or cancel anytime with one click.',
  'og.subtitle.mai': 'Save 74 % in the first month, switch or cancel anytime with one click.',
  'og.subtitle.trial50': '50 leads on us: 3-day test, cancel anytime.',
  'og.title.beta.grad': 'hand-picked',
  'og.title.beta.lead': 'You were ',
  'og.title.beta.tail': ' for the beta.',
  'og.title.default.grad': 'start in 60 seconds',
  'og.title.default.lead': 'Pick your plan and ',
  'og.title.default.tail': '.',
  'og.title.mai.grad': 'unfair competitive edge',
  'og.title.mai.lead': 'Your ',
  'og.title.mai.tail': ' starts here.',
  'og.title.trial50.grad': 'on the house',
  'og.title.trial50.lead': '50 B2B leads worth € 100: ',
  'og.title.trial50.tail': '.',
  'og.trial': '3 days free',
  'og.trial50v2.cta': 'Claim your 50 free credits',
  'og.trial50v2.detail': 'Enough credits to test-drive Leadscraper end-to-end.',
  'og.trial50v2.feature.1': 'Verified emails & phone numbers',
  'og.trial50v2.feature.2': 'AI targeting in natural language',
  'og.trial50v2.feature.3': 'CRM integrations + CSV/Excel export',
  'og.trial50v2.feature.4': 'GDPR-compliant · data in the EU',
  'og.trial50v2.feature.5': 'Rolls over after 3 days, 1-click cancellable',
  'og.trial50v2.leadsNum': '50',
  'og.trial50v2.leadsUnit': 'leads in 3 days',
  'og.trial50v2.planName': 'Trial',
  'og.trial50v2.price': 'Free',
  'og.trial50v2.priceNote': 'Ends after 3 days or rolls over, 1-click cancellable.',
  'og.trialIncl': 'incl.',
  'og.trialLeadsN': '{n} trial leads',
  'og.trust.beta.lock.body': 'no hidden upcharges',
  'og.trust.beta.lock.title': 'Beta price in month 1',
  'og.trust.cancel.body.default': 'No minimum term',
  'og.trust.cancel.body.trial': 'Free during the trial',
  'og.trust.cancel.title.default': '1-click cancellable',
  'og.trust.card.body.default': 'Secure payment via Stripe',
  'og.trust.card.body.trial': 'Charged only after 3 days',
  'og.trust.card.title.default': 'Card required',
  'og.trust.card.title.trial': 'Card to activate',
  'og.trust.gdpr.body': 'Servers in the EU · public sources only',
  'og.trust.gdpr.title': 'GDPR-compliant',
  'og.welcome': 'Welcome, Janik.',

  'onb.step1Done': 'Leadscraper now knows your offering: see analysis below',

  'onb.heroTitle': 'Your unfair advantage starts here',

  'onb.heroDesc':
    'Three steps to your first 10 leads. Leadscraper really gets to know you and finally delivers leads that truly fit.',

  'onb.helpCardTitle': 'New to Leadscraper?',
  'onb.helpCardDesc':
    'Our quick-start guide takes you from account and email to your first audience in just a few minutes.',
  'onb.helpCardCta': 'Read the first steps',
  'onb.helpCardDismissAria': 'Dismiss hint',

  'onb.stepLabel': 'Step {n}',

  'onb.b2cLead': 'Leadscraper only finds companies: no private customers.',

  'onb.b2cBody':
    'Your website analysis shows you sell to end consumers. The suggestions below therefore target B2B multipliers (e.g. property developers, facility managers) rather than private customers directly. If you have no fitting B2B layer, Leadscraper is probably not the right tool for your business.',

  'onb.step2LabelDone': 'First audience is set. Leadscraper has saved it',

  'onb.step2LabelPending': 'Define your first target group: who exactly do you want as customers?',

  'onb.step2Cta': 'Create audience',

  'onb.step2Badge': 'Create now',

  'onb.step2Locked': 'Waiting for step 1',

  'onb.step3Title': 'First search run',

  'onb.step3DescFull':
    'Once your first profile is set, you start the search here directly on it. Leadscraper finds 10 leads in 30-90 seconds, exactly matching the target group you just created.',

  'onb.step3Cta': 'Start search',

  'onb.step3Badge': 'Start now',

  'onb.step3Locked': 'Waiting for step 2',
  'onb.step1Pending':
    'Tell Leadscraper briefly about yourself: a look at your website is enough for it to understand what you sell',
  'onb.step2Desc':
    "Describe your ideal customers in 1-2 sentences, e.g. 'tax advisors in NRW, 3-15 employees, managing director'. Leadscraper builds your search queries from this, learns with each feedback, and the profile gets sharper over weeks.",
  'onb.step2Title': 'Create your first audience',
  'onb.step3Done': 'First search is running. Leadscraper will deliver your first 10 leads shortly',
  'onb.step3Pending': 'Search for your target audience. Leadscraper delivers 10 tailored leads',

  'pd.activeSince': 'Active since {date}',
  'pd.company.analyze': 'Analyze',
  'pd.company.analyzed': 'Leadscraper has analyzed your company (Confidence {n}%).',
  'pd.company.analyzedAt': 'Analyzed on {date}',
  'pd.company.analyzing': 'Analyzing…',
  'pd.company.cached': 'Profile loaded from cache.',
  'pd.company.cancel': 'Cancel',
  'pd.company.change': 'Change',
  'pd.company.confidence': '{n}% confident',
  'pd.company.costHint':
    'Cost ~$0.015 per analysis. Re-analysis every 30 days automatically if your site changes.',
  'pd.company.error': 'Analysis failed. Please try again.',
  'pd.company.inputDesc1':
    'Leadscraper reads your company website and remembers what you sell, who you sell to, and what arguments you use. For each lead, Leadscraper then writes ',
  'pd.company.inputDesc2': ' instead of just "fits the industry".',
  'pd.company.inputDescStrong': 'your tailored pitch strategy',
  'pd.company.inputTitle': 'Enter your own website',
  'pd.company.knownTitle': 'What Leadscraper knows about your company',
  'pd.company.placeholder': 'https://my-company.com',
  'pd.company.reanalyze': 'Re-analyze now',
  'pd.company.reanalyzing': 'Re-analyzing…',
  'pd.company.sellLabel': 'What you sell',
  'pd.company.staleAt': 'Re-analysis due {date}',
  'pd.company.targetLabel': 'To whom',
  'pd.company.techDetails': 'Technical details',
  'pd.company.valueLabel': 'Value props',
  'pd.cortex.comingSoon': 'coming soon',
  'pd.cortex.sub': 'Where Leadscraper is sharpest about your targeting',
  'pd.cortex.title': 'Leadscraper audience',
  'pd.curve.coldSub': 'Cold',
  'pd.curve.currentRate': 'current match rate',
  'pd.curve.highPct':
    'Leadscraper is hitting at {n}% very accurately: the learning curve takes shape as historical data arrives. ',
  'pd.curve.highPctStrong': 'All on track.',
  'pd.curve.inWeeks': 'in {n} weeks',
  'pd.curve.learningActive': 'Leadscraper is actively learning',
  'pd.curve.liftLabel': 'Improvement since start',
  'pd.curve.liftSub': 'absolute match rate',
  'pd.curve.lockLabel': 'from 50 ratings',
  'pd.curve.lowPct':
    'Leadscraper is collecting the trajectory from your {n} ratings. With more data the trend line will sharpen.',
  'pd.curve.midPct':
    'From your {n} ratings Leadscraper is building the trajectory: the learning curve becomes more visible with each run.',
  'pd.curve.milestone200': '200 ratings',
  'pd.curve.milestone200Sub': 'model stabilized',
  'pd.curve.milestone50': '50 ratings',
  'pd.curve.milestone50Sub': 'first patterns',
  'pd.curve.mockAxisEnd': '50 ratings',
  'pd.curve.mockTitle': 'Match rate over the last 50 ratings',
  'pd.curve.noData': 'Not enough data yet.',
  'pd.curve.start': 'Start',
  'pd.curve.sub': 'How the match rate has evolved with every rating.',
  'pd.curve.subShort': 'How the match rate evolves with each rating',
  'pd.curve.title': 'Learning curve',
  'pd.curve.today': 'Today',
  'pd.curve.todaySub': '{n} ratings',
  'pd.decisions.checked': '{n} candidates reviewed',
  'pd.decisions.checkedSg': '{n} candidate reviewed',
  'pd.decisions.delivered': '{n} delivered',
  'pd.decisions.hint':
    'See a pattern that is wrong? Rephrase your query. Leadscraper takes all these decisions as teaching examples for the next run, once you confirm the audience memory.',
  'pd.decisions.more': '+ {n} more …',
  'pd.decisions.rejected': '{n} rejected',
  'pd.decisions.showAll': 'Show all rejected',
  'pd.decisions.showLess': 'Show less',
  'pd.decisions.title': 'Leadscraper decisions · last run',
  'pd.empty.cta': 'Go to dashboard',
  'pd.empty.desc1': 'An audience is ',
  'pd.empty.desc2':
    ': Leadscraper collects all learnings from your feedback in it. Create your first audience in the dashboard, then you will find all accumulated patterns, assumptions, rejection reasons and run history here.',
  'pd.empty.descStrong': 'a learning container',
  'pd.empty.title': 'No audience created yet',
  'pd.hex.bizModel': 'Biz model',
  'pd.hex.industry': 'Industry',
  'pd.hex.location': 'Location',
  'pd.hex.ownership': 'Ownership',
  'pd.hex.role': 'Role',
  'pd.hex.size': 'Size',
  'pd.leads.sub': 'Preview: the full list lives on the Leads tab.',
  'pd.leads.title': 'Recent leads',
  'pd.leads.viewAll': 'View all',
  'pd.learn.calibratedHint':
    'Leadscraper now actively incorporates your patterns into its reasoning.',
  'pd.learn.coldStartHint': 'Rate more leads so Leadscraper starts recognizing your patterns.',
  'pd.learn.earlyHint': 'With each additional rating, pattern recognition becomes more precise.',
  'pd.learn.emptyDesc1': 'Once you click ',
  'pd.learn.emptyDesc2': ' or ',
  'pd.learn.emptyDesc3':
    ' in the lead list, Leadscraper learns your preferences and shows here what it derives.',
  'pd.learn.emptyFit': 'fit',
  'pd.learn.emptyNotFit': 'not a fit',
  'pd.learn.emptyTitle': 'No feedback given yet',
  'pd.learn.fits': 'Fit',
  'pd.learn.lastRating': 'Last rating ',
  'pd.learn.loadError': 'Error loading',
  'pd.learn.loading': 'Loading feedback learning status…',
  'pd.learn.matchRate': 'Match rate',
  'pd.learn.matchRateSub': 'fit / rated',
  'pd.learn.matureMsg':
    'Profile fully calibrated: Leadscraper treats your patterns almost like rules.',
  'pd.learn.morePrefix': 'Still ',
  'pd.learn.moreSuffix': ' more ratings until stage ',
  'pd.learn.narrativeHide': 'Hide AI briefing',
  'pd.learn.narrativeShow': 'Show AI briefing',
  'pd.learn.narrativeSub':
    'This exact text is passed to Leadscraper AI on the next run, word for word.',
  'pd.learn.negative': 'negative',
  'pd.learn.noData': 'No feedback data available.',
  'pd.learn.noRating': 'No rating yet',
  'pd.learn.notFits': 'Not a fit',
  'pd.learn.positive': 'positive',
  'pd.learn.rated': 'Rated',
  'pd.learn.ratingStatus': 'Rating status',
  'pd.learn.recentTitle': 'Recent ratings',
  'pd.learn.stageCali': 'Calibrated',
  'pd.learn.stageEarly': 'Learning',
  'pd.learn.stageMature': 'Mature',
  'pd.learn.stageNext': 'next stage',
  'pd.learn.topReasons': 'Most common rejection reasons',
  'pd.learn.topReasonsDesc1': 'From your ',
  'pd.learn.topReasonsDesc2':
    ' rejections. Leadscraper remembers these patterns and pushes similar candidates down on the next run.',
  'pd.learn.totalSub': '{n} total',
  'pd.openLeads': 'Open leads',
  'pd.pat.actions': 'Actions',
  'pd.pat.confirm': 'Confirm',
  'pd.pat.confirmT': 'Confirm: adopt as rule',
  'pd.pat.reject': 'Reject',
  'pd.pat.rejectT': 'Reject: delete pattern',
  'pd.pat.remove': 'Remove',
  'pd.pat.weaken': 'Weaken',
  'pd.patterns.medium': 'Medium: plausible, being watched',
  'pd.patterns.strong': 'Strong: reliable rules',
  'pd.patterns.sub': 'Your preferences: extracted from every Fit / Not-fit rating.',
  'pd.patterns.title': 'What Leadscraper has learned',
  'pd.patterns.weak': 'Weak: early signals',
  'pd.queries.dailyLegacy': 'Daily (legacy)',
  'pd.queries.daysAgo': 'started {n} days ago',
  'pd.queries.emptySub': 'Once you start a search, it will appear here, including schedule.',
  'pd.queries.emptyTitle': 'No search started for this audience yet.',
  'pd.queries.everyH': 'Every {n}h',
  'pd.queries.filterEmpty': 'No queries match this filter.',
  'pd.queries.hourly': 'Hourly',
  'pd.queries.inDays': 'in {n} days',
  'pd.queries.inHours': 'in {n}h',
  'pd.queries.inMinutes': 'in {n} min',
  'pd.queries.leadsDelivered': '{n} leads delivered',
  'pd.queries.manual': 'One-time',
  'pd.queries.monthlyLegacy': 'Monthly (legacy)',
  'pd.queries.newSearch': 'Start new search',
  'pd.queries.overdue': 'overdue',
  'pd.queries.paused': 'paused',
  'pd.queries.showAll': 'Show all',
  'pd.queries.sub': 'Click opens details, schedule and search history.',
  'pd.queries.title': 'Search queries of this audience',
  'pd.queries.tomorrow': 'tomorrow',
  'pd.queries.unnamed': 'Unnamed search',

  // W21 Dossier — audience page as a self-writing dossier
  // (Claude design handover 2026-07-03). Surface 1: dossier card.
  'dos.eyebrow': 'Your target audience · written by you and Leadscraper',
  'dos.maturity.coldStart': 'Getting to know you',
  'dos.maturity.early': 'Early picture',
  'dos.maturity.calibrated': 'Calibrated',
  'dos.maturity.mature': 'Mature',
  'dos.ratings': '{n} ratings',
  'dos.matchRate': '{pct}% match rate',
  'dos.weak': 'weak',
  'dos.edit.cta': 'Edit target audience',
  'dos.weave.youSearch': 'You are looking for',
  'dos.weave.vorgabeLabel': 'Your input · from your briefing',
  'dos.weave.withSize': 'with {size} employees',
  'dos.weave.sizeValue': '{range} employees',
  'dos.weave.inRegion': 'in {region}',
  'dos.weave.contact': 'contact person',
  'dos.weave.prefers': 'preferring',
  'dos.weave.and': 'and',
  'dos.weave.weakHint': 'first hint:',
  'dos.legend.you': 'your input',
  'dos.legend.learned': 'learned: number = evidence, clickable',
  'dos.legend.weak': 'weak (1–2 pieces of evidence)',
  'dos.emptyLearned':
    'Nothing learned yet. Rate your first leads below and this dossier starts writing itself.',
  'dos.heartbeat.active': 'Actively learning',
  'dos.heartbeat.waiting': 'Waiting for your first ratings',
  'dos.heartbeat.since': 'since {date}',
  'dos.heartbeat.next': 'next analysis at {n} ratings',
  'dos.proof.title': 'Your {n} accepted companies',
  'dos.proof.openAll': 'View all in the board',
  'dos.error.learn': 'The learning data is unreachable right now.',
  'dos.error.retry': 'Reload',
  'dos.details.show': 'All {n} patterns in detail ↓',
  'dos.details.hide': 'Hide details',
  'dos.aside.patterns': 'Patterns in detail',
  'dos.kpi.title': 'Audience in numbers',
  'dos.kpi.match': 'Match rate',
  'dos.kpi.reachable': 'Reachable',
  'dos.kpi.reachableSub': '{n} of {m} requests',
  'dos.kpi.reachableTeaser': 'After your first contact request',
  'dos.kpi.yield': 'Per search',
  'dos.kpi.yieldSub': '{n} searches',
  'dos.kpi.matchTeaser': 'from {p} ratings',
  'dos.journey.eyebrow': 'How your dossier takes shape',
  'dos.journey.s1': 'Audience described',
  'dos.journey.s1Sub': 'Captured cleanly: Leadscraper knows what to look for.',
  'dos.journey.s2': 'Receive your first leads',
  'dos.journey.s2Sub': 'Start your first search: the first companies arrive within minutes.',
  'dos.journey.s2Done': '{n} leads are ready.',
  'dos.journey.s2Running': 'Your search is running: the first companies will land here shortly.',
  'dos.journey.s2RunningBadge': 'Search running · typically 5–12 min',
  'dos.journey.s3': 'Rate your first {p} leads',
  'dos.journey.s3Progress': '{n} of {p} leads rated',
  'dos.journey.s3Sub':
    'At {p} ratings Leadscraper writes its first assessment here. From {a} on, your feedback shapes every further search.',
  'dos.voice.preview':
    'After your first {p} ratings, Leadscraper writes its assessment of your audience here.',
  'dos.voice.more': 'Read more',
  'dos.voice.less': 'Show less',
  'dos.analysis.pending':
    'Leadscraper is analysing your {n} ratings: the first assessment of your audience will appear here shortly.',
  'dos.heartbeat.analysing': 'Analysing your ratings …',
  // Dossier — evidence popover
  'dos.popover.close': 'Close',
  'dos.popover.evidence': '{n} pieces of evidence',
  'dos.popover.weakChip': 'weak · {n} pieces of evidence',
  'dos.popover.view': 'view ↗',
  'dos.popover.noExamples':
    'No individual evidence leads are stored for this pattern: the number counts your ratings.',
  'dos.popover.weakNote': 'Only {n} pieces of evidence, still feeds into the search cautiously.',
  // Dossier — surface 2: rate now
  'dos.rate.eyebrow': 'Rate now',
  'dos.rate.waiting': '{n} leads are waiting for your verdict',
  'dos.rate.waitingOne': '1 lead is waiting for your verdict',
  'dos.rate.openBoard': 'Open all in the board →',
  'dos.rate.sub': 'Every rating sharpens the dossier, right here, without leaving the page.',
  'dos.rate.fits': 'Fits my target audience',
  'dos.rate.fitsNot': "Doesn't fit",
  'dos.rate.view': 'view',
  'dos.rate.acceptedCheck': '✓ Accepted',
  'dos.rate.learned': ', the dossier learned:',
  'dos.rate.flowsIn': ', feeds into the next analysis.',
  'dos.rate.undo': 'Undo',
  'dos.rate.whyQuestion': 'What was off? One tap is enough: Leadscraper learns from it.',
  'dos.rate.noReason': 'Continue without a reason',
  'dos.rate.allDone': 'Everything rated: new leads appear here as soon as a search delivers.',
  'dos.rate.rejectedCheck': '✗ Filtered out',
  'dos.rate.avoidedLearned': ', the dossier now avoids:',
  'dos.reason.industry': 'Wrong industry',
  'dos.reason.tooBig': 'Too big',
  'dos.reason.tooSmall': 'Too small',
  'dos.reason.region': 'Wrong region',
  'dos.reason.role': 'Wrong role',
  'dos.reason.other': 'Other',
  // Dossier — surface 3: next searches
  'dos.sug.eyebrow': 'Derived from your patterns',
  'dos.sug.title': 'Your next searches',
  'dos.sug.basis.expansion': 'Expansion',
  'dos.sug.basis.crossSell': 'Cross-sell',
  'dos.sug.basis.zoomOut': 'Zoom out',
  'dos.sug.basis.patternHint': 'Pattern hint',
  'dos.sug.basis.salesFit': 'Sales fit',
  'dos.sug.tier.veryStrong': 'very strong',
  'dos.sug.tier.strong': 'strong',
  'dos.sug.tier.solid': 'solid',
  'dos.sug.tier.hypothesis': 'weak',
  'dos.sug.fitLabel': 'expected fit',
  'dos.sug.start': 'Start search',
  'dos.sug.history': '{n} previous searches',
  'dos.sug.historyOne': '1 previous search',
  'dos.sug.showHistory': 'View history →',
  'pd.queries.weeklyLegacy': 'Weekly (legacy)',
  'pd.ratings': '{n} ratings',
  'pd.rej.agency_not_operator': 'Agency, not operator',
  'pd.rej.consultant_not_operator': 'Consultant, not operator',
  'pd.rej.duplicate_previous_session': 'Already delivered',
  'pd.rej.insufficient_data': 'Insufficient data',
  'pd.rej.learned_rejection_pattern': 'Matched your rejection pattern',
  'pd.rej.low_confidence': 'Too uncertain',
  'pd.rej.outside_radius': 'Outside radius',
  'pd.rej.wrong_company_form': 'Wrong legal form',
  'pd.rej.wrong_industry': 'Wrong industry',
  'pd.rej.wrong_region': 'Wrong region',
  'pd.rej.wrong_role': 'Wrong role',
  'pd.rej.wrong_size': 'Wrong size',
  'pd.runs': '{n} search runs',
  'pd.screenLabel': 'Audience details',
  'pd.side.accepted': '({n} accepted)',
  'pd.side.feedbacks': 'Ratings',
  'pd.side.firstRun': 'First run',
  'pd.side.focus': 'Search focus',
  'pd.side.lastRun': 'Last run',
  'pd.side.lastRunLeads': '{n} leads',
  'pd.side.leadsTotal': 'Total leads',
  'pd.side.matchMiss': 'Fit / Not',
  'pd.side.matchRate': 'Match rate',
  'pd.side.next1.d': 'At a {pct} % match rate, 50–100 fresh leads pay off.',
  'pd.side.next1.t': 'Start a search run',
  'pd.side.next2.d': 'That way Leadscraper learns faster.',
  'pd.side.next2.t': 'Review unconfirmed patterns',
  'pd.side.next3.d': 'The more ratings, the more precise.',
  'pd.side.next3.t': 'Keep giving feedback',
  'pd.side.patterns': 'Patterns',
  'pd.side.patternsSub': '{strong} strong · {medium} medium',
  'pd.side.reasons': 'Common rejection reasons',
  'pd.side.recommended': 'Recommended',
  'pd.side.snapshot': 'At a glance',
  'pd.target.contacts': 'Contacts',
  'pd.target.excluded': 'Excluded',
  'pd.target.industry': 'Industry',
  'pd.target.leads': 'Leads',
  'pd.target.patterns': 'Patterns',
  'pd.target.queries': 'Queries',
  'pd.target.region': 'Region',
  'pd.target.size': 'Size',
  'pd.target.sub': 'What Leadscraper uses as basis for every search.',
  'pd.target.title': 'Target audience',
  'pd.time.daysAgo': '{n} days ago',
  'pd.time.hoursAgo': '{n}h ago',
  'pd.time.justNow': 'just now',
  'pd.time.minsAgo': '{n} min ago',
  'pd.toast.confirmed': 'Pattern confirmed: applied from now on as a reliable rule',
  'pd.toast.rejected': 'Pattern rejected',
  'pd.toast.removed': 'Pattern removed',
  'pd.toast.weakened': 'Pattern weakened: will be observed anew',

  'price.afterThen': 'Then {price} / month · cancel anytime',
  'price.badge.popular': 'Popular',
  'price.badge.recommended': 'Recommended',
  'price.badge.yourPlan': 'Your plan',
  'price.ctaStartTrial': 'Start 3 days free',
  'price.ctaSwitchPlan': 'Switch plan',
  'price.ctaDowngradeScheduled': 'Change already scheduled',
  'price.ctaCurrentPlan': 'Current plan',
  'price.ctaTopUp': 'Top up now',
  'price.heroSub': 'More leads: exactly when you need them.',
  'price.heroTrial': 'Choose your plan: the first 3 days are free.',
  'price.leads': 'Leads',
  'price.monthlyCancelable': 'cancel monthly',
  'price.oneTime': 'one-time',
  'price.pack.1000.tag': 'Perfect to get started',
  'price.pack.10000.tag': 'For continuous lead generation',
  'price.pack.5000.tag': 'For first scaled campaigns',
  'price.pack.50000.tag': 'For high volume and teams',
  'price.perLead': '€ / lead',
  'price.perMonth': '/month',
  'price.perMonthLong': '/ month',
  'price.plan.basic.f1': '100 qualified leads per month',
  'price.plan.basic.f2': '1 active audience',
  'price.plan.basic.f3': 'Leadscraper AI with continuous learning',
  'price.plan.basic.f4': 'CRM integrations (HubSpot, Pipedrive, Salesforce …)',
  'price.plan.basic.f5': 'Email support',
  'price.plan.basic.tag': 'To get started with one audience',
  'price.plan.growth.f1': '500 qualified leads per month',
  'price.plan.growth.f2': 'Unlimited audiences',
  'price.plan.growth.f3': 'Leadscraper AI with team memory',
  'price.plan.growth.f4': 'All CRM integrations + webhooks',
  'price.plan.growth.f5': 'Dedicated account manager',
  'price.plan.growth.f6': 'API access',
  'price.plan.growth.tag': 'For scaling sales teams',
  'price.plan.starter.f1': '250 qualified leads per month',
  'price.plan.starter.f2': '3 active audiences',
  'price.plan.starter.f3': 'Leadscraper AI with prioritized learning',
  'price.plan.starter.f4': 'All CRM integrations',
  'price.plan.starter.f5': 'Priority support',
  'price.plan.starter.f6': 'Export to CSV, XLSX, JSON',
  'price.plan.starter.tag': 'Best value for money',
  'price.selected': 'Selected:',
  'price.subOneoffDesc':
    'Additional leads as a one-off package: no contract, no lock-in. Credits never expire.',
  'price.subTrialDesc':
    'With real leads, your target groups and your own Leadscraper memory. Unusable leads are refunded, no questions asked.',
  'price.tab.afterSub': '(after subscription)',
  'price.tab.lockNote': 'Available after subscription',
  'price.tab.oneoff': 'One-off packages',
  'price.tab.sub': 'Subscriptions',
  'price.testLeads': 'trial leads',
  'price.then': 'then',
  'price.trial3days': '3 days free',
  'price.trialIncl': 'incl.',
  'price.trust.cancel.s': 'Monthly cancellation, no hidden fees, no minimum term.',
  'price.trust.cancel.t': 'Cancel anytime',
  'price.trust.gdpr.s': 'All data EU-hosted, encrypted, never shared with third parties.',
  'price.trust.gdpr.t': 'GDPR-compliant',
  'price.trust.refund.s': "If a lead doesn't fit, the credit comes back instantly.",
  'price.trust.refund.t': 'Bad leads? Refunded.',

  'pricing.beta.headline': 'Your beta access to Leadscraper',
  'pricing.beta.subText': 'Growth plan with 55% off your first month, exclusive for beta testers.',
  'pricing.mai.headline': 'Your unfair competitive edge starts here.',
  'pricing.mai.subText': 'Save 74 % in the first month, switch or cancel anytime with one click.',
  'pricing.trial50.headline': '50 B2B leads worth € 100, on the house.',
  'pricing.trial50.subText': '50 leads on us: 3-day test, cancel anytime.',

  'reject.alreadyKnown': 'Already Known',
  'reject.alreadyKnown.hint':
    "Already in your CRM or contacted before: no learning signal, and doesn't count against your match rate.",
  'reject.badData': 'Bad Data',
  'reject.badData.hint': 'Address, name, or contact info is incorrect',
  'reject.noBuyingSignal': 'No Recognizable Demand',
  'reject.noBuyingSignal.hint': 'No trigger events, no open positions, no growth signal',
  'reject.notOperator': 'Not an Operator',
  'reject.notOperator.hint': 'Agency, broker, or developer instead of operational provider',
  'reject.other': 'Other Reason',
  'reject.other.hint': 'Briefly explain why below (free text)',
  'reject.wrongIndustry': 'Wrong Industry',
  'reject.wrongIndustry.hint': 'Leadscraper misidentified the business field',
  'reject.wrongOwnership': 'Wrong Ownership Structure',
  'reject.wrongOwnership.hint':
    'Corporate subsidiary instead of family business, wrong legal form, etc.',
  'reject.wrongRegion': 'Wrong Location',
  'reject.wrongRegion.hint': "HQ / region doesn't match search criteria",
  'reject.wrongRole': 'Wrong Contact Person',
  'reject.wrongRole.hint': 'Person or role is not the decision-maker',
  'reject.wrongSize': 'Wrong Company Size',
  'reject.wrongSize.hint': 'Too small, too large, or corporation instead of SME',

  'rel.daysAgo': '{n} days ago',
  'rel.hAgo': '{n}h ago',
  'rel.minAgo': '{n} min ago',
  'rel.now': 'just now',
  'rel.weeksAgo': '{n} weeks ago',
  'rel.yesterday': 'yesterday',

  'repeat.amountHint': 'More leads = broader coverage, fewer leads = higher quality per lead.',
  'repeat.amountLabel': 'How many leads do you want?',
  'repeat.cancel': 'Cancel',
  'repeat.paramsLabel': 'Parameters from this run',
  'repeat.prediction.basedOn': 'based on your current match rate',
  'repeat.prediction.credits': 'credits',
  'repeat.prediction.matches': 'expected matches',
  'repeat.prediction.time': 'estimated runtime',
  'repeat.prediction.title': 'Expected outcome',
  'repeat.preset': 'Presets',
  'repeat.start': 'Start run',
  'repeat.sub': 'Parameters are pre-filled: tweak them or start right away.',
  'repeat.title': 'Repeat search run',
  'repeat.toast': 'Run started: results in a few minutes.',

  'res.acceptedNote': 'Leadscraper learns from this acceptance.',
  'res.breadcrumb': 'Search results · {profile}',
  'res.cancel': 'Cancel',
  'res.density.comfortable': 'Comfortable',
  'res.density.compact': 'Compact',
  'res.employees': 'Employees',
  'res.fb.all': 'All',
  'res.fb.new': 'New to you',
  'res.fb.status': 'Feedback status',
  'res.filter': 'Filter',
  'res.fit': 'Fit',
  'res.footer':
    'Leadscraper reviewed another 406 entries. The {count} shown here are the ones that best match your feedback so far.',
  'res.fromMem': 'from your memory: „{text}"',
  'res.learning.body':
    'New signal over the past two weeks: you accept businesses with their own printing or die-cutting more often than pure converters.',
  'res.learning.title': 'What Leadscraper is learning',
  'res.location': 'Location',
  'res.new': 'New',
  'res.notFit': 'Not a fit',
  'res.openDetails': 'Open details →',
  'res.pickReason': 'Pick a reason →',
  'res.reasonHint': 'One click is enough: your reason sharpens what you see tomorrow.',
  'res.rejectedNote': 'Reason saved. That sharpens your memory.',
  'res.sector': 'Sector',
  'res.summary':
    '{count} leads out of 412 reviewed. Each comes with one sentence on why it fits you: your „Fit / Not fit" sharpens what you see tomorrow.',
  'res.title': 'Leads: {profile}',
  'res.toast.accepted': '"{company}" saved as a fit. Leadscraper sharpens your audience.',
  'res.toast.rejected': 'Reason „{reason}" saved. Similar leads will become rarer.',
  'res.uncertainty': 'Leadscraper is {score} here: {text}.',
  'res.whyNotTitle': 'Why is this lead not a fit?',

  'run.complete': 'Search complete: {count} leads delivered.',
  'run.completeEmpty':
    'Search complete: no matching companies found. Refine your target audience or try a different region.',
  'run.cta.broaden_query': 'Broaden your query',
  'run.cta.edit_query': 'Adjust query',
  'run.cta.retry': 'Try again',
  'run.failed.body':
    'Technical hiccup during the last search. Wait 1–2 minutes and try again. If it keeps hanging, let us know.',
  'run.failed.title': 'Leadscraper got stuck',
  'run.no_leads_delivered': 'No matching leads delivered',
  'run.no_results.body':
    'Your keywords didn\'t return matching German B2B companies on Google. Try more common terms, e.g. "carpentry" instead of "furniture manufactory", or expand the region.',
  'run.no_results.title': 'No web results found for your query',
  'run.partial_yield.body':
    'Leadscraper found fewer than 10 matches. For more volume: loosen your description or broaden the region.',
  'run.partial_yield.title': '{delivered}/{total} leads delivered',
  'run.searching': 'Leadscraper is searching for you…',
  'run.startFailed': 'The search could not be started. Please try again.',
  'run.too_strict.body':
    'Leadscraper found companies, but none cleanly matched your target audience. Your description might be too narrow: try a larger region, loosen employee count, or remove some details.',
  'run.too_strict.title': '{reasoned} candidates checked: none matched your audience',

  'runs.delivered': '{n} leads delivered',
  'runs.deliveredOne': '1 lead delivered',
  'runs.empty': 'No runs yet for this search.',
  'runs.evaluated': '{n} evaluated',
  'runs.failed': 'failed',
  'runs.harvested.body':
    'Earlier runs already delivered {n} matching companies: Leadscraper already knows all known matches. New matches appear when new companies in your target group become visible online. The schedule picks them up automatically.',
  'runs.harvested.title': 'Target group temporarily exhausted',
  'runs.last': 'latest',
  'runs.loadError': 'Error loading',
  'runs.loadFailed': 'Could not load history: {err}',
  'runs.loading': 'Loading history…',
  'runs.noHits': 'no matches',
  'runs.running': 'running now',
  'runs.unfeasible': 'not feasible',

  'sched.autoPush': 'Automatically push new leads to CRM',
  'sched.autoPushNoCRM': 'Connect a CRM in your account settings first to enable auto-push.',
  'sched.autoPushSub':
    'Whenever Leadscraper finishes a scheduled run, all found leads will be automatically sent to your connected CRM.',
  'sched.daily': 'Daily',
  'sched.dailySub': 'Every day at the same time',
  'sched.day.fri': 'Friday',
  'sched.day.fri.short': 'Fri',
  'sched.day.mon': 'Monday',
  'sched.day.mon.short': 'Mon',
  'sched.day.sat': 'Saturday',
  'sched.day.sat.short': 'Sat',
  'sched.day.sun': 'Sunday',
  'sched.day.sun.short': 'Sun',
  'sched.day.thu': 'Thursday',
  'sched.day.thu.short': 'Thu',
  'sched.day.tue': 'Tuesday',
  'sched.day.tue.short': 'Tue',
  'sched.day.wed': 'Wednesday',
  'sched.day.wed.short': 'Wed',
  'sched.dayOfMonth': 'Day of month',
  'sched.monthly': 'Monthly',
  'sched.monthlySub': 'Every month on the chosen date',
  'sched.nextRun': 'Next run',
  'sched.once': 'One-time',
  'sched.onceSub': 'Run once now',
  'sched.rel.inDays': 'in {n} days',
  'sched.rel.overdue': 'overdue',
  'sched.rel.soon': 'soon',
  'sched.rel.tomorrow': 'tomorrow',
  'sched.section': 'Recurrence',
  'sched.sectionSub': 'Let Leadscraper run this search automatically on a schedule.',
  'sched.time': 'Start time',
  'sched.toast.created': 'Scheduled run created: runs automatically from now on.',
  'sched.toast.deleted': 'Scheduled run deleted.',
  'sched.toast.paused': 'Scheduled run paused.',
  'sched.toast.resumed': 'Scheduled run resumed.',
  'sched.weekday': 'Weekday',
  'sched.weekly': 'Weekly',
  'sched.weeklySub': 'Every week on the chosen day',

  'schedCard.creditsHint':
    'max. {n} credits / day: once no new leads are found in your target group, Leadscraper runs idle with no credit usage.',
  'schedCard.errorToast': 'Save failed: {err}',
  'schedCard.freq.every': 'Every {n} hours',
  'schedCard.freq.everyShort': 'every {n}h',
  'schedCard.freq.hourly': 'Hourly',
  'schedCard.freq.everyMinute': 'Every minute (Test)',
  'schedCard.minuteTestHint':
    'Test mode: fires ~every minute once the scheduler tick runs. Staging only.',
  'schedCard.freq.hourlyShort': 'every hour',
  'schedCard.leadsPerDay': '~{n} leads / day',
  'schedCard.nextLabel': 'next run {when}',
  'schedCard.nextRun.days': 'in {n} days',
  'schedCard.nextRun.hours': 'in {n}h',
  'schedCard.nextRun.min': 'in {n} min',
  'schedCard.nextRun.overdue': 'overdue',
  'schedCard.nextRun.tomorrow': 'tomorrow',
  'schedCard.noRepeat': 'No repetition',
  'schedCard.offBody': 'One-time: you start it yourself, whenever you want.',
  'schedCard.onBody': 'Runs in the background. New matches land automatically in your lead list.',
  'schedCard.perWeek': '≈ {n} / week',
  'schedCard.repeat': 'Repeat this search',
  'schedCard.save': 'Save',
  'schedCard.savedToast': 'Schedule saved.',
  'schedCard.saving': 'Saving…',

  'schedRuns.col.action': '',
  'schedRuns.col.crm': 'CRM push',
  'schedRuns.col.frequency': 'Frequency',
  'schedRuns.col.leads': 'Leads/run',
  'schedRuns.col.nextRun': 'Next run',
  'schedRuns.col.params': 'Parameters',
  'schedRuns.count': 'active',
  'schedRuns.crm.no': 'Off',
  'schedRuns.crm.yes': 'On',
  'schedRuns.delete': 'Delete',
  'schedRuns.empty.sub':
    'Enable "Recurrence" on your next search to fetch leads on a regular schedule.',
  'schedRuns.empty.title': 'No scheduled runs yet',
  'schedRuns.freq.daily': 'Daily · {time}',
  'schedRuns.freq.monthly': '{day} of each month · {time}',
  'schedRuns.freq.weekly': '{day} · {time}',
  'schedRuns.pause': 'Pause',
  'schedRuns.resume': 'Resume',
  'schedRuns.status.paused': 'Paused',
  'schedRuns.sub': 'Recurring runs that automatically pull new leads into this audience.',
  'schedRuns.title': 'Scheduled searches',

  'so.close.btn': 'Let it continue in background',
  'so.close.hint': 'You can keep working: Leadscraper will notify you when new leads are ready.',
  'so.funnel.analyzed': 'Deep analyzed',
  'so.close.trust': 'Public sources only · every data point is cited in the lead.',
  'so.funnel.evaluated': 'Evaluated',
  'so.funnel.identified': 'Identified',
  'so.funnel.ready': 'Ready',
  'so.hero.elapsed': 'Time since start:',
  'so.hero.inFocus': 'companies in focus',
  'so.hero.preparing': 'Leadscraper is checking your query',
  'so.hero.reflecting': 'Leadscraper is considering a new plan',
  'so.hero.round': '(Round {n})',
  'so.hero.searching': 'Leadscraper is searching for you',
  'so.live.title': 'Leadscraper working live',
  'so.query.title': 'Your search query',
  'so.reflector.title': 'Leadscraper discarded the first approach',
  'so.step.delivery.sub': 'Top matches are sorted + delivered for you',
  'so.step.delivery.title': 'Compiling leads',
  'so.step.discovery.sub': 'Top candidates from web search + industry directories',
  'so.step.discovery.title': 'Identifying companies',
  'so.step.done.sub': 'Search run completed',
  'so.step.done.title': 'Done',
  'so.step.enriching.sub': 'Acquisition plan, scores + deep research for the 10 leads',
  'so.step.enriching.title': 'Cortex still enriching',
  'so.step.enriching.title.light': 'Verifying basic data',
  'so.step.hydration.sub': 'Websites + Impressum + Career + Team + News',
  'so.step.hydration.title': 'Deep-analyzing companies',
  'so.step.planning.sub': 'Analyzing your learnings + planning search strategies',
  'so.step.planning.title': 'Leadscraper remembers',
  'so.step.reasoning.sub': 'Leadscraper checks each candidate against your audience',
  'so.step.reasoning.title': 'Leadscraper evaluates',

  'src.derived': 'By Leadscraper',
  'src.directory': 'Directory',
  'src.news': 'Trade press',
  'src.official': 'Official',
  'src.web': 'Company site',

  'trial.afterNote': 'After that, your {plan} plan continues automatically, cancel anytime.',
  'trial.day1': '1 day left',
  'trial.daysN': '{n} days left',
  'trial.freeTest': 'of free trial.',
  'trial.leadsLeft': '{left} / {total} trial leads left',
  'trial.phase': 'Trial',
  'trial.secureSub': 'Start subscription',
  // LEA-324: SEPA subscription "payment processing" banner.
  'bill.sepaProcessing.badge': 'Payment processing',
  'bill.sepaProcessing.title': 'Your SEPA payment is processing: your access is already unlocked.',
  'bill.sepaProcessing.note':
    'The debit can take 2–5 business days. You can use Leadscraper in full right now.',

  // ─── Transactional email — shared strings ────────────────────────────────
  // LEA-295: extracted from packages/email-templates/src/templates/*.de.html.
  // Values containing {{var}} mustache placeholders are resolved by
  // packages/email-templates/src/index.ts:interpolate() at render time.
  'email.shared.brand.name': 'Leadscraper',
  'email.shared.founder.name': 'Janik Deimann',
  'email.shared.founder.title': 'Founder, Leadscraper',
  'email.shared.reply_note': 'Questions? Just reply to this email.',
  'email.sepa-payment-failed.subject': 'Your SEPA payment failed',
  'email.sepa-payment-failed.preheader': 'The direct debit of {{amount_formatted}} was returned.',
  'email.sepa-payment-failed.badge': 'Payment failed',
  'email.sepa-payment-failed.hero': 'Your direct debit<br>was returned.',
  'email.sepa-payment-failed.greeting': 'Hi {{first_name}},',
  'email.sepa-payment-failed.intro':
    'the SEPA direct debit for your credit pack did not go through at your bank.',
  'email.sepa-payment-failed.credits_line':
    'We have therefore removed {{credits_revoked}} credits from your account.',
  'email.sepa-payment-failed.retry_line':
    'If you need the credits, you can simply buy the pack again in your account.',
  'email.sepa-payment-failed.button': 'Open Leadscraper',
  'email.sepa-payment-failed.detail.pack_label': 'Pack',
  'email.sepa-payment-failed.detail.amount_label': 'Amount',
  'email.shared.footer.transactional':
    "You're receiving this email because you registered for a Leadscraper account. This transactional message is part of the contract relationship and can't be unsubscribed.",
  'email.shared.footer.legal':
    'Deimann Com GmbH &middot; Randstraße 75 &middot; 22525 Hamburg &middot; Germany<br />Managing Director: Janik Deimann &middot; HRB 164162 (AG Hamburg) &middot; VAT ID DE332747716 &middot; © {{year}}',

  // ─── Transactional email — welcome (LEA-259 design) ──────────────────────
  'email.welcome.subject': 'Welcome to Leadscraper, {{first_name}} 👋',
  'email.welcome.title': 'Welcome to Leadscraper',
  'email.welcome.preheader': 'Welcome aboard: your first leads in 5 minutes.',
  'email.welcome.badge': 'Account ready',
  'email.welcome.hero': 'Glad to have you here,<br>{{first_name}}.',
  'email.welcome.subhead':
    "Your account is set up and your first credits are ready: let's get going.",
  'email.welcome.steps.title': 'Get started in 5 steps',
  'email.welcome.steps.1.title': 'Add your website',
  'email.welcome.steps.1.body':
    'So the agent understands what your business is about, and what to look for.',
  'email.welcome.steps.2.title': 'Define your target audience',
  'email.welcome.steps.2.body':
    'Industry, region, company size, job title: the more specific, the better the matches.',
  'email.welcome.steps.3.title': 'Run your first lead request',
  'email.welcome.steps.3.body':
    'The agent researches, enriches, and delivers the first companies straight to your dashboard.',
  'email.welcome.steps.4.title': 'Rate the leads',
  'email.welcome.steps.4.body':
    'Thumbs up or down: the agent learns from every bit of feedback what fits you.',
  'email.welcome.steps.5.title': 'Run the next request',
  'email.welcome.steps.5.body':
    "With every run the results get noticeably sharper, until they're a 100 % fit for you.",
  'email.welcome.cta.primary': 'To the dashboard',
  'email.welcome.signoff.line': "Questions? Just reply to this email: I'm reading along.",

  // ─── Transactional email — subscription-cancelled (LEA-259 design) ──────
  'email.subscription-cancelled.subject':
    'Sorry to see you go, {{first_name}}: cancellation confirmed',
  'email.subscription-cancelled.title': 'Your subscription is cancelled',
  'email.subscription-cancelled.preheader': "We've received your cancellation.",
  'email.subscription-cancelled.badge': 'Cancellation confirmed',
  'email.subscription-cancelled.hero': 'Sorry to see you go,<br>{{first_name}}.',
  'email.subscription-cancelled.subhead':
    "We've received your cancellation. Your {{plan_name}} access stays active until {{access_until}}.",
  'email.subscription-cancelled.subhead_trial':
    'We have received your cancellation. Your trial has ended and nothing will be charged.',
  'email.subscription-cancelled.note_trial':
    'If you want to continue later, you can reactivate your subscription in your account.',
  'email.subscription-cancelled.summary.plan_label': 'Plan',
  'email.subscription-cancelled.summary.until_label': 'Access until',
  'email.subscription-cancelled.note':
    'You keep full access until then. After that, your data is deleted per our privacy policy.',
  'email.subscription-cancelled.signoff.line':
    "What could we have done better? Just reply to this email: I'm reading along.",
  'email.subscription-cancelled.cta.primary': 'Back to the product &amp; reactivate',
  'email.subscription-cancelled.cta.note':
    "You'll land in the dashboard where you can reactivate your subscription.",
  'email.subscription-cancelled.footer.transactional':
    "You're receiving this email as confirmation of your cancellation. This transactional message is part of the contract relationship and can't be unsubscribed.",

  // LEA-333: pause confirmation + pause-ending-soon.
  'email.subscription-paused.subject': 'Your subscription is paused',
  'email.subscription-paused.badge': 'Subscription paused',
  'email.subscription-paused.hero': 'Your subscription<br>is now on pause.',
  'email.subscription-paused.detail.plan_label': 'Plan',
  'email.subscription-paused.detail.until_label': 'Paused until',
  'email.subscription-paused.preheader': 'No charges until {{pause_ends_at}}.',
  'email.subscription-paused.greeting': 'Hi {{first_name}},',
  'email.subscription-paused.intro':
    "your {{plan_name}} subscription is now paused. You won't be charged until {{pause_ends_at}}.",
  'email.subscription-paused.access':
    "You keep full access and your remaining credits: you just won't receive new monthly credits.",
  'email.subscription-paused.resume_note':
    'On {{pause_ends_at}} your subscription resumes automatically. You can resume or cancel any time before then.',
  'email.subscription-paused.button': 'Manage subscription',
  'email.subscription-paused.signoff': 'See you soon, the Leadscraper team',

  'email.subscription-pause-ending.subject': 'Your subscription resumes soon',
  'email.subscription-pause-ending.preheader': 'Your pause ends on {{resumes_at}}.',
  'email.subscription-pause-ending.greeting': 'Hi {{first_name}},',
  'email.subscription-pause-ending.intro':
    'a quick reminder: your pause ends on {{resumes_at}}. Your {{plan_name}} subscription will then resume automatically.',
  'email.subscription-pause-ending.charge_note':
    "Billing restarts as normal from then. If you'd rather not resume, you can cancel before that date.",
  'email.subscription-pause-ending.button': 'Manage subscription',
  'email.subscription-pause-ending.signoff': 'The Leadscraper team',

  // ─── Transactional email — payment-failed / dunning (LEA-304 design) ─────
  // "of 3" is intentionally baked into the copy (not a variable): the Stripe
  // Smart-Retries count practically never changes. If it does, it's a one-line
  // edit per language — see LEA-304.
  'email.payment-failed.subject': 'Your payment failed. Please update your details',
  'email.payment-failed.title': 'Payment failed. Please update',
  'email.payment-failed.preheader':
    "We couldn't charge {{amount_formatted}} for your {{plan_name}} plan. Please update your payment details.",
  'email.payment-failed.badge': 'Payment failed',
  'email.payment-failed.hero': "Your payment didn't go through, {{first_name}}.",
  'email.payment-failed.subhead':
    'We couldn\'t charge <strong style="color:#0B0F19;">{{amount_formatted}}</strong> for your {{plan_name}} plan. Update your payment details to avoid an interruption to your leads.',
  'email.payment-failed.summary.plan_label': 'Plan',
  'email.payment-failed.summary.amount_label': 'Amount due',
  'email.payment-failed.summary.attempt_label': 'Attempt',
  'email.payment-failed.summary.attempt_value': '{{attempt_count}} of 3',
  'email.payment-failed.summary.next_label': 'Next attempt',
  'email.payment-failed.cta.primary': 'Update payment details now',
  'email.payment-failed.reassurance':
    'It takes less than a minute, then everything continues as usual. Questions? Just reply to this email.',
  'email.payment-failed.footer.transactional':
    "You're receiving this email because a payment for your Leadscraper subscription failed. This transactional message is part of the contract relationship and can't be unsubscribed.",

  // ─── Transactional email — trial-ending-soon (LEA-295) ─────
  'email.trial-winback.subject': 'If it was just the fear of getting charged …',
  'email.trial-winback.badge': 'Your account is still here',
  'email.trial-winback.hero': '30% off if you<br>want to continue.',
  'email.trial-winback.preheader': 'Come back — 30% off for 3 months, your account is still there.',
  'email.trial-winback.greeting': 'Hi {{first_name}},',
  'email.trial-winback.intro':
    'you ended your trial right away yesterday — completely fine, that is exactly what the button is for. But if it was only about avoiding an unwanted charge: your account is still there, with everything you set up.',
  'email.trial-winback.offer':
    'If you want to continue: {{plan_name}} at 30% off for 3 months. No new forms — your card is on file.',
  'email.trial-winback.button': 'View offer & reactivate',
  'email.trial-winback.transparency':
    'The click charges nothing — you first see the price and the charge date, then confirm yourself. Link: {{winback_url}}',
  'email.trial-winback.signoff': 'Janik',
  'email.trial-ending-soon.cancel_note':
    "Don't want to continue? Cancel with one click, before the first charge: {{cancel_link}}",
  'email.trial-ending-soon.cancel_link_label': 'Cancel your trial',
  'email.trial-ending-soon.subject': 'Your trial ends soon',
  'email.trial-ending-soon.preheader': 'Trial ends {{trial_ends_at}}. Pick a plan now.',
  'email.trial-ending-soon.greeting': 'Hi {{first_name}},',
  'email.trial-ending-soon.intro':
    'your {{plan_name}} trial ends on {{trial_ends_at}}. You have {{credits_remaining}} credits left.',
  'email.trial-ending-soon.why':
    'Once the trial ends, your account becomes read-only: you can keep viewing past leads, but new searches pause.',
  'email.trial-ending-soon.cta':
    'If results are working for you: pick a plan now so things keep flowing.',
  'email.trial-ending-soon.button': 'Choose a plan',
  'email.trial-ending-soon.signoff': 'Janik',

  // ─── Transactional email — trial-ended (LEA-295) ─────
  'email.trial-ended.subject': 'Your trial has ended',
  'email.trial-ended.badge': 'Trial ended',
  'email.trial-ended.hero': 'Your trial<br>is over.',
  'email.trial-ended.preheader': 'Your trial ended: account is read-only.',
  'email.trial-ended.greeting': 'Hi {{first_name}},',
  'email.trial-ended.intro':
    'your {{plan_name}} trial just ended. Your account is now read-only: you can still see all past leads, but new searches are paused.',
  'email.trial-ended.cta':
    'Pick a plan to continue immediately. Your data + learning memory stay intact.',
  'email.trial-ended.button': 'Choose a plan',
  'email.trial-ended.signoff': 'See you soon.<br>Janik',

  // ─── Transactional email — verify-email (LEA-295) ─────
  'email.verify-email.subject': 'Confirm your email address',
  'email.verify-email.badge': 'Almost there',
  'email.verify-email.hero': 'Confirm your<br>email address.',
  'email.verify-email.preheader': 'Confirm your email to activate Leadscraper.',
  'email.verify-email.greeting': 'Hi {{first_name}},',
  'email.verify-email.body':
    'tap the button below to confirm your email and activate your Leadscraper account.',
  'email.verify-email.button': 'Confirm email',
  'email.verify-email.fallback_note':
    "If the button doesn't work, paste this link into your browser:",
  'email.verify-email.ttl_note': 'This link expires in {{verify_expires_in}}.',
  'email.verify-email.ttl_default': '24 hours',
  'email.verify-email.ignore_note': "Didn't create a Leadscraper account? Just ignore this email.",

  // ─── Transactional email — refund-confirmation (LEA-295) ─────
  'email.refund-confirmation.subject': 'Refund confirmed',
  'email.refund-confirmation.preheader': 'Refund: {{amount_formatted}}',
  'email.refund-confirmation.greeting': 'Hi {{first_name}},',
  'email.refund-confirmation.intro': "we've refunded {{amount_formatted}} to you.",
  'email.refund-confirmation.refunded_line':
    'Posted on {{refunded_at}} to your original payment method. Banks typically reflect this within 3-10 business days.',
  'email.refund-confirmation.clawback_yes':
    'Since the refund cancels the related credits, {{credits_clawed_back}} credits were removed from your account.',
  'email.refund-confirmation.clawback_no': 'Your credits remain untouched.',
  'email.refund-confirmation.reason_line': 'Reason: {{reason}}.',
  'email.refund-confirmation.outro': 'Questions? Just reply to this email.',
  'email.refund-confirmation.footer':
    'You receive this because a refund was issued for your Leadscraper account.',

  // ─── Transactional email — password-reset (LEA-259 design) ──────────────
  'email.password-reset.subject': 'Reset your password: link valid for {{expires_in}}',
  'email.password-reset.title': 'Reset your password',
  'email.password-reset.preheader': 'Reset your password securely. Link expires in {{expires_in}}.',
  'email.password-reset.badge': 'Reset password',
  'email.password-reset.hero': 'Set a new<br>password.',
  'email.password-reset.body':
    'Someone requested to reset your password. If that was you, just click the button. If not, ignore this email: your password stays unchanged.',
  'email.password-reset.expires': 'The link expires in {{expires_in}}.',
  'email.password-reset.cta.primary': 'Reset password',
  'email.password-reset.signoff.line':
    'Questions about account security? Just reply to this email.',
  'email.password-reset.footer.transactional':
    "For security reasons, this email includes information about the request. Don't share it with anyone. This security notification is part of the contract relationship and can't be unsubscribed.",

  // ─── Transactional email — security-alert (LEA-264 design) ──────────────
  // EN strings below are mirrored VERBATIM from security-alert.en.html so
  // the EN baseline stays byte-equal after conversion. See de.ts for the
  // same note.
  'email.security-alert.subject': 'Security alert: {{event}}',
  'email.security-alert.title': 'Security alert',
  'email.security-alert.preheader':
    "Security alert: {{event}}. If this wasn't you, reset your password now.",
  'email.security-alert.badge': 'Security alert',
  'email.security-alert.hero': 'Something changed on<br>your account.',
  'email.security-alert.subhead':
    'Hi {{first_name}}, we just detected a security-related action: <strong style="color:#0B0F19;">{{event}}</strong>. If this was you, everything\'s fine: you can ignore this email.',
  'email.security-alert.detail.time_label': 'Time (UTC)',
  'email.security-alert.detail.ip_label': 'IP address',
  'email.security-alert.detail.browser_label': 'Browser',
  'email.security-alert.warning.line':
    '<strong style="color:#881337;">Wasn\'t you?</strong> Reset your password immediately and review your account activity.',
  'email.security-alert.cta.primary': 'Reset password now',
  'email.security-alert.signoff.line':
    'Questions about account security? Just reply to this email: I read every message.',
  'email.security-alert.footer.transactional':
    'For security reasons this email contains information about the action. Do not share it with anyone. This security notification is part of our terms of service and cannot be unsubscribed from.',
  // LEA-295 bug-fix: see note in de.ts.
  'email.security-alert.event.password_reset': 'Password reset',
  'email.security-alert.event.account_deletion_requested':
    'Account deletion requested (30 days grace period)',
  'email.security-alert.event.password_changed': 'Password changed',
  'email.security-alert.firstname_fallback': 'there',
  // ── Phase-Trigger-UI (Welle G66 i18n — Pricing-v2) ──
  'phase.creditOne': 'credit',
  'phase.creditMany': 'credits',
  'phase.retry': 'Try again',
  'phase.cancel': 'Cancel',
  'phase.confirm': 'Confirm',
  'phase.running': 'Running …',
  'phase.btn.running': 'running …',
  'phase.unknownError': 'Unknown error',
  'phase.errorLabel': 'Error:',
  'phase.gate.loadingConnect': 'Researching contacts …',
  'phase.gate.loadingPitch': 'Generating full insights …',
  'phase.gate.loadingHint':
    'This usually takes 30-60 seconds. You can leave the page: we will notify you when it is ready.',
  'phase.gate.failConnect': 'Research failed',
  'phase.gate.failPitch': 'Insights generation failed',
  'phase.gate.failHint': 'Please try again, no additional credit charged.',
  'phase.connect.title': 'Unlock contacts & direct details',
  'phase.connect.desc':
    'We research up to 3 decision-makers with direct email, direct phone and LinkedIn URL. Sources are included (GDPR audit trail).',
  'phase.connect.cta': 'Find contacts',
  'phase.connect.runtime': 'Duration: ~30-60 seconds',
  'phase.pitch.title': 'Unlock full insights & acquisition plan',
  'phase.pitch.desc':
    'Personalized 6-section acquisition plan: what the company does, why exactly this lead, recency (trigger events), customer references, hooks for your sales email.',
  'phase.pitch.cta': 'Generate full insights',
  'phase.pitch.runtime': 'Duration: ~20-40 seconds',
  'phase.locked.confirmQuestion': 'Confirm: charge {credits} for "{action}"?',
  'phase.deepen.title': 'Dig deeper into this lead',
  'phase.deepen.descConnectDone':
    'Contacts are loaded. Now load full insights for the acquisition plan + tech stack.',
  'phase.deepen.descDefault':
    'Identified. Load contacts or go straight to full insights, billed per click.',
  'phase.deepen.pricingError':
    'Pricing catalog could not be loaded, falling back to standard prices.',
  'phase.deepen.directPitch': 'Load full insights directly (without contacts)',
  'phase.btn.connect': '+ Find contacts ({credits})',
  'phase.btn.pitch': '+ Full insights ({credits})',
  'phase.toast.connectLoading': 'Contacts are loading.',
  'phase.toast.pitchLoading': 'Full insights are loading.',
  'phase.toast.noCredits': 'Out of credits. Please top up or upgrade your plan.',
  'phase.toast.connectSoon': 'Contact search is coming soon, unlocked with wave F2.2.',
  'phase.toast.pitchSoon': 'Full insights are coming soon, unlocked with wave F2.3.',
  'phase.toast.error': 'Error: {msg}',
  'phase.toast.unexpected': 'Unexpected error. Please try again.',
  'phase.dialog.connectTitle': 'Find contacts?',
  'phase.dialog.pitchTitle': 'Load full insights?',
  'phase.dialog.connectDesc':
    'We research decision-makers (email, phone, LinkedIn) for this lead. Results are usually available within 1-2 minutes.',
  'phase.dialog.pitchDesc':
    'We generate the acquisition plan, tech stack, trigger phrases and sparkle fields for this lead. Results are usually available within 1-2 minutes.',
  'phase.dialog.close': 'Close dialog',
  'phase.dialog.costNote':
    'This action costs {credits}. Once a credit is spent, it is not automatically refunded.',
  'phase.dialog.confirmDeduct': 'Yes, charge {credits}',
  // ── LeadDetail Rest-Strings (Welle G66.2 i18n) ──
  'det.src.impressum': 'Imprint',
  'det.src.handelsregister': 'Commercial register',
  'det.src.subPage': 'Team page',
  'det.src.dorkEnrich': 'Web research',
  'det.src.geminiGrounding': 'AI research',
  'det.confReason.deepResearchConfirmed': 'confirmed via research',
  'det.confReason.handelsregisterOnly': 'commercial register only',
  'det.confReason.nameMatch': 'name match',
  'det.confReason.multiSource': 'multiple sources',
  'det.confReason.rankFallback': 'Discovery ranking (deep research skipped)',
  'det.confReason.rankFallbackLowConf': 'Discovery ranking (deep research found nothing)',
  'det.trust.authoritative': 'Verified from an official source (imprint/commercial register)',
  'det.trust.semiAuth': "From the company's own page (e.g. /team)",
  'det.trust.llm': 'Extracted by AI from website content',
  'det.trust.derived': 'Derived from other data (low confidence)',
  'det.trust.sourceGeneric': 'Source: {source}',
  'det.trust.confidence': 'confidence',
  'det.pReject.duplicate': 'Duplicate',
  'det.pReject.duplicateHint':
    'Person is already in the list or name mismatch ("Werner Weber Kurt Richter")',
  'det.pReject.wrongRole': 'Wrong role',
  'det.pReject.wrongRoleHint': 'Person does not have the decision authority we are looking for',
  'det.pReject.inactive': 'No longer active',
  'det.pReject.inactiveHint': 'Person has moved on, retired, etc.',
  'det.pReject.wrongData': 'Incorrect data',
  'det.pReject.wrongDataHint': 'Email/phone wrong or unreachable',
  'det.pReject.betterContact': 'Another person is better',
  'det.pReject.betterContactHint': 'There is a more suitable contact at this company',
  'det.pReject.private': 'Do not contact',
  'det.pReject.privateHint': 'I do not want to contact this person (no learning)',
  'det.toast.personFeedbackRealOnly': 'Person feedback is only available for real leads.',
  'det.toast.removeFailed': 'Could not remove. Please try again.',
  'det.toast.backendUnavailable': 'Backend unavailable. Please reload the app.',
  'det.toast.planRegenerating': 'Acquisition plan is being regenerated with the current briefing …',
  'det.toast.phaseAlreadyRunning': '{phase} is already running, one moment please.',
  'det.available': 'available',
  'det.unavailable': 'unavailable',
  'det.primary': 'Primary',
  'det.sourcePrefix': 'Source:',
  'det.dataViaWebResearch': 'Data via public web research',
  'det.openLink': 'Open {label}',
  'det.openLinkedin': "Open {name}'s LinkedIn profile",
  'det.openXing': "Open {name}'s XING profile",
  // ── LeadsTable Rest-Strings (Welle G66.3 i18n) ──
  'lt.trigErr.noContacts': 'We could not identify any contacts. No credit charged.',
  'lt.trigErr.insufficientCredits': 'Not enough credits. Please top up.',
  'lt.trigErr.phaseRunning': 'This phase is already running. Please wait.',
  'lt.trigErr.phaseCompleted': 'This phase is already completed.',
  'lt.trigErr.triggerFailed': 'Trigger failed: {msg}',
  'lt.cta.findContacts': 'Find contacts · 1 credit',
  'lt.cta.createPlan': 'Create acquisition plan · 1 credit',
  'lt.cta.openOutreach': 'Open outreach message',
  'lt.verifyStuck': 'Verification is stuck. Please reload the page and try again.',
  'lt.verifyFailed': 'Contact verification failed.',
  'lt.planFailed': 'The acquisition plan could not be created.',
  'lt.softKeepAria': 'Possible: click for details',
  'lt.manual.toast.backendUnavailable': 'Backend unavailable. Please try again later.',
  'lt.manual.toast.added': '{name} added',
  'lt.manual.toast.alreadyExists': '{name} already exists, opening it for you.',
  'lt.manual.toast.switchProfile': 'You may need to switch audiences: the lead might be elsewhere.',
  'lt.manual.toast.addFailed': 'Could not add.',
  'lt.manual.companyFallback': 'Company',
  // ── Dashboard Rest-Strings (Welle G66.4 i18n) ──
  'dash.cancel.requested': 'Cancellation requested: it will take effect at the next checkpoint.',
  'dash.cancel.failed': 'Cancellation failed',
  'dash.cancel.titleNoRun': 'Run ID not available yet',
  'dash.cancel.titleCancel': 'Cancel search run',
  'dash.cancel.inFlight': 'Cancelling …',
  'dash.cancel.confirm': 'Really cancel?',
  'dash.refreshing': 'Refreshing …',
  'dash.run.noCredits': 'No credits. Please subscribe.',
  'dash.run.startSub': 'Start subscription',
  'dash.sugg.region': 'Region:',
  'dash.sugg.contact': 'Contact:',
  'dash.sugg.extra': 'Extra:',
  'dash.sugg.why': 'Why:',
  // ── Bestandskunden-Exclude (A1, 2026-06-02) ──
  'acct.exclude.title': 'Exclude existing customers',
  'acct.exclude.desc':
    'Add domains you already know (e.g. your CRM export). They are filtered out of the results of ALL searches, one domain per line.',
  'acct.exclude.placeholder': 'company.com\nexample-inc.com\nclient.com',
  'acct.exclude.count': '{n} domains excluded from all searches',
  'acct.exclude.save': 'Save list',
  'acct.exclude.saved': 'Exclusion list saved ({n} domains)',
  // ── Agent-Chat / Cockpit (LEA-435 Wave B) ──
  'agent.nav': 'Assistant',
  'agent.tab.chat': 'Chat',
  'agent.tab.workspace': 'Workspace',
  'agent.boot': 'One moment — your assistant is starting …',
  'agent.thinking': 'Thinking …',
  'agent.turnError': "That didn't work just now — please try again in a moment.",
  'agent.budgetExhausted':
    "Your account's chat allowance for today is used up. It resets automatically tomorrow — your credits and leads are unaffected.",
  'agent.artifact.eyebrow': 'Target group',
  'agent.artifact.draftBadge': 'Draft',
  'agent.artifact.createdBadge': 'Just created',
  'agent.artifact.industry': 'Industry',
  'agent.artifact.region': 'Region',
  'agent.artifact.size': 'Size',
  'agent.artifact.exclusions': 'Exclusions',
  'agent.artifact.any': 'any',
  'agent.bootError': 'The assistant is currently unavailable. Please reload the page.',
  'agent.empty.title': '{greeting} — what can I help you with?',
  'agent.greet.morning': 'Good morning',
  'agent.greet.day': 'Hello',
  'agent.greet.evening': 'Good evening',
  'agent.empty.sub':
    'Just describe who you want as customers — I will build the search, ask for your approval, and we will review the results together.',
  'agent.starter.find': 'I am looking for new customers — help me define my target audience',
  'agent.starter.describe': 'Analyze my website and suggest matching target audiences',
  'agent.starter.review': 'Show me my latest leads and let us go through them',
  'agent.composer.placeholder': 'Message your assistant …',
  'agent.composer.send': 'Send',
  'agent.composer.stop': 'Stop',
  'agent.composer.hint': 'Enter to send · Shift+Enter for a new line',
  'agent.scroll.end': 'Jump to the end',
  'agent.confirm.title': 'Approval: {action}',
  'agent.confirm.approve': 'Approve',
  'agent.confirm.deny': 'Decline',
  'agent.tool.analyze': 'Analyze website',
  'agent.tool.analyzeReference': 'Check reference website',
  'agent.tool.draft': 'Audience draft',
  'agent.tool.createProfile': 'Create profile',
  'agent.tool.startRun': 'Start search',
  'agent.tool.runStatus': 'Search status',
  'agent.tool.listLeads': 'Load leads',
  'agent.tool.getLead': 'Lead details',
  'agent.tool.connect': 'Find contacts',
  'agent.tool.pitch': 'Create outreach plan',
  'agent.tool.feedback': 'Record feedback',
  'agent.tool.credits': 'Credit balance',
  'agent.tool.exclude': 'Exclude companies',
  'agent.tool.cancelApproval': 'Withdraw approval',
  'agent.tool.cancelPlan': 'Stop search plan',
  'agent.support.open': 'Support',
  'agent.support.title': 'Open the support chat — a human replies',
  'agent.ws.title': 'Your audiences',
  'agent.ws.new': 'New',
  'agent.ws.empty': 'The audience profiles we create together in the chat will appear here.',
  'agent.ws.openLeads': 'View leads',
  // Kopieren / Umbenennen / Datei-Anhang (LEA-435 Usability-Welle)
  'agent.msg.copy': 'Copy',
  'agent.msg.copied': 'Copied',
  'agent.sessions.rename': 'Double-click to rename',
  'agent.composer.attach': 'Attach customer list (CSV/XLSX)',
  'agent.attach.none': 'No company domains were detected in the file.',
  'agent.attach.xlsxFailed': 'Could not read the Excel file. Please try a CSV file instead.',
  'agent.attach.saved':
    'I uploaded my customer list: {n} company domains are now excluded from all future searches (e.g. {examples}).',
  'agent.attach.saveFailed':
    'I uploaded my customer list ({n} company domains), but saving it as an exclusion list failed.',
  // Session-Verlauf + Relativzeit (LEA-435 Multi-Session)
  'agent.sessions.new': 'New chat',
  'agent.sessions.empty': 'No conversations yet.',
  'agent.sessions.untitled': 'New conversation',
  'agent.sessions.delete': 'Delete',
  // LEA-448 — delete confirm (#7), radius field (P2-5), company-contact hint
  // (P2-1b), stalled-run failsafe (#8).
  'agent.sessions.deleteConfirm': 'Delete this conversation? This cannot be undone.',
  'agent.artifact.radius': '{n} km radius',
  'agent.leads.companyContactHint':
    'Company contact from the imprint — not a personal decision-maker.',
  'agent.run.stalled': 'Taking longer than usual…',
  'agent.run.interrupted': '{n} companies delivered — search ended early',
  'agent.run.qualifierDown':
    'Our qualification stage was briefly unavailable — that was on us, not your criteria. A fresh run is worth it.',
  'agent.run.recheck': 'Check again',
  // LEA-448 round-4 — approval-card cost line, localized (was hardcoded German).
  'agent.cost.startRun':
    'up to {n} credits — only companies actually delivered count; filtered-out ones are never charged',
  'agent.cost.startRunRescue':
    "second attempt after a thin result — doesn't count as another search; as always only delivered companies are charged (up to {n} credits)",
  'agent.cost.connect':
    '{n} credit — decision-makers (name, role, email, phone) for this company from public sources',
  'agent.cost.pitch':
    '{n} credit — outreach plan (research + ready-to-send first message) for this company',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'agent.cost.startRunReveal':
    'free — searching costs nothing; you only pay when you unlock a contact person',
  'agent.cost.scheduleReveal':
    'free — every run · {cadence} · pauses itself after {k} runs in a row without new companies or when your balance is empty · you can stop it any time',
  'agent.cost.connectReveal':
    'free — contact persons are researched and become visible once you unlock them',
  'agent.cost.pitchReveal': 'free — the acquisition plan comes with the unlock',
  'agent.cost.startRunPlan':
    '{runs} searches one after another, up to {per} credits each — up to {n} credits in total for up to {leads} companies; only companies actually delivered count, and the plan stops after a thin result',
  'agent.cost.connectBatch':
    'up to {n} credits — decision-makers (name, role, email, phone) for {count} companies from public sources; a company without a reachable contact is not charged',
  'agent.cost.pitchBatch':
    'up to {n} credits — outreach plans (research + ready-to-send first message) for {count} companies',
  'agent.sessions.history': 'History',
  'agent.sessions.close': 'Close',
  'agent.time.now': 'just now',
  'agent.time.min': '{n} min ago',
  'agent.time.hour': '{n} h ago',
  'agent.time.day': '{n} d ago',
  // ── Live-Fortschrittskarte (LEA-435) ──
  'agent.run.running': 'Search running',
  'agent.run.finalizing': 'Finishing up — almost done …',
  'agent.run.preparing': 'Preparing search …',
  'agent.run.done': 'Search complete',
  'agent.run.failed': 'Search failed',
  'agent.run.cancelled': 'Search cancelled',
  'agent.run.delivered': '{n} / {total} companies delivered',
  'agent.run.reviewCta': 'Review leads',
  'agent.run.dismiss': 'Dismiss',
  'agent.run.step.planning': 'Planning',
  'agent.run.step.discovery': 'Discovery',
  'agent.run.step.hydration': 'Enrichment',
  'agent.run.step.reasoning': 'Scoring',
  'agent.run.step.delivery': 'Delivery',
  'agent.run.won': '{n} fresh leads for you!',
  'agent.run.empty': 'No matching companies found',
  'agent.rescue.head.zero': "This search didn't find any matching companies.",
  'agent.rescue.head.lowOne':
    'This search found only 1 matching company — you can already take a look at it.',
  'agent.rescue.head.low':
    'This search found only {n} matching companies — you can already take a look at them.',
  'agent.rescue.cause.ours':
    "That was on us, not your audience: the search didn't run through cleanly for technical reasons.",
  'agent.rescue.cause.oursQualifier':
    'That was on us, not your audience: our checking step was unavailable during the search, so the companies we found were never evaluated.',
  'agent.rescue.cause.fewFound':
    'In the search area ({area}) we found only a few companies that match your description. That says more about our reach there than about your market.',
  'agent.rescue.cause.harvested':
    'You already know the companies we found: they were delivered to you in earlier searches or are on your list of known companies.',
  'agent.rescue.cause.harvestedLow':
    'You already know the other companies we found: they were delivered to you in earlier searches or are on your list of known companies.',
  'agent.rescue.cause.tooBroad':
    "Your audience doesn't name a specific industry. Without one, the research doesn't know which companies to check.",
  'agent.rescue.cause.filtered':
    'We found companies, but none of them met your criteria (industry, size or region).',
  'agent.rescue.cause.filteredLow':
    "The other companies we found didn't meet your criteria (industry, size or region).",
  'agent.rescue.cause.unknown': "We couldn't determine for sure why.",
  'agent.rescue.freeRule':
    "Failed searches never cost anything: nothing is charged without a delivered company. And the new attempt doesn't count as another search.",
  'agent.rescue.pick': 'My suggestion — one click starts the new search:',
  'agent.rescue.noOption.tooBroad':
    "Tell me a specific industry or trade and we'll sharpen the audience together.",
  'agent.rescue.noOption.wide':
    'The search area is already as wide as makes sense — another attempt with the same criteria would most likely bring nothing new.',
  'agent.rescue.thin.zero':
    "The second attempt didn't find any matching companies either. That suggests there are very few publicly findable companies for this combination — another attempt with the same criteria wouldn't change that.",
  'agent.rescue.thin.low':
    "The second attempt found hardly any matching companies either ({n} delivered). That suggests there are only a few publicly findable companies for this combination — another attempt with the same criteria wouldn't change that.",
  'agent.rescue.thin.next':
    'A different angle makes more sense — for example a neighbouring industry or another region.',
  'agent.rescue.opt.same': 'Run the same search again',
  'agent.rescue.opt.widen': 'Widen the area to {area} (instead of only {from})',
  'agent.rescue.opt.dach': 'Widen the area to Germany, Austria and Switzerland',
  'agent.rescue.opt.dachFrom':
    'Widen the area to Germany, Austria and Switzerland (instead of only {from})',
  'agent.rescue.opt.industry': 'Search again with the industry “{industry}”',
  'agent.rescue.chip.market': "Let's try “{market}” as the audience",
  'agent.rescue.chip.rethink': 'Help me rethink the audience',
  'agent.rescue.unavailable': 'This second attempt is no longer available',
  'agent.rescue.card.note':
    "Doesn't count as another search — as always, only delivered companies are charged",
  'agent.rescue.card.noteFree': "Free second attempt — doesn't count as another search",
  'agent.rescue.oursRetryLater':
    'Please try again in a few minutes — companies that were not delivered are never charged.',
  'agent.rescue.card.used': 'Started',
  'agent.rescue.card.aria': 'Suggestions for a second attempt',
  'agent.rescue.preparing': 'Looking into what went wrong …',
  // ── Momentum-Leiste (LEA-435) ──
  'agent.momentum.label': 'Your run',
  'agent.momentum.audiences': 'Audiences',
  'agent.momentum.searches': 'Searches',
  'agent.momentum.leads': 'Leads',
  'agent.momentum.contacts': 'Contacts',
  'agent.momentum.pitches': 'Outreach',
  // ── Lead-Bewert-Deck (LEA-435) ──
  'agent.leads.title': 'Your leads — which fit?',
  'agent.leads.rated': '{done}/{total} rated',
  'agent.leads.accept': 'Good fit',
  'agent.leads.reject': 'Not a fit',
  'agent.leads.accepted': 'Good fit',
  'agent.leads.rejected': 'Not a fit',
  'agent.leads.contacts': '{n} contacts',
  'agent.leads.openAll': 'See all in detail',
  'agent.leads.done': 'Nice — all rated! That sharpens your next search.',
  'agent.leads.chainConnect': '→ Find decision-makers for your matches ({n})',
  'agent.leads.chainMsg': 'Please find the contacts for: {names}. (leadIds: {ids})',
  // ── Erfolgs-Puls (LEA-435) ──
  'agent.pulse.hitRate': 'Hit rate {pct}%',
  'agent.pulse.rising': 'rising',
  'agent.pulse.detail': '{accepted} of {rated} leads fit · {profiles} audiences',
  'agent.pulse.nudge':
    'Rate your leads with 👍/👎 — then I learn your hit rate and get better with every search.',
  // ── Aktions-Chips (LEA-435) ──
  'agent.chip.confirmDraft': 'Yes, create it like this',
  'agent.chip.adjustDraft': 'Adjust targeting',
  'agent.chip.startRun': 'Start search',
  'agent.chip.reviewLeads': 'Review leads',
  'agent.chip.msg.confirmDraft': 'Yes, create the profile exactly like this.',
  'agent.chip.msg.adjustDraft': "I'd like to adjust the target audience.",
  'agent.chip.msg.startRun': 'Start the search for this profile now.',
  'agent.chip.msg.startRunNamed': 'Start the search for the audience "{name}" now.',
  'agent.chip.msg.reviewLeads': "Let's go through the delivered leads.",
  // ── Editierbare Firmen-Karte (#122, 2026-06-02) ──
  'common.remove': 'Remove',
  'dash.cortex.editHint':
    'Remove chips with × or add fitting ones, so Leadscraper matches your offer more precisely (max. 8 per column).',
  'dash.cortex.descLabel': 'Description',
  'dash.cortex.changeUrl': 'Analyze a different website',
  'dash.cortex.editSaved': 'Company profile updated',
  'dash.cortex.addPlaceholder': 'add…',
  'dash.cortex.capReached': 'Max. 8 reached',
  'pd.target.edit': 'Redescribe',
  'pd.target.editHint':
    'Describe your ideal customers in 1–2 sentences. Leadscraper re-derives industry, region & contact role from it.',
  'pd.target.editPlaceholder':
    'e.g. packaging manufacturers, nationwide, 50–250 employees, management',
  'pd.target.reparsing': 'Leadscraper is thinking …',
  'pd.target.saved': 'Audience updated',
  'pd.target.saveError': "Couldn't update. Please try again.",
  'common.close': 'Close',
  'common.selected': 'Selected',
  'credit.balanceTitle': 'Your credit balance',
  'credit.available': 'available',
  'det.trigger.cat.serviceRadius': 'Service area',
  'det.trigger.cat.specialization': 'Specialization',
  'det.trigger.cat.capacity': 'Capacity',
  'det.trigger.cat.history': 'History',
  'det.trigger.cat.partnership': 'Partnership',
  'det.trigger.cat.certification': 'Certification',
  'det.trigger.cat.other': 'Other',
  'lead.removeContactTitle': 'Why remove?',
  'lead.actionNeedPlan': 'Generate an acquisition plan first',
  'lead.actionNoEmail': 'No email address for the prioritized contact',
  // scraper run experience + API errors (LEA-302) — see de.ts for context
  'scraper.act.loadProfile': 'Loading your profile + previous ratings…',
  'scraper.act.firstFeedbacks':
    'Collecting first ratings: after 10 ratings, Cortex learns your acceptance/rejection patterns.',
  'scraper.act.feedbacksCollected':
    "{seen} ratings collected: personalization becomes active after {activeAt} ratings per profile. This search doesn't use personalization yet.",
  'scraper.act.patternsActive':
    '{seen} ratings · {accepted} acceptance patterns · {rejected} rejection patterns active in reasoning',
  'scraper.act.planning':
    'Planning search strategy: which search sources + queries best cover your request?',
  'scraper.act.aiSearchTempError':
    'AI search had a temporary issue (network/timeout). Please try again.',
  'scraper.act.aiSearchUnavailable':
    'AI search currently unavailable (configuration issue). Contact support.',
  'scraper.act.aiSearchBadFormat': 'AI search returned invalid format. Please try again.',
  'scraper.act.aiSearchFailed': 'AI search failed ({reason}). Please try again.',
  'scraper.act.reasonUnknown': 'unknown',
  'scraper.act.researcherAnalyzing': 'AI researcher analyzing your search request…',
  'scraper.act.researcherFound': 'AI researcher: {n} verified companies identified',
  'scraper.act.goal': 'Goal: {goal}',
  'scraper.act.strategy': 'Strategy: {strategy}',
  'scraper.act.reasoning': 'Reasoning: {reasoning}',
  'scraper.act.srcCurated': '⭐ Curated source',
  'scraper.act.srcOwn': '💡 Own suggestion',
  'scraper.act.srcKindRegister': 'Register',
  'scraper.act.srcKindDirectory': 'Directory',
  'scraper.act.srcKindPortal': 'Portal',
  'scraper.act.source': '{tag}: {label} [{kind}]',
  'scraper.act.googleSearch': 'Google Search: "{q}"',
  'scraper.act.googleMaps': 'Google Maps: "{q}"{location}',
  'scraper.act.googleNews': 'Google News: "{q}"',
  'scraper.act.researcherEnough':
    'AI researcher sufficient ({n} companies), skipping additional Google searches',
  'scraper.act.researcherIdentified':
    'AI researcher identified {n} companies, skipping Google searches',
  'scraper.act.researcherNone':
    'AI researcher found no matching companies: search request is very niche. Try with broader profile or less specific region.',
  'scraper.act.companyIdentified': 'Company identified: {name} ({i}/{total})',
  'scraper.act.enrichBasics':
    'Enriching {n} companies with basic data (address, size, tech stack)...',
  'scraper.act.enrichCompany': 'Enriching company {idx}/{total}: {domain}',
  'scraper.act.phase1Light':
    'Phase-1-Light: {n} companies identified in {secs}s. Address/size/details will be scraped as needed.',
  'scraper.act.serperExhausted':
    '⚠ Serper Credits exhausted. Discovery limited. Reload at serper.dev/dashboard.',
  'scraper.act.mapsHits': '{n} Maps hits for "{query}"',
  'scraper.act.searchHitsCollected': '{n} hits collected from Google search',
  'scraper.act.directoriesFound': '{n} industry directories found, extracting listed companies …',
  'scraper.act.searchingPortal': 'Searching {host} for listed companies …',
  'scraper.act.minedCompanies': '{n} companies extracted from {portal}',
  'scraper.act.onlyPortals': 'No operating companies identified: all hits were portals',
  'scraper.act.queryInfeasible': 'Cortex considers the query unfeasible: {reason}',
  'scraper.act.rethinking': 'Cortex is rethinking (round {round}): {reason}',
  'scraper.act.searchingPortalNew': 'Searching {host} (new plan step) …',
  'scraper.act.minedPortalRound': '{n} companies from {host} (reflector round {round})',
  'scraper.act.backlogResumed': '{n} backlog candidates from previous runs resumed',
  'scraper.act.companiesIdentifiedAgg':
    '{n} companies identified ({rescued}/{attempted} rescued from aggregator portals), starting deep analysis',
  'scraper.act.companiesIdentified': '{n} companies identified, starting deep analysis',
  'scraper.act.handelsregisterChecked': 'Commercial register extract checked: {hrb}',
  'scraper.act.scanningWebsite': 'Analyzing website: {domain}',
  'scraper.act.relatedPages': '{n} additional pages analyzed: {domain}',
  'scraper.act.deepAnalysis': 'Deep company analysis: {name}',
  'scraper.act.pipelineStarted':
    'Pipeline started, {n} candidates going through hydration + evaluation in parallel',
  'scraper.act.allDroppedPrefilter':
    'All {n} found companies were discarded as not fitting (industry/region). Refine your target audience or try a different region.',
  'scraper.act.noCompaniesFound':
    'Discovery found no companies for this search. Refine your target audience.',
  'scraper.act.phase1OnlyRun': 'Phase-1-only run: {n} Leads identified. Phase 2 + 3 were skipped.',
  'scraper.act.leadsDeliveredEnriching':
    '{n} Leads delivered, Cortex still enriching (acquisition plan, scores, deep research)',
  'scraper.act.deeperResearch': 'Deeper research: {name}, {findings} from {sources} sources',
  'scraper.act.coldStart': 'Cold start (no previous runs)',
  'scraper.act.runHistory':
    '{runs} previous runs · {delivered} already delivered · {dropped} already dropped',
  'scraper.act.buyerProfile': 'Buyer profile: {narrative} (Confidence: {confidence})',
  'scraper.act.confHigh': 'high',
  'scraper.act.confMid': 'medium',
  'scraper.act.confLow': 'low',
  'scraper.act.subsidiary':
    'DACH subsidiary detected: {domain} ({src}), will be used for contact search.',
  'scraper.act.subsidiarySrcDirect': 'directly checked',
  'scraper.act.subsidiarySrcGoogle': 'via Google research',
  'scraper.rq.harvestedMsg':
    'Target audience temporarily exhausted: previous search runs have already delivered {prior} fitting companies.',
  'scraper.rq.harvestedRec':
    'Cortex has already found the known companies. New hits occur when new companies in your target audience become visible online. The schedule picks them up automatically.',
  'scraper.rq.noMarketMsg':
    'Only {n} companies found across the entire web for the search. This target audience seems not publicly findable: perhaps too specific or internal company data.',
  'scraper.rq.noMarketRec':
    'Try formulating more broadly or combine with look-alike industries. Schedule is not worthwhile for this query.',
  'scraper.rq.tooNicheMsg':
    'Only {n} potential companies in the market: your target audience is very niche.',
  'scraper.rq.tooNicheRec':
    'Schedule is only worthwhile for target audiences with 50+ companies. Consider broader region or more industry variants.',
  'scraper.rq.qualifierDownMsg':
    'Our AI qualification was unavailable during this run, so the {n} companies we found could not be assessed — a technical problem on our side, not a verdict on your market.',
  'scraper.rq.qualifierDownRec':
    'Start the search again in a few minutes. No need to change your criteria — not a single company was actually evaluated this time.',
  'scraper.rq.unmatchedMsg':
    '{n} companies analyzed: none matched your criteria (industry, size, region).',
  'scraper.rq.unmatchedRec':
    "Check description: criteria too strict? Look-alike acceptance doesn't help because no look-alikes were plausible.",
  'scraper.sum.delivered':
    '{n} Leads delivered ({hard} certain{softFrag}) from {total} analyzed companies.',
  'scraper.sum.softFragment': ', {soft} possibly relevant',
  'scraper.sum.deliveredNiche':
    '{n}/10 Leads delivered: target audience is niche (only {total} companies identified in the market).',
  'scraper.sum.nicheRec':
    'Normal for recurring schedules. New matches develop over time. If you need more volume: consider broader region or related industries.',
  'scraper.sum.recallUnverified':
    '{n}/10 Leads delivered: the AI researcher was sufficient, so the broad web search was skipped. The market may be much larger than the {total} companies found so far.',
  'scraper.sum.recallUnverifiedRec':
    "This isn't a thin market: it's a skipped search. We're widening discovery to measure the real market size.",
  // LEA-494: honest low-contact floor — a run can deliver 10 leads yet mostly nameless companies.
  'scraper.sum.lowContactRec':
    'Only {withContact} of {n} leads carry a contact person. For the rest we deliver the company — find the contact via Connect.',
  // LEA-461: honest low-yield framing — discovery under-reached, but we have NO breadth signal proving the market is thin.
  'scraper.sum.lowYield':
    "{n}/10 Leads delivered. We've found {total} companies for your query so far — this reflects our current discovery reach, not the true market size.",
  'scraper.sum.lowYieldRec':
    'Not a thin market — discovery just did not exhaust it. For more volume: broaden the region or split the query into more specific sub-searches.',
  'scraper.rq.lowYield':
    '{n} companies found so far. This reflects our discovery reach, not the market size — the market is likely larger.',
  // LEA-474: zero-run on a query naming no industry ("SMEs") → honest too-broad diagnosis instead of too_niche.
  'scraper.rq.tooBroadMsg':
    'Your search names no specific industry — "{type}" only describes company type or size. No clear target profile can be derived from it, so no matching company came through.',
  'scraper.rq.tooBroadRec':
    'Name a concrete industry or trade (e.g. "mechanical engineering companies in NRW" instead of "SMEs") — you can additionally narrow region and size.',
  // LEA-479: the audience names no industry at all, only a signal/attribute (businessType 'any',
  // e.g. "companies with an outdated website"). A signal is a check criterion, not a search seed.
  'scraper.sum.attrOnly':
    '{n}/10 Leads delivered. Your search names no industry — only a signal (e.g. "outdated website"). A signal is a check criterion, not a search term, so discovery doesn\'t know WHO to inspect and few matching companies came through.',
  'scraper.rq.attrOnly':
    'Your search names no industry — only a signal (e.g. "outdated website"). A signal is a check criterion, not a search term — without an industry, discovery doesn\'t know WHO to inspect.',
  'scraper.sum.attrOnlyRec':
    'Name an industry or segment (e.g. "dentists in NRW") and keep the signal as an extra qualifier — then discovery inspects the right companies for your signal.',
  'scraper.sum.supplyExhausted':
    "{n}/10 Leads delivered: {dropped} more matches were already delivered to you in earlier searches and filtered out as duplicates. The market isn't thin; you've simply already received most of the companies we can currently find.",
  'scraper.sum.supplyExhaustedRec':
    'Normal for recurring searches. New companies appear over time. For more fresh volume: choose a broader region or related industries.',
  'scraper.sum.deliveredDropped':
    '{n}/10 Leads delivered: Cortex rejected {dropped} additional candidates as not a fit.',
  'scraper.sum.droppedRec':
    'If you want more volume: formulate description more loosely or accept look-alikes/soft-keeps.',
  'scraper.sum.deliveredMixed': '{n}/10 Leads delivered: mixed yield from {total} companies.',
  'scraper.sum.mixedRec':
    'Normal for recurring schedules: Cortex gathers additional matches over time.',
  'scraper.sum.noneMatched': '{total} companies analyzed: none matched your criteria.',
  'scraper.sum.noneMatchedRec': 'Check description: criteria too strict or try different region.',
  'scraper.mem.active': 'Actively personalized · {n} ratings',
  'scraper.mem.analyzing': 'Currently being re-analyzed · {n} ratings',
  'scraper.mem.firstImpression': 'First impression · {n}/{active} until active',
  'scraper.mem.learning': 'Learning with you · {n}/{preview} until preview',
  'scraper.reflector.fallback':
    "Reflector not available: query reported as not feasible so user doesn't wait indefinitely.",
  'apierr.junkQuery':
    'Please describe specifically WHO you\'re looking for, e.g. "bakeries in Hamburg" or "tax advisors NRW 5-50 employees". Generic terms like "B2B", "test", "profile" or typo texts are not accepted.',
  'apierr.invalidWebsite': 'Please enter a valid website (e.g. my-company.com)',
  // LEA-543: Zielgruppe sind Privatpersonen — Leadscraper findet nur Unternehmen.
  // Server-seitig lokalisiert via tForLang, zusammen unter 240 Zeichen (die
  // Fehler-Antwort wird im Client bei 300 Zeichen abgeschnitten).
  'apierr.b2cOnly':
    "Leadscraper finds companies and the decision-makers inside them — we don't supply private individuals.",
  'apierr.b2cPivot': 'A workable alternative: {pivot}',
  'apierr.noUserCompanyStep1': 'Analyze website first (step 1).',
  'apierr.noUserCompany': 'Analyze website first.',
  'apierr.insufficientPhase': 'You need {cost} Credit(s) for this phase. Current: {credits}.',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'apierr.pitchRequiresReveal':
    "Unlock this company's contacts first — the acquisition plan is included.",
  'apierr.planGenFailed': 'Acquisition plan could not be generated. No Credits consumed.',
  'apierr.urlParse': 'URL could not be parsed.',
  'apierr.urlIncomplete': 'Please provide complete URL.',
  'apierr.dupCompany': 'You have already added this company{nameSuffix}.',
  'apierr.dupCompanySuffix': ' ({name})',
  'apierr.manualUnreachable': 'Website was unreachable during setup: data could not be retrieved.',
  'apierr.manualPhase1Failed': 'Phase 1 failed (website unreachable). Try again via "Update data".',
  'apierr.cancelRequested': 'Cancellation requested. Will take effect at next checkpoint.',
  'apierr.noCredits': 'No Credits available. Please subscribe or purchase Credits.',
  'apierr.rescueNotAvailable':
    'The free second attempt for this search is not (or no longer) available.',
  // LEA-475: distinct from noCredits — access has ended, not merely an empty
  // wallet. Existing credits are kept (frozen).
  'apierr.subscriptionEnded':
    'Your subscription has ended. Reactivate it to keep searching — your existing credits are kept.',
  // LEA-475: forced "expired" gate copy (features/pricing/ExpiredGate).
  'expired.title': 'Your subscription has ended',
  'expired.body':
    'Your access is paused. Reactivate your subscription to search for leads and run your target groups again.',
  'expired.readOnly':
    'You can still view and export your leads. New searches and contact research need an active plan.',
  // Present tense ("frozen, not deleted") on purpose rather than promising the
  // exact count survives reactivation: pure-trial accounts have their non-pack
  // credits voided on the first paid cycle (LEA-278).
  'expired.creditsKept': 'Your {credits} credits are frozen, not deleted.',
  'expired.cta': 'Reactivate subscription',
  'expired.ctaLoading': 'Loading…',
  'apierr.intentParse':
    'Could not extract specific industry from your description "{desc}". Please be more precise, e.g. instead of "Hamburg" → "bakeries in Hamburg" or "tax advisors in Hamburg".',
  // i18n localization batch (LeadDetail / acquisition plan)
  'det.acquisitionPlan': 'Acquisition Plan',
  'det.creatingPlan': 'Cortex is creating your acquisition plan…',
  'det.planLoadTime': 'Usually 30-60 seconds, no reload needed, appears automatically',
  'det.planUncertaintyWarning': 'Warning: Plan text contains uncertainties',
  'det.companyClassification': 'Company Classification',
  'det.opportunities': 'Opportunities',
  'det.risksAndDealbreakers': 'Risks / Dealbreakers',
  'det.channelMix': 'Channel Mix · 7-Day Sequence',
  'ld.sparkle.sampleMessageLabel': 'Sample message for first contact',
  'ld.sparkle.sampleMessageCopied': 'Sample message copied.',
  'common.copy': 'copy',
  'ld.sparkle.messageSubject': 'Subject: ',
  'ld.lean.urteil': 'Why this lead',
  'ld.lean.winkel': 'Your angle',
  'ld.lean.kontakte': 'Who first',
  'ld.lean.nachricht': 'First contact: ready to send',
  'ld.lean.nachrichtShort': 'First-contact draft',
  'ld.lean.telefon': 'Phone opener',
  'ld.lean.check': 'Before you send',
  'ld.lean.copyAI': 'Copy for AI',
  'ld.lean.copyAITitle':
    'Copies the plan, publicly sourced company & contact data and your offer profile as a handover for ChatGPT, Claude & co.',
  'ld.lean.copiedAI': 'Handover copied: paste it into your AI tool',
  'ld.lean.varMain': 'Recommended',
  'ld.lean.sendMail': 'Send as email',
  'ld.lean.sendMailTitle': 'Opens your email app with {addr}, subject and text pre-filled',
  'ld.lean.zentrale': 'Main office',
  'ld.lean.nameNotPublic': 'name not public',
  'ld.lean.verifiziert': 'verified',
  'ld.lean.chEmail': 'Email',
  'ld.lean.chTelefon': 'Phone',
  'ld.lean.chLinkedIn': 'LinkedIn',
  'ld.lean.chXing': 'Xing',
  'ld.ai.instructions':
    'You are my sales copilot for this one specific lead. Below is all the data my tool (Leadscraper) researched from public sources and compiled into an acquisition plan: use it directly, don’t ask for it first.\n\nMarkers: ✓ = publicly verified (website, imprint, LinkedIn, registry), ~ = assumption without a hard source. Keep this distinction and don’t invent anything about the company or the contact person.\n\nYou can help me refine the first-contact message, build a call script, rehearse objections or prepare the follow-up.',
  'ld.ai.secLead': 'Lead',
  'ld.ai.secData': 'Data availability',
  'ld.ai.secContacts': 'Contacts',
  'ld.ai.secCompany': 'My company',
  'ld.ai.secPlan': 'Acquisition plan',
  'ld.ai.secUncertain': 'Uncertainties & verify',
  'ld.ai.secTask': 'What I need from you',
  'ld.ai.taskBody':
    'Start right away: refine the first-contact message above in my tone and suggest ONE concrete improvement that raises my reply rate.',
  'ld.ai.company': 'Company',
  'ld.ai.industry': 'Industry',
  'ld.ai.size': 'Size',
  'ld.ai.region': 'Region',
  'ld.ai.dataAsOf': 'Data as of: researched on {date}',
  'det.recommendedNextStep': 'Recommended Next Step',
  'det.botProtectionWarning':
    "This website had bot protection active: we couldn't scrape the imprint/contact page directly. The data shown here we compiled from public sources (Google, industry directories) and may be less accurate than direct imprint data.",
  'det.possibleNotVerified': 'Possible: not 100% verifiable',
  'det.noJustificationYet':
    "No justification yet: for this lead, buyer matching couldn't be executed (user profile incomplete or website was unreachable). Starting phases 2/3 will fetch more data.",
  'det.offering': 'Offering',
  'det.nicheSignals': 'Niche Signals',
  'det.niche.signalsOne': '1 signal',
  'det.niche.signalsMany': '{n} signals',
  'det.vatId': 'VAT ID: ',
  'det.revenue': 'Revenue ',
  'det.agency': 'Agency',
  'det.distributor': 'Distributor',
  'det.stack': 'Stack:',
  'det.webDesign': 'Web Design:',
  'det.masteryBusiness': 'Master Business',
  'det.guild': 'Guild: ',
  'det.imprintVerified': '✓ Imprint verified',
  'det.sealsOfQuality': 'Seals of Quality:',
  'det.social': 'Social:',
  'det.verifyingContacts': 'Verifying contacts…',
  'det.inferringPattern': 'Pattern is being inferred…',
  'det.emailPatternPlaceholder': '{firstname}.{lastname}@company.de',
  'det.emailPatternExampleTag': 'Example',
  'det.emailPatternLockedHint': 'Determined for this company when you verify the contacts.',
  'det.sales': 'Sales',
  'det.marketing': 'Marketing',
  'det.engineering': 'Engineering',
  'det.finance': 'Finance',
  'det.management': 'Management',
  'det.procurist': 'Procurist',
  'det.contactRemoved': 'removed, will no longer be delivered.',
  'det.percentSure': '% sure',
  'det.foundIn': 'found in:',
  'det.email.verified': 'verified',
  'det.email.unverified': 'unverified',
  'det.recommendedChannel': 'Recommended Channel',
  'det.linkedinProfile': 'LinkedIn profile',
  'det.xingProfile': 'Xing profile',
  'det.tier1': 'Directly reachable',
  'det.tier2': 'Via LinkedIn/Xing',
  'det.tier3': 'Via the switchboard',
  'det.tier4': 'Backup contact',
  'det.tier5': 'Company channel only',
  'det.inferred': '⚠ inferred',
  'det.companyCentral': '(Company Central)',
  'det.quality.title': 'Lead Quality',
  'det.quality.company': 'Company',
  'det.quality.contact': 'Contact',
  'det.quality.noContacts':
    'No decision-makers are publicly verifiable for this company: Leadscraper never invents contacts.',
  'det.quality.companyFitPlain': 'Industry, region and size match your search.',
  'det.quality.companyFitSoft':
    'Industry and region fit, not fully clear-cut on every criterion yet.',
  'det.quality.noContactsCentral': 'You can still reach them via the main office (see contact).',
  'det.quality.outreach': 'Outreach',
  'det.quality.lockedContactVerify': 'Verify contact first',
  'det.quality.lockedPlanCreate': 'Create acquisition plan first',
  'ld.sparkle.conversationOpener': 'Conversation Opener',
  'ld.sparkle.openerCopied': 'Opener copied.',
  'lt.next.contactVerificationStarted': 'Contact verification started …',
  'lt.next.contactVerificationLabel': 'Contact verification',
  'lt.next.planGenerationStarted': 'Acquisition plan generation started …',
  'lt.next.planGenerationLabel': 'Acquisition plan generation',
  'lt.next.verifiedNoContacts': 'Verified: no contacts found',
  'det.size.employees': 'employees',
  'det.since': 'since ',

  // ── Prism funnel (Stage C i18n extraction, /dev/prism-demo) ──────────────
  // General / kicker
  'prism.kicker.account': 'Account created',
  'prism.kicker.waiting': 'Your first customers are waiting',
  'prism.audienceFallback': 'your target audience',
  // LEA-379 i18n#4 (Om QA): Stripe checkout line-item, localized per session lang.
  'billing.tripwire.lineItem.name': 'Leadscraper · 50 Leads Starter Pack',
  'billing.tripwire.lineItem.desc': '50 verified leads, ready to reach out.',
  'prism.a11y.close': 'Close',
  // Step 1 — target audience
  'prism.target.eyebrow': 'Step 1 of 3 · Target audience',
  'prism.target.title': 'Who do you want to reach?',
  'prism.target.titleGrad': "We'll find them instantly.",
  'prism.target.sub':
    'Describe your target audience in one sentence: your live search zeroes in on exactly that.',
  'prism.target.label': 'Your target audience',
  'prism.target.placeholder': 'e.g. managing directors of tax firms in Bavaria',
  'prism.target.chip.steuer': 'Tax firms in Bavaria',
  'prism.target.chip.agentur': 'Marketing agencies in NRW',
  'prism.target.chip.handwerk': 'Skilled trades businesses in Hamburg',
  'prism.target.chipQuery.steuer': 'Managing directors of tax firms in Bavaria',
  'prism.target.chipQuery.agentur': 'Owners of marketing agencies in NRW',
  'prism.target.chipQuery.handwerk': 'Skilled trades businesses in Hamburg',
  'prism.target.tip':
    '💡 Strongest combo: industry + region, e.g. "dentists in Cologne". Roles like "SMB managing directors" work too.',
  'prism.target.suggestion': 'Did you mean something like "{suggestion}"?',
  'prism.target.validating': 'Checking your target audience …',
  'prism.target.cta': 'Find my audience',
  'prism.target.foot': 'Free · no payment details needed yet',
  'prism.target.errFallback': "That doesn't look like a target audience yet.",
  // Step 2 — website
  'prism.website.eyebrow': 'Step 2 of 3 · Website',
  'prism.website.title': 'Your website:',
  'prism.website.titleGrad': 'so the AI gets what you do',
  'prism.website.sub':
    'Your own company website, so we understand what you sell and which customers fit you.',
  'prism.website.label': 'Website URL',
  'prism.website.placeholder': 'https://your-company.com',
  'prism.website.hint':
    'No website of your own yet? Then skip this step. The search then runs on your audience alone.',
  'prism.website.errInvalid': 'That doesn\'t look like a web address yet, e.g. "your-company.com".',
  'prism.website.cta': 'Analyze website',
  'prism.website.foot': 'Analysis only · nothing gets published',
  // Analysis phase
  'prism.analyzing.reading': 'The AI is reading your website …',
  'prism.analyzing.wait': 'Sharpening your target audience …',
  'prism.analyze.step1': 'Website loaded live & parsed',
  'prism.analyze.step2': 'Business model identified',
  'prism.analyze.step3': 'Offer & value proposition analyzed',
  'prism.analyze.step4': 'Ideal target audience derived',
  // Step 3 — questions
  'prism.questions.eyebrow': 'Final step · Fine-tuning',
  'prism.questions.back': '← Back',
  'prism.questions.title': 'Quick check:',
  'prism.questions.titleGrad': 'question {num} of {total}',
  'prism.questions.q1': 'How large should the companies be?',
  'prism.questions.q1o1': 'Up to 50 employees',
  'prism.questions.q1o2': 'More than 50',
  'prism.questions.q1o3': 'No preference',
  'prism.questions.q2': 'Should the companies be specialized?',
  'prism.questions.q2o1': 'Yes, one segment',
  'prism.questions.q2o2': 'Broadly positioned',
  'prism.questions.q2o3': 'No preference',
  'prism.questions.q3': 'Where should the companies be based?',
  'prism.questions.q3o1': 'Only my region',
  'prism.questions.q3o2': 'Nationwide',
  'prism.questions.q3o3': 'No preference',
  'prism.questions.yes': 'Yes, exactly',
  'prism.questions.no': 'Not really',
  'prism.questions.foot': 'The more precise your answer, the sharper your first leads.',
  // Search phase
  'prism.searching.label': 'companies found in your target audience …',
  // Wave 2: concrete/procedural so the endless rotation doesn't feel "stuck" —
  // 6 true process steps instead of 4.
  'prism.searching.wait1': 'Checking matches for fit …',
  'prism.searching.wait2': 'Filtering out weak matches …',
  'prism.searching.wait3': 'Cross-checking for duplicates …',
  'prism.searching.wait4': 'Checking that websites are reachable …',
  'prism.searching.wait5': 'Matching locations …',
  'prism.searching.wait6': 'Merging company profiles …',
  'prism.search.step1': 'Search queries planned for your target audience',
  'prism.search.step2': 'Companies collected via web and map search',
  'prism.search.step3': 'Portals, directories and duplicates removed',
  'prism.search.step4': 'Fit of the best matches to your target audience scored',
  'prism.search.step5': 'Websites of the strongest matches checked live',
  'prism.search.step6': 'Region and company type of the strongest matches cross-checked',
  'prism.search.step7': 'Weak matches removed',
  'prism.search.step8': 'Result checked for plausibility',
  'prism.search.step9': 'Strongest matches compiled',
  'prism.search.n.companies': '{count} companies',
  'prism.search.n.ap': '{count} contacts',
  'prism.search.n.valid': '{count} valid',
  'prism.search.n.revenue': '~€{count}M',
  'prism.search.n.top': 'Top 50',
  // Fit-score labels
  'prism.score.perfect': 'Perfect fit',
  'prism.score.outstanding': 'Outstanding fit',
  'prism.score.veryStrong': 'Very strong fit',
  'prism.score.good': 'Good fit',
  'prism.score.titleAttr': 'Fit score {score}/100',
  // Refine screen (engine weak)
  'prism.refine.title': "Not enough strong matches yet: let's sharpen this.",
  'prism.refine.body': "We haven't found enough convincing companies for {audience} yet.",
  'prism.refine.hint1': 'Sharpen your target audience, ideally',
  'prism.refine.hintStrong': 'industry + region',
  'prism.refine.hint2':
    '(e.g. "tax firms in Bavaria", "dental practices in Hamburg", "construction companies in Saxony"). The more specific you get, the more real companies we find for you.',
  'prism.refine.try': 'Already working well, just one click:',
  // F9: 429 screen — daily quota, named honestly (not a quality refine).
  'prism.rateLimit.title': 'You’ve reached today’s limit for live searches.',
  'prism.rateLimit.body':
    'This has nothing to do with your target audience — we cap the free live searches per day. Your target audience and website stay saved.',
  'prism.rateLimit.reset': 'Your quota resets at {time}.',
  'prism.rateLimit.cta': 'Back to the start',
  // D2 (LEA-430): "welcome back" resume + honest timer alternative.
  'prism.resume.title': 'Welcome back!',
  'prism.resume.body': 'Your search for {audience} is done — your result is saved.',
  'prism.resume.cta': 'View result',
  'prism.resume.dismiss': 'Start a new search',
  'prism.resume.saved': 'Your selection is saved — no time pressure.',
  'prism.understood.title': 'Your business, understood',
  'prism.understood.opps': 'Opportunities',
  // Wave 2: label above the highlighted "why now" line.
  'prism.understood.momentumLabel': 'Why now:',
  // DEPRECATED (Wave 2): "Watch out for" is no longer rendered (legacy bundles).
  'prism.understood.risks': 'Watch out for',
  'prism.understood.demoModel': 'B2B service helping mid-sized firms win new customers.',
  'prism.understood.demoOpp1': 'Clearly defined niche with high deal value',
  'prism.understood.demoOpp2': 'Little specialized competition in the region',
  'prism.understood.demoOpp3': 'Decision-makers directly reachable (small teams)',
  'prism.understood.demoRisk1': 'Long decision cycles in mid-market',
  'prism.understood.demoRisk2': 'First outreach needs a concrete hook',
  'prism.seed.badge': 'Starter pack',
  'prism.seed.working': '{delivered}/{total} leads delivered',
  'prism.seed.workingSub':
    'This takes 10 to 30 minutes. New leads appear automatically. Best to export once they are all in.',
  'prism.seed.creditsNote':
    'Your {total} starter credits are redeemed as we go: 1 credit per finished lead.',
  'prism.seed.done': 'All {delivered} leads are in your account.',
  'prism.seed.donePartial': '{delivered} leads delivered, remaining credits stay in your balance.',
  'prism.refine.cta': 'Sharpen my audience now',
  // Results (aha)
  // Wave 2: the real kept-count now carries the headline.
  'prism.results.foundSuffix': 'companies found in your target audience',
  // #4 (Quickwins): personalized headline variant — {audience} arrives as a
  // ready-made »quote« from the client (never inflect, gate lives client-side).
  'prism.results.foundSuffixAud': 'companies found matching {audience}',
  // DEPRECATED (#13): "only X match" undersells the engine and contradicts
  // the 50-unlock — replaced by topLine (abundance + curation).
  'prism.results.matched': '{count} match your target audience',
  // #13: story = we show the strongest matches, the market has more of them.
  'prism.results.topLine': 'Below: your strongest matches by fit.',
  // Wave 2: crossfade label target for the number morph (reserved; the
  // "live-checked" framing currently carries foundSuffix).
  'prism.results.checkedLabel': 'of those live-checked, your strongest',
  // DEPRECATED (Wave 2): replaced by prism.results.matched.
  'prism.results.checked': "We've already live-checked {count} of them",
  'prism.results.unlockHint': 'Unlock your first',
  'prism.results.unlockOffer': '{n} matching companies for €49',
  'prism.results.disclaimer':
    "Market-potential estimate based on your live analysis: these are exactly the companies we'll find for you.",
  'prism.results.stat.checked': 'companies found',
  // Wave 2: new real stat labels.
  'prism.results.stat.onTarget': 'match your target audience',
  // #13: market-abundance tile instead of "X match" — real engine estimate
  // (market.projected_range_dach); tile is omitted when no estimate exists.
  'prism.results.stat.market': 'companies in your market (estimate)',
  'prism.results.stat.avgFit': 'Avg. fit score of your strongest matches',
  // DEPRECATED (Wave 2): synthetic tiles — no longer rendered.
  'prism.results.stat.contacts': 'contacts findable',
  'prism.results.stat.revenue': 'audience revenue potential',
  'prism.results.chart.sizeTitle': 'Companies by size',
  'prism.results.chart.sizeMuted': 'in your target audience',
  'prism.results.chart.emp1': '1–9 staff',
  'prism.results.chart.emp2': '10–49 staff',
  'prism.results.chart.emp3': '50–199 staff',
  'prism.results.chart.emp4': '200+ staff',
  'prism.results.chart.qualityTitle': 'Data quality of your leads',
  'prism.results.chart.qualityMuted': 'checked today',
  'prism.results.chart.mail': 'Verif. email',
  'prism.results.chart.dial': 'Direct dial',
  'prism.results.chart.decider': 'Decision-maker',
  'prism.results.insights.title': 'Potential & timing for your target audience',
  'prism.results.insights.openRate': 'avg. open rate of verified B2B emails',
  'prism.results.insights.bestTimeValue': 'Tue–Thu · 9–11 am',
  'prism.results.insights.bestTime': 'Best outreach time in this industry',
  'prism.results.insights.dealValue': 'avg. deal value per customer won',
  'prism.results.insights.competitionValue': 'low',
  'prism.results.insights.competition': 'Cold-outreach competition in your region',
  'prism.results.why.title': 'Good timing:',
  'prism.results.why.p1': 'Your target audience has recently seen',
  'prism.results.why.strong': '18% more new decision-makers',
  'prism.results.why.p2':
    'become active, the ideal window for a first touch, before your competitors catch on.',
  'prism.results.timing.title': 'Why right now is the perfect moment',
  'prism.results.timing.legend': 'Best outreach window for your target audience, now',
  'prism.timing.text':
    "In {month}, {who} are typically at their most reachable: budgets for the coming quarter are being allocated and decision-makers actually pick up the phone. Make first contact now and you're in before your competitors follow in {next}.",
  // Months (seasonality chart + timing text)
  'prism.month.now': 'Now',
  'prism.month.short.1': 'Jan',
  'prism.month.short.2': 'Feb',
  'prism.month.short.3': 'Mar',
  'prism.month.short.4': 'Apr',
  'prism.month.short.5': 'May',
  'prism.month.short.6': 'Jun',
  'prism.month.short.7': 'Jul',
  'prism.month.short.8': 'Aug',
  'prism.month.short.9': 'Sep',
  'prism.month.short.10': 'Oct',
  'prism.month.short.11': 'Nov',
  'prism.month.short.12': 'Dec',
  'prism.month.long.1': 'January',
  'prism.month.long.2': 'February',
  'prism.month.long.3': 'March',
  'prism.month.long.4': 'April',
  'prism.month.long.5': 'May',
  'prism.month.long.6': 'June',
  'prism.month.long.7': 'July',
  'prism.month.long.8': 'August',
  'prism.month.long.9': 'September',
  'prism.month.long.10': 'October',
  'prism.month.long.11': 'November',
  'prism.month.long.12': 'December',
  // Free lead
  'prism.freelead.tag': 'Your first lead, on us',
  'prism.freelead.verified': 'verified',
  'prism.freelead.lockedChip': '🔒 Contact person & contact details after unlocking',
  'prism.freelead.note1': 'This is what',
  'prism.freelead.noteStrong': 'every one',
  'prism.freelead.note2':
    'of your {n} matching companies looks like: a real contact person with email or phone. You unlock the other {rest} in the next step.',
  'prism.freelead.alt1':
    'This company matches your target audience. Once you unlock, we enrich it with',
  'prism.freelead.altStrong': 'real contact people with email or phone',
  'prism.freelead.alt2': ', for all {n}.',
  // Lead rows
  'prism.lead.ap': 'Contact people',
  'prism.lead.inclDeciders': 'after unlocking',
  'prism.results.moreStrong': '≈{count} more',
  'prism.results.moreRest': 'companies found. We research the contacts after you unlock.',
  'prism.results.planTitle': 'Your starter acquisition plan:',
  'prism.results.planBody':
    'the {n} strongest companies first, contact people with email or phone, exportable as CSV or Excel.',
  'prism.results.cta': 'Unlock my {n} matching companies',
  'prism.results.detailsLink': 'What exactly is included?',
  'prism.results.foot': '€49 today · {n} matching companies · from day 4: €290/month, cancel anytime',
  // Paywall
  'prism.paywall.step2': 'Unlock',
  'prism.paywall.step3': 'Get started',
  'prism.paywall.resPrefix': 'Your',
  'prism.paywall.resStrong': '50 leads',
  'prism.paywall.resSuffix': 'are reserved for you',
  'prism.paywall.resExpired':
    "Reservation expired: we're holding your search for a little while longer.",
  'prism.paywall.eyebrow': '{count} companies found, ready to unlock',
  'prism.paywall.title1': 'Unlock your first',
  'prism.paywall.titleGrad': '{n} matching companies',
  'prism.paywall.title2': 'now.',
  // #4 (Quickwins): personalized H1 variant ({audience} = ready-made »quote«).
  'prism.paywall.title2Aud': 'for {audience} now.',
  'prism.paywall.sub1': 'We found',
  'prism.paywall.subStrong1': '{count} companies',
  'prism.paywall.sub2': 'matching {audience}. The',
  'prism.paywall.subStrong2': '{n} strongest',
  'prism.paywall.sub3':
    'are waiting for you. We research the contact people and contact details after you unlock.',
  // Lead vault
  'prism.vault.title': 'Your {n} strongest companies are ready',
  // Wave 2: 3-stage story from real numbers — {count}=discovery.kept
  // (live-checked), {audience}=typed target audience.
  // #13: no more "exactly X match" (contradicted "50 strongest" and shrank
  // the market) — {onTarget} stays as an unused-but-compatible placeholder.
  'prism.vault.sub':
    'Out of {count} companies found for {audience}: here are your {n} strongest. We research the contact people and contact details after you unlock.',
  'prism.vault.locked': 'locked',
  'prism.vault.blurEmail': 'contact@company.com',
  // Wave 2: real remaining count from the scored pool instead of a static "+45".
  'prism.vault.more': '+ {count} more companies found, locked',
  'prism.vault.cta': 'Unlock all {n}: €49',
  'prism.vault.reassure': '€49 today · from day 4: €290/month · cancel anytime',
  // Founder card + video
  'prism.founder.head': 'A personal note from the founder',
  'prism.founder.quote':
    "\"Hey, I'm Janik. I'll personally look after you throughout your entire trial, and the entry price is deliberately low, so you can try Leadscraper in peace. Give us a shot: I'm confident we're a great fit for you.\"",
  'prism.founder.role': 'Founder · Leadscraper',
  'prism.video.playAria': 'Play demo video',
  'prism.video.chip': 'Live demo · 10:04',
  'prism.video.title': 'Watch Janik find your first leads',
  'prism.video.cta': 'Watch the demo: real search, real dashboard',
  'prism.video.iframeTitle': 'Live demo · Leadscraper',
  // Timeline (how your trial works)
  'prism.timeline.title': 'How your 3-day trial works',
  'prism.timeline.today': 'Today',
  'prism.timeline.todayStrong': '€49 today',
  'prism.timeline.todayRest': ', {n} matching companies unlocked, in your account within 10 to 30 minutes.',
  'prism.timeline.days13': 'Days 1–3',
  'prism.timeline.testP1': 'You test with real leads.',
  'prism.timeline.testStrong': '3 full days',
  'prism.timeline.testP2': ": not a fit? Cancel with 1 click, and you won't pay another cent.",
  'prism.timeline.day4': 'From day 4',
  'prism.timeline.aboP1': 'Then your plan with',
  'prism.timeline.aboStrong': '250 credits for €290/month',
  'prism.timeline.aboP2': 'continues — cancel anytime.',
  // Versus block
  'prism.versus.title': 'Why Leadscraper, and not the usual way',
  'prism.versus.oldTitle': 'The usual way',
  'prism.versus.old1': 'Hours of manual googling or buying stale lists',
  'prism.versus.old2': 'High bounce rates, GDPR grey zone',
  'prism.versus.old3': 'Piecing together contact people by hand',
  'prism.versus.old4': '€1,000–1,500/month + annual contract (Cognism, Dealfront)',
  'prism.versus.old5': 'Weeks until the first reply',
  'prism.versus.newTitle': 'With Leadscraper',
  'prism.versus.new1': '{n} matching companies in 10 to 30 minutes, tailored to your audience',
  'prism.versus.new2': 'Email addresses technically checked, phone where available',
  'prism.versus.new3': 'Contact people included by default',
  'prism.versus.new4': 'Try for €49 · cancel monthly · no annual contract',
  'prism.versus.new5': 'Export today, reach out tomorrow',
  'prism.versus.foot1': 'The same work others spend',
  'prism.versus.footStrong1': 'weeks',
  'prism.versus.foot2': 'and',
  'prism.versus.footStrong2': 'over €1,000/month',
  'prism.versus.foot3': 'on, yours today, to try for',
  'prism.versus.footStrong3': '€49',
  // ROI panel
  'prism.roi.title': 'What your {n} matching companies are worth',
  'prism.roi.row1': 'Leads with contact people, ready in 10 to 30 minutes',
  'prism.roi.row2': 'Your cost today',
  'prism.roi.row3': 'Just 1 won customer brings',
  'prism.roi.row3v': 'many times that back',
  'prism.roi.hl1': 'A',
  'prism.roi.hlStrong': 'single',
  'prism.roi.hl2':
    'customer from your first {n} matching companies pays back the €49 many times over: everything after that is pure upside.',
  'prism.roi.perLead': 'per ready-to-use lead',
  'prism.roi.stat2v': '10–30 min',
  'prism.roi.stat2': 'instead of weeks of research',
  'prism.roi.stat3v': '3 days',
  'prism.roi.stat3': 'trial before the plan starts',
  // Plan card
  'prism.plan.badge': 'Intro offer · 3-day trial',
  'prism.plan.leadsUnit': 'matching companies · contact people within 10 to 30 minutes',
  'prism.plan.anchor': 'Doing it yourself: ~10 hrs of manual research',
  'prism.plan.priceSuffix': 'today',
  'prism.price.netVat': 'plus VAT',
  'prism.plan.perLeadStrong': 'under €1',
  'prism.plan.f1': 'Email addresses technically checked, phone where available',
  'prism.plan.f2': 'Contact people per company, where publicly findable',
  'prism.plan.f3': 'Export as CSV or Excel, CRM connection possible',
  'prism.plan.cta': 'Unlock now: €49',
  'prism.plan.secure': 'Secure payment via Stripe · SSL-encrypted',
  'prism.plan.subnote': 'Cancel anytime with 1 click in your account.',
  'prism.plan.gbCondition': 'Guarantee conditions: see § 7 of our',
  'prism.guarantee.title': 'Money-back guarantee',
  'prism.guarantee.sub':
    'Within the 3 trial days we refund your €49: email support@leadscraper.eu, fill in our short feedback form, and we end your plan along with the refund. This intro offer only.',
  'prism.legal.agb': 'Terms',
  'prism.legal.agbUrl': 'https://www.leadscraper.de/en/terms-and-conditions',
  'prism.legal.privacyUrl': 'https://www.leadscraper.de/en/privacy-policy',
  'prism.legal.privacy': 'Privacy policy',
  // Reviews band (headings — customer quotes/names deliberately untranslated)
  'prism.reviews.title': 'Sales teams that already made the switch',
  // Trust bar
  'prism.trust.payStrong': '€49 today',
  'prism.trust.payRest': '· card, PayPal, Apple & Google Pay, secure via Stripe',
  'prism.trust.cancelStrong': 'Cancel anytime',
  'prism.trust.cancelRest': '· with 1 click in your account, no notice period, no questions asked',
  'prism.trust.dataStrong': 'Public data only',
  'prism.trust.dataRest': '· GDPR by design · servers in the EU',
  // FAQ
  'prism.faq.title': 'Frequently asked questions',
  'prism.faq.q1': 'What happens after the 3 days?',
  'prism.faq.a1':
    'From day 4 your plan continues with 250 credits for €290/month, cancel anytime with one click. So you get the full 3 days to decide, no pressure.',
  'prism.faq.q2': 'Can I cancel anytime?',
  'prism.faq.a2':
    'Yes, monthly: one click in your account, no notice period, no questions. Cancel within the 3 trial days and you only pay the €49. Later, your access runs until the end of the paid month.',
  'prism.faq.q3': 'Where do the leads come from? Is this GDPR-compliant?',
  'prism.faq.a3':
    'Exclusively from publicly available company data. GDPR by design: processing and servers entirely within the EU.',
  'prism.faq.q4': "What if the leads aren't a fit?",
  'prism.faq.a4':
    'Within the 3 trial days we refund your €49 if you fill in our short feedback form (Terms § 7). Email support@leadscraper.eu; with the refund we end your plan. After that no refund is possible, but you can cancel the plan at any time.',
  'prism.faq.q5': 'Do I get real contact people?',
  'prism.faq.a5':
    'Yes: researched contact people per company, with an email address or phone number. Email addresses are technically checked; we cannot guarantee that every mailbox exists. If no reachable contact is found for a company, nothing is charged for it.',
  // Founder line
  'prism.founderline.strong': 'Founder-led, from Hamburg',
  'prism.founderline.rest': ', Janik Deimann, founder',
  'prism.founderline.sub': "Deimann Com GmbH · You'll reach real people here, not a ticket queue.",
  'prism.founderline.ask': 'Still unsure? Email us: support@leadscraper.eu, a human replies.',
  // Sticky buy bar
  'prism.sticky.leads': '{n} matching companies ·',
  'prism.sticky.today': 'today · from day 4: €290/month',
  'prism.sticky.cta': 'Unlock now',
  // Inline checkout
  'prism.checkout.eyebrow': 'Intro offer · €49 today',
  'prism.checkout.title': '{n} matching companies · unlock now',
  'prism.checkout.sumPrice': '€49 today',
  'prism.checkout.sumDesc': '{n} matching companies unlocked, 3-day trial',
  'prism.checkout.after': 'from day 4',
  'prism.checkout.monthly': '€290 / month',
  'prism.checkout.reassure3d':
    'Cancel within the 3 days and you pay only the €49. Your leads stay yours: you can still view and export them afterwards.',
  'prism.checkout.deliverNote':
    'This search has {count} matching companies ready. A credit only counts when we find a contact; the rest of your 50 credits is yours for further searches.',
  'prism.checkout.cancelNote': 'Cancel the subscription anytime, one click.',
  'prism.checkout.invite':
    'Consider this our invitation: 50 leads once at cost price, purely to get you started, so you can try Leadscraper risk-free.',
  'prism.checkout.or': 'or pay by card',
  'prism.checkout.tabCard': 'Card',
  'prism.checkout.tabSepa': 'SEPA direct debit',
  'prism.checkout.cardholder': 'Cardholder',
  'prism.checkout.cardholderPh': 'John Smith',
  'prism.checkout.cardNumber': 'Card number',
  'prism.checkout.expiry': 'Expiry',
  'prism.checkout.expiryPh': 'MM / YY',
  'prism.checkout.country': 'Country',
  'prism.checkout.countryDe': 'Germany',
  'prism.checkout.countryAt': 'Austria',
  'prism.checkout.countryCh': 'Switzerland',
  'prism.checkout.paying': 'Activating …',
  'prism.checkout.embedLoading': 'Loading secure payment …',
  'prism.checkout.payCta': 'Unlock {n} matching companies: €49',
  'prism.checkout.securePrefix': 'Secure payment via',
  'prism.checkout.secureSuffix': '· SSL-encrypted',
  // Wave 2: generic button reference — the live CTA of the PaymentElement
  // (locked zone) reads "Continue to payment", not "Unlock 50 leads".
  'prism.checkout.fine1': 'By clicking the button above, you accept the',
  'prism.checkout.fine2':
    'as well as automatic renewal as the Starter plan (250 credits / €290 per month) from day 4, cancel anytime with one click. This offer is exclusively for businesses and self-employed professionals (B2B, § 14 German Civil Code). All prices net, plus statutory VAT. Money-back guarantee: this intro offer only, within the 3 trial days only, and with a completed feedback form (Terms § 7).',
  // Success screen
  'prism.success.title': '{n} matching companies unlocked',
  'prism.success.body':
    'Your {n} matching companies are unlocked. The contact people follow within 10 to 30 minutes, ready to export to CSV or your CRM. From day 4 your Starter plan runs (250 credits/month), cancel monthly.',
  'prism.success.cta': "Let's go",
  // --- Autopilot-Modus (Port aus feat/autopilot-setup-experience) ---
  'autopilot.act.title': 'Latest activity',
  'autopilot.appr.action': 'Approve',
  'autopilot.appr.givenShort': 'Approved',
  'autopilot.appr.opsShort': 'Approved by us',
  'autopilot.appr.opsFeedback':
    'We have reviewed and approved this, so there is nothing you need to do. If it works for you, you can confirm it here. Please send any change requests straight to your contact person.',
  'autopilot.appr.opsNoAction':
    'We have reviewed and approved this, so there is nothing you need to do. Please send any change requests straight to your contact person.',
  'autopilot.appr.opsChanged':
    'The content has changed since your feedback on {date}. We have reviewed and approved the current version.',
  'autopilot.appr.opsConfirm': 'Looks good to me',
  'autopilot.appr.opsConfirmAsk': 'Save your feedback?',
  'autopilot.appr.opsDone': 'Thanks, your feedback has been saved.',
  'autopilot.appr.opsAllDone': 'Everything is approved. If anything looks off, just let us know.',
  'autopilot.appr.launchHintOps':
    'We approve the launch once the audience, messages and reply handling have been reviewed.',
  'autopilot.camp.readonlyOps':
    'Want to change something? Tell your contact person and we will adjust it.',
  'autopilot.appr.pvShow': 'View',
  'autopilot.appr.pvHide': 'Collapse',
  'autopilot.appr.pvShowFirst': 'First review what you approve',
  'autopilot.appr.pvHeading': 'This is what you approve',
  'autopilot.appr.pvSampleTitle': 'Sample of target companies',
  'autopilot.appr.pvSampleFoot':
    'A sample from your audience — you see the full list during operation.',
  'autopilot.appr.pvEmpty': 'Content is being prepared for you.',
  'autopilot.appr.pvFirms': '{n} companies',
  'autopilot.appr.pvPace': '{n}/day',
  'autopilot.appr.pvStart': 'Immediately',
  'autopilot.appr.pvWait': '+{d} days',
  'autopilot.appr.pvSubject': 'Subject:',
  'autopilot.appr.variantA': 'Variant A',
  'autopilot.appr.variantB': 'Variant B',
  'autopilot.appr.subject': 'Subject:',
  'autopilot.seq.variantA': 'Variant A',
  'autopilot.seq.variantB': 'Variant B',
  'autopilot.seq.subject': 'Subject:',
  'autopilot.appr.staleCopy':
    'The texts have changed since your approval on {date}. Please review and approve them again.',
  'autopilot.appr.stale':
    'The content or prerequisites have changed since your approval on {date}. Please review and approve them again.',
  'autopilot.appr.pvAb': 'A/B variant:',
  'autopilot.appr.pvLaunchReady': 'All content is approved — on start, the first email goes out.',
  'autopilot.appr.pvLaunchWait': 'Start unlocks once the three approvals above are in place.',
  'autopilot.appr.allDone':
    'Everything approved — we will launch your campaign and let you know once it is live.',
  'autopilot.appr.confirmAsk': 'Approve bindingly?',
  'autopilot.appr.copy': 'Copy & sequence',
  'autopilot.appr.copyHint':
    'Your emails, fully written — the engine fills the variables per company, individually.',
  'autopilot.appr.done': 'Approval recorded — with timestamp and checksum.',
  'autopilot.appr.error': 'Approval failed — please try again.',
  'autopilot.appr.given': 'Approved on {date}',
  'autopilot.appr.hash': 'Checksum',
  'autopilot.appr.icp': 'Audience & segment',
  'autopilot.appr.icpHint':
    'Who your engine reaches out to — industries, regions, decision-makers.',
  'autopilot.appr.intro':
    'You approve, we execute. Every approval is documented — you stay in control of audience, content and launch.',
  'autopilot.appr.launch': 'Campaign launch',
  'autopilot.appr.launchHint': 'Your final approval — only then does the first email go out.',
  'autopilot.appr.locked': 'Unlocks once the other approvals are in place',
  'autopilot.appr.logIntro':
    'Every approval is recorded with a timestamp; the approved content is frozen and anchored with a checksum.',
  'autopilot.appr.logTitle': 'Approval log',
  'autopilot.appr.pending': 'Waiting for you',
  'autopilot.appr.preparingShort': 'In preparation',
  'autopilot.appr.preparing':
    "Content is being prepared — you'll be notified as soon as you can approve it.",
  'autopilot.appr.playbook': 'Reply playbook',
  'autopilot.appr.playbookHint': 'How we answer questions in your name before handing over.',
  'autopilot.appr.soon': 'Content is being prepared for you',
  'autopilot.appr.title': 'Your approvals',
  'autopilot.camp.approvedAt': 'Approved by you on {date}',
  'autopilot.camp.approvedShort': 'Approved — start to follow',
  'autopilot.camp.audience': 'Audience',
  'autopilot.camp.audienceN': '{n} companies in the segment',
  'autopilot.camp.awaitApproval': 'Waiting for your launch approval',
  'autopilot.camp.back': 'All campaigns',
  'autopilot.camp.chip.paused': 'Paused',
  'autopilot.camp.chip.running': 'Running',
  'autopilot.camp.chip.scheduled': 'Scheduled',
  'autopilot.camp.hideMail': 'Collapse',
  'autopilot.camp.nextSend': 'Next send {when}',
  'autopilot.camp.open': 'View',
  'autopilot.camp.pace': 'up to {n} emails/day across your mailboxes',
  'autopilot.camp.progress': '{done} of {total} companies contacted',
  'autopilot.camp.queue': '{n} verified companies queued',
  'autopilot.camp.readonly':
    'Want to change something? Tell your contact — every change goes live only after your approval.',
  'autopilot.camp.runningSince': 'running since {date}',
  'autopilot.camp.sReplies': '{n} replies',
  'autopilot.camp.sSent': '{n} sent',
  'autopilot.camp.sectionRunning': 'Running now',
  'autopilot.camp.sectionPlanned': 'Planned — starts after your approval',
  'autopilot.camp.statsAfterStart': 'Send and reply numbers appear once the campaign is live.',
  'autopilot.seq.letterChip': 'Letter · by post',
  'autopilot.camp.showLetter': 'View letter',
  'autopilot.camp.hideLetter': 'Hide letter',
  'autopilot.rep.gateSource': 'Source: {label}.',
  'autopilot.ch.letter.one': '1 letter',
  'autopilot.ch.letter.many': '{n} letters',
  'autopilot.ch.mail.one': '1 email',
  'autopilot.ch.mail.many': '{n} emails',
  'autopilot.ch.legendLetter': 'Letter',
  'autopilot.ch.legendMail': 'Email',
  'autopilot.ov.kamp.vonFirmen': 'of {n} companies',
  'autopilot.ov.mod.post': 'Mailboxes',
  'autopilot.ov.mod.briefe': 'Letter mail',
  'autopilot.ov.briefe.zeile': 'letters sent · {r} replies',
  'autopilot.ov.briefe.zeileOne': 'letters sent · 1 reply',
  'autopilot.ov.kpi.rateFoot': '{p}% reply rate',
  'autopilot.ov.kpi.repliesFootLeer': 'The rate appears with the first send',
  'autopilot.ov.kpi.handoverFoot': '{p}% of replies',
  'autopilot.ov.kpi.handoverFootLeer': 'We hand matching replies over to you',
  'autopilot.ov.kpi.wonFoot': '{v} deal value',
  'autopilot.ov.kpi.wonFootLeer': 'The value appears with your first deal',
  'autopilot.ov.kamp.zielfirmen': 'target companies',
  'autopilot.ov.post.anzahl': 'mailboxes',
  'autopilot.ov.mod.betreuung': 'Your contact',
  'autopilot.ov.kpi.seitStart': 'since campaign start',
  'autopilot.ov.kpi.proGespraech': '{v} per conversation',
  'autopilot.ov.kpi.proPositiv': 'Cost per positive reply: {v}',
  'autopilot.ov.kpi.positivLabel': 'Positive replies',
  'autopilot.ov.kpi.positivFoot': '{p}% of replies are positive',
  'autopilot.ov.zu.title': 'Reaching the inbox',
  'autopilot.ov.zu.sub': 'of {n} warmup emails in the last 7 days',
  'autopilot.ov.betrieb.post': '{n} mailboxes sending',
  'autopilot.ov.betrieb.laeuft': 'Campaign running',
  'autopilot.ov.betrieb.briefe': '{n} letters in transit',
  'autopilot.ov.betrieb.kontakt': '{name} is your direct line',
  'autopilot.ov.auf.uebergabe': '{firma} is waiting for your call',
  'autopilot.ov.auf.freigabeHint': 'Nothing goes out without your approval.',
  'autopilot.ov.post.sendend': '{n} currently sending',
  'autopilot.ov.post.schwach': 'Weakest mailbox: {n} — we are on it',
  'autopilot.fun.deliveredFoot':
    '{n} emails delivered — more than companies contacted, because follow-ups count too.',
  'autopilot.appr.zf.ls.preparing': 'Letter in preparation',
  'autopilot.appr.zf.ls.printed': 'Letter printed',
  'autopilot.appr.zf.ls.mailed': 'Letter on its way',
  'autopilot.appr.zf.ls.replied': 'Reply received',
  'autopilot.camp.sendTbd': 'Pace and send window are set with your launch approval.',
  'autopilot.camp.sending': 'Sending',
  'autopilot.camp.sequence': 'The sequence',
  'autopilot.camp.sequenceHint':
    'Every email is one of a kind: the engine fills in salutation, name and company per contact. Highlighted are sample values (Ms Muster, Musterbetrieb GmbH).',
  'autopilot.camp.showMail': 'View email',
  'autopilot.camp.startsAt': 'Starts {when}',
  'autopilot.camp.stepStart': 'Sequence start',
  'autopilot.camp.stepWait': '+{n} days later',
  'autopilot.camp.subject': 'Subject',
  'autopilot.contact.hint':
    'Direct line, no ticket system. The emergency stop lives in the campaign under “Launch”.',
  'autopilot.contact.title': 'Your contact',
  'autopilot.contact.write': 'Write a message',
  'autopilot.end.testing': 'Currently testing: {label}',
  'autopilot.exp.empty':
    'Once your engine runs test hypotheses, you will see here what is being tested — and why.',
  'autopilot.exp.since': 'since {date}',
  'autopilot.exp.title': 'Experiments',
  'autopilot.foot.details': 'Details in Tech',
  'autopilot.foot.quota': 'Quota {used}/{target}',
  'autopilot.health.amber': 'Under watch',
  'autopilot.health.blacklistOk': 'Blacklists clean',
  'autopilot.health.bounce': 'Bounce rate {n}%',
  'autopilot.health.green': 'All systems green',
  'autopilot.health.red': 'We are on it',
  'autopilot.health.suppressed': '{n} unsubscribes honored, blocked across campaigns',
  'autopilot.health.title': 'System health',
  'autopilot.hist.campaigns': 'Completed',
  'autopilot.hist.completed': 'completed',
  'autopilot.hist.emptyHint':
    'Once your first campaign runs, campaign results and completed test outcomes collect here.',
  'autopilot.hist.emptyTitle': 'No history yet',
  'autopilot.hist.intro':
    'What is running now, what has run — and what your engine learned along the way. View and click through. You agree changes with your account contact.',
  'autopilot.hist.ongoing': 'ongoing',
  'autopilot.hist.running': 'running',
  'autopilot.hist.steps': '{n} sequence steps',
  'autopilot.hist.tests': 'Completed tests',
  'autopilot.hist.tie': 'Tie',
  'autopilot.hist.title': 'Campaigns',
  'autopilot.hist.vs': 'vs',
  'autopilot.ho.none': 'No open handovers — the engine is working.',
  'autopilot.ho.title': 'Warm handovers',
  'autopilot.infra.dns': 'Email authentication configured (SPF · DKIM · DMARC)',
  'autopilot.infra.domain': 'Sending domain registered — in your name',
  'autopilot.infra.mailboxes': 'Mailboxes provisioned',
  'autopilot.infra.title': 'Your infrastructure',
  'autopilot.infra.verify': 'Domain verified & cleared for sending',
  'autopilot.infra.yourTask': 'Your task',
  'autopilot.setup.title': 'Your engine is being built',
  'autopilot.setup.intro': 'What we are setting up for you right now — every step documented.',
  'autopilot.setup.ev.domain_registered':
    "Sending domain {domain} registered — in your company's name, you are the owner.",
  'autopilot.setup.ev.dns_shield':
    'DNS security net for {domain} in place: sender authentication (SPF · DKIM · DMARC) and anti-spoofing protection active.',
  'autopilot.setup.ev.redirect_live':
    '{domain} now takes visitors straight to {target} — full transparency for every recipient.',
  'autopilot.setup.ev.mailboxes_created':
    '{n} mailboxes set up on {domain}, secured and encrypted.',
  'autopilot.setup.ev.warmup_started':
    'Warm-up network started: {n} mailboxes are now building delivery reputation day by day.',
  'autopilot.setup.ev.warmup_progress':
    'Warm-up day {day} of {total} — {rate}% inbox placement across the network.',
  'autopilot.setup.ev.blacklist_clean': 'Reputation check: {n} blocklists screened — all clear.',
  'autopilot.kpi.contacted': 'Contacted',
  'autopilot.kpi.delivered': 'Delivered',
  'autopilot.kpi.handovers': 'Handovers',
  'autopilot.kpi.lockedHint': 'Numbers appear once your campaign is running.',
  'autopilot.kpi.modulePrice': 'Module: {price}/month',
  'autopilot.kpi.replies': 'Replies',
  'autopilot.kpi.won': 'Won',
  'autopilot.kpi.wonValueLabel': 'in deals won',
  'autopilot.mb.empty': 'Your mailboxes are being set up.',
  'autopilot.mb.place.title': 'Where your warm-up emails land',
  'autopilot.mb.place.hint': 'Warm-up emails landing in inbox and spam across all your mailboxes.',
  'autopilot.mb.place.sent': 'Sent',
  'autopilot.mb.place.inbox': 'Inbox',
  'autopilot.mb.place.spam': 'Spam',
  'autopilot.mb.place.rate': '{pct}% inbox rate',
  'autopilot.mb.place.sentLine': 'Sent (ramp-up)',
  'autopilot.mb.place.ratePct': '% inbox rate',
  'autopilot.mb.sum.score': 'Avg. delivery score {n}',
  'autopilot.mb.sum.cta': 'Open warm-up',
  'autopilot.nav.warmup': 'Warm-up',
  'autopilot.warm.introTitle': 'Your warm-up phase',
  'autopilot.warm.introLead':
    'Before the first real email goes out, your mailboxes build sender reputation — with real, daily-growing email traffic. This is the invisible work that later decides between inbox and spam.',
  'autopilot.warm.p1t': 'Real email traffic',
  'autopilot.warm.p1':
    'Your mailboxes exchange emails daily with a network of well-kept mailboxes — including replies, like real conversations. No simulation, real traffic.',
  'autopilot.warm.p2t': 'Reputation builds',
  'autopilot.warm.p2':
    'The major mail providers watch new senders closely. Clean, natural traffic marks your domains as trustworthy — a key factor in whether your emails land later.',
  'autopilot.warm.p3t': 'About 4 weeks of craft',
  'autopilot.warm.p3':
    'Volume ramps up gently, day by day. Cutting corners would damage the reputation — which is why a low base level keeps running even once you are live.',
  'autopilot.warm.traffic.title': 'Warmup traffic across your mailboxes',
  'autopilot.warm.traffic.hint':
    'Outgoing warmup emails and warmup emails recorded in the inbox across all your mailboxes.',
  'autopilot.warm.traffic.out': 'sent out',
  'autopilot.warm.traffic.in': 'received',
  'autopilot.ov.ring.day': 'Day',
  'autopilot.ov.ring.warm': 'Your mailboxes are warming up',
  'autopilot.ov.ring.building': 'Your engine is being built',
  'autopilot.ov.ring.ready': 'Ready to launch — your approvals are missing',
  'autopilot.ov.ring.launch': 'First send ~{date}',
  'autopilot.ov.ring.rateLabel': 'Inbox',
  'autopilot.ov.ring.daySub': 'Day {d} of {total}',
  'autopilot.ov.today.recent': 'Latest',
  'autopilot.ov.hero.warmLine':
    'Your mailboxes are building trust with the major mail providers — so your emails land later.',
  'autopilot.ov.hero.buildLine':
    'We are building your sending infrastructure: domains, mailboxes, protective shields.',
  'autopilot.ov.hero.startLabel': 'Your campaign starts',
  'autopilot.ov.hero.phase1Label': 'First sends from',
  'autopilot.ov.hero.phase1Sub': 'low volume · full ramp-up ~{date}',
  'autopilot.warm.traffic.weekend': 'Weekend — the warmup network winds down on schedule',
  'autopilot.warm.traffic.pause': 'Rest day in the warmup network',
  'autopilot.warm.traffic.weekendShort': 'W/E',
  'autopilot.warm.traffic.pauseShort': 'Pause',
  'autopilot.ov.hero.rampLabel': 'Full ramp-up from',
  'autopilot.ov.hero.phase2Sub': 'first sends are live — volume increases step by step',
  'autopilot.appr.zf.loading': 'Loading target companies …',
  'autopilot.appr.zf.passt': 'Fits',
  'autopilot.appr.zf.raus': 'Remove',
  'autopilot.appr.zf.raus2': 'Removed',
  'autopilot.appr.zf.alle': 'Show all {n} companies',
  'autopilot.appr.zf.weniger': 'Show fewer',
  'autopilot.appr.zf.stand': '{rated} of {n} rated',
  'autopilot.appr.zf.chipLetter': '✉ Letter',
  'autopilot.appr.zf.title': 'Your target companies',
  'autopilot.appr.zf.dabei': '{n} included · {raus} removed',
  'autopilot.appr.zf.lead':
    'We contact every company you don’t exclude. A checkmark is optional and helps us understand which companies you prefer.',
  'autopilot.appr.zf.f.alle': 'All {n}',
  'autopilot.appr.zf.f.dabei': 'Included {n}',
  'autopilot.appr.zf.f.raus': 'Excluded {n}',
  'autopilot.appr.zf.f.ohneKontakt': 'No contact {n}',
  'autopilot.camp.offenN': '{n} approvals pending: {liste}',
  'autopilot.camp.offen1': 'One approval pending: {liste}',
  'autopilot.appr.zf.neuTitle': 'New since your last visit',
  'autopilot.appr.zf.neuChip': '{n} new',
  'autopilot.appr.zf.th.firma': 'Company',
  'autopilot.appr.zf.th.ort': 'City',
  'autopilot.appr.zf.th.kontakt': 'Contact',
  'autopilot.appr.zf.th.grund': 'Why this company',
  'autopilot.appr.zf.kontaktFolgt': 'being researched',
  'autopilot.appr.zf.wieder': 'Re-include',
  'autopilot.appr.zf.passtTitle': 'Optional: confirms the match and helps the engine learn',
  'autopilot.appr.zf.suche': 'Search …',
  'autopilot.appr.kampagne': 'Campaign',
  'autopilot.appr.sammel.titel': 'All {n} preparation approvals at once',
  'autopilot.appr.sammel.hint':
    'The campaign start stays a separate step. Every approval is logged individually.',
  'autopilot.appr.sammel.btn': 'Approve all {n}',
  'autopilot.appr.sammel.confirm': 'Grant {n} approvals bindingly?',
  'autopilot.appr.sammel.cancel': 'Cancel',
  'autopilot.appr.zf.st.dabei': 'Included',
  'autopilot.appr.zf.st.neu': 'New',
  'autopilot.appr.zf.alleSeite': 'Select all undecided on this page',
  'autopilot.appr.zf.gewaehlt': '{n} selected',
  'autopilot.appr.zf.bulkPasst': 'Good fit',
  'autopilot.appr.zf.bulkLaeuft': 'Saving {fertig} of {gesamt} …',
  'autopilot.appr.zf.bulkFehler': '{n} could not be saved — please retry',
  'autopilot.appr.zf.bereich': '{von}–{bis} of {gesamt}',
  'autopilot.appr.zf.grundFrage': 'Why is this company not a fit?',
  'autopilot.appr.zf.grundFrageN': 'Why are these {n} companies not a fit?',
  'autopilot.appr.zf.grundSkip': 'Remove without a reason',
  'autopilot.appr.zf.g.branche': 'Wrong industry',
  'autopilot.appr.zf.g.groesse': 'Wrong size',
  'autopilot.appr.zf.g.region': 'Wrong region',
  'autopilot.appr.zf.g.bekannt': 'Already known',
  'autopilot.appr.zf.g.kontakt': 'Contact is wrong',
  'autopilot.appr.zf.g.fit': 'Not a content fit',
  'autopilot.appr.zf.g.sonst': 'Other reason',
  'autopilot.appr.zf.g.bekanntHinweis':
    '“We already know them” removes the company from your suggestions for good, including future campaigns.',
  'autopilot.appr.zf.st.raus': 'Removed',
  'autopilot.camp.brief.title': 'Campaign plan',
  'autopilot.camp.brief.hint':
    'The plan behind this campaign — who we approach, with which offer, and what we compare along the way.',
  'autopilot.camp.brief.ziel': 'Goal',
  'autopilot.camp.brief.zielfirmen': 'Ideal companies',
  'autopilot.camp.brief.ausschluss': 'Excluded for now',
  'autopilot.camp.brief.ap': 'Contacts',
  'autopilot.camp.brief.prio.primaer': 'Primary',
  'autopilot.camp.brief.prio.sekundaer': 'Secondary',
  'autopilot.camp.brief.prio.alternativ': 'Alternative',
  'autopilot.camp.brief.aufhaenger': 'Angle',
  'autopilot.camp.brief.kern': 'Core message',
  'autopilot.camp.brief.angebot': 'The offer',
  'autopilot.camp.brief.cta': 'First step',
  'autopilot.camp.brief.abtest': 'What we compare (A/B)',
  'autopilot.camp.st.plan': 'Plan',
  'autopilot.camp.st.start': 'Launch',
  'autopilot.camp.st.zielfirmen': 'Target companies',
  'autopilot.camp.st.versand': 'Next send',
  'autopilot.camp.st.ergebnisse': 'Results & sequence',
  'autopilot.camp.st.planLeer':
    'The campaign plan is being worked out — you will see it here as soon as it stands.',
  'autopilot.camp.vs.geprueft': '{n} confirmed',
  'autopilot.camp.vs.ungeprueft': '{n} not confirmed',
  'autopilot.camp.vs.zust.ok': 'Address confirmed',
  'autopilot.camp.vs.zust.ungeprueft': 'Address not confirmed',
  'autopilot.camp.vs.erkl.geprueft':
    'We check every address before sending. Confirmed means the mail server acknowledged it. Not confirmed usually means catch-all, where the server answers the same for every address.',
  'autopilot.camp.vs.absender': 'Sender',
  'autopilot.camp.vs.takt': 'Pace',
  'autopilot.camp.vs.taktWert': '{n} emails per day',
  'autopilot.camp.vs.naechster': 'next send {when}',
  'autopilot.camp.vs.keinAbsender':
    'No sender mailbox has been assigned to this campaign yet. We will set it up before launch.',
  'autopilot.camp.vs.title': 'Next send',
  'autopilot.camp.vs.bereit': '{n} ready to send',
  'autopilot.camp.vs.wartet': '{n} waiting for a contact',
  'autopilot.camp.vs.hint':
    'This is how the email goes out. Green underline: filled from our research. Dashed: filled per person at send time.',
  'autopilot.camp.vs.keine':
    'No send-ready recipients yet — once contacts with email addresses are researched, you will see every email fully rendered here.',
  'autopilot.camp.vs.step': 'Step {n}',
  'autopilot.camp.vs.nurBrief':
    'This campaign has letter steps only — the letter preview comes from the print pipeline.',
  'autopilot.camp.vs.post': '{n} by post',
  'autopilot.appr.zf.th.aktion': 'Action',
  'autopilot.nav.approvalsBadgeTitle': 'Open approvals — waiting for your confirmation',
  'autopilot.appr.zf.hint':
    'We contact every company that is NOT marked as removed here. ✓ is optional and helps us match your taste.',
  'autopilot.ov.health.mailOne': 'email exchanged today',
  'autopilot.ov.health.mailsDay': 'mails exchanged on {day}',
  'autopilot.ov.health.mailOneDay': 'mail exchanged on {day}',
  'autopilot.ov.health.arrive': 'land in the inbox',
  'autopilot.ov.health.mails': 'emails exchanged today',
  'autopilot.ov.health.checksOk': 'All checks passed',
  'autopilot.ov.health.checksPart': '{clean} of {total} checks ok',
  'autopilot.ov.recent.title': 'Recently done for you',
  'autopilot.fun.title': 'Your funnel',
  'autopilot.fun.hint': 'since campaign launch',
  'autopilot.fun.contacted': 'Contacted',
  'autopilot.fun.delivered': 'Delivered',
  'autopilot.fun.replies': 'Replied',
  'autopilot.fun.interested': 'Interested',
  'autopilot.fun.handovers': 'Handed to you',
  'autopilot.fun.won': 'Won',
  'autopilot.ov.today.title': 'Today for you',
  'autopilot.ov.today.stand': 'As of {time}',
  'autopilot.ov.today.moved': '{n} warm-up emails moved',
  'autopilot.ov.today.lMoved': 'Warm-up emails moved',
  'autopilot.ov.today.lScore': 'Avg. delivery score',
  'autopilot.ov.today.lBl': 'Blocklists clean',
  'autopilot.ov.today.blClean': '{n} blocklists checked — all clean',
  'autopilot.ov.today.blPart': '{clean} of {total} blocklists clean',
  'autopilot.ov.today.empty': 'The machine is settling in — numbers follow daily.',
  'autopilot.ov.today.foot': 'Runs automatically, every day — weekends included.',
  'autopilot.ov.next.title': 'Your next step',
  'autopilot.ov.next.none': 'All on us — nothing for you to do right now.',
  'autopilot.ov.next.msSetup': 'Next from us: connecting your mailboxes to the warm-up network.',
  'autopilot.ov.next.msWarmup': 'Next from us: your sequence copy for approval.',
  'autopilot.ov.next.msLive': 'The engine is working — handovers appear here first.',
  'autopilot.ov.next.more': 'View +{n} more handovers',
  'autopilot.ov.outlook.title': 'What comes next',
  'autopilot.ov.outlook.approvals': 'Your approvals',
  'autopilot.ov.outlook.open': '{n} open',
  'autopilot.ov.outlook.start': 'Campaign launch',
  'autopilot.ov.outlook.replies': 'First replies',
  'autopilot.ov.outlook.repliesVal': 'typically week 2–3',
  'autopilot.ov.trust.bl': '{n} blocklists clean',
  'autopilot.ov.trust.write': 'Write',
  'autopilot.ov.trust.report': 'Report on {date}',
  'autopilot.mb.hint':
    'Warmup runs continuously — even while live, a low baseline keeps deliverability high.',
  'autopilot.mb.perDay': '{n} emails/day',
  'autopilot.mb.score': 'Deliverability',
  'autopilot.mb.st.connecting': 'connecting',
  'autopilot.mb.st.ready': 'ready',
  'autopilot.mb.st.sending': 'active · maintenance warmup',
  'autopilot.mb.st.warmup': 'Warmup · day {d}/{total}',
  'autopilot.mb.title': 'Mailboxes & warmup',
  'autopilot.mb.count': '{active} of {total} active',
  'autopilot.mb.scoreLabel': 'Deliverability score',
  'autopilot.mb.sent': '{n} campaign emails sent from this mailbox',
  'autopilot.mode.autopilot': 'Autopilot',
  'autopilot.mode.lockedHint': 'Autopilot is an add-on module – learn more',
  'autopilot.mode.search': 'Standard',
  'autopilot.nav.history': 'Campaigns',
  'autopilot.nav.overview': 'Dashboard',
  'autopilot.nav.replies': 'Replies',
  'autopilot.nav.tech': 'Tech',
  'autopilot.notActive.hint': 'If you would like to use Autopilot, get in touch with us.',
  'autopilot.notActive.title': 'Autopilot is not active for this account',
  'autopilot.ov.activeTitle': 'Your engine is working',
  'autopilot.ov.awaitCta': 'Go to approvals',
  'autopilot.ov.awaitHint': 'Only your approvals are missing — then we start sending.',
  'autopilot.ov.awaitTitle': 'Your engine is ready to launch',
  'autopilot.ov.endedTitle': 'Autopilot ended',
  'autopilot.ov.engineTitle': 'Your engine',
  'autopilot.ov.offerHint': 'As soon as the contract is in place, we start building your engine.',
  'autopilot.ov.offerTitle': 'Your Autopilot is being prepared',
  'autopilot.ov.pausedHint': 'Nothing is being sent. Contact your account manager to resume.',
  'autopilot.ov.pausedTitle': 'Sending paused',
  'autopilot.ov.setupHint':
    'Domain, authentication and mailboxes are being set up — entirely by us. Nothing for you to do; we will reach out as soon as your first approvals are ready.',
  'autopilot.ov.setupTitle': 'We are building your engine',
  'autopilot.ov.warmupDay': 'Warmup · day {d} of {total}',
  'autopilot.ov.warmupHint':
    'Your mailboxes are being warmed up carefully so your emails land in the inbox — not in spam. Meanwhile you can complete your approvals.',
  'autopilot.ov.warmupTitle': 'Warmup in progress',
  'autopilot.pause.hintContact':
    'Your contact stops the sending for you — just reach out, it takes effect immediately.',
  'autopilot.pause.action': 'Pause sending',
  'autopilot.pause.hint':
    'Stops all sending immediately and completely. Your account manager will follow up personally.',
  'autopilot.pause.title': 'Emergency stop',
  'autopilot.pause.confirm': 'Really stop?',
  'autopilot.pause.done': 'Sending paused — your account manager will follow up personally.',
  'autopilot.pause.error': 'Pausing failed — please contact your account manager directly.',
  'autopilot.pause.pausedHint':
    'Sending is paused. Your account manager will follow up personally before anything resumes.',
  'autopilot.pulse.checked': '{n} AI-checked',
  'autopilot.pulse.next': 'Next send {when}',
  'autopilot.pulse.queue': '{n} in queue',
  'autopilot.pulse.quiet':
    'No sending yet — the engine is being set up. Once it starts, you’ll see the daily pulse here.',
  'autopilot.pulse.researched': '{n} researched',
  'autopilot.pulse.sent': '{n} sent today',
  'autopilot.pulse.title': 'The engine right now',
  'autopilot.quota.progress': '{used} of ~{target} companies',
  'autopilot.quota.title': 'Quota this month',
  'autopilot.rc.interested': 'Interested',
  'autopilot.rc.later': 'Later',
  'autopilot.rc.noNeed': 'No need',
  'autopilot.rc.ooo': 'Out of office',
  'autopilot.rc.unsub': 'Unsubscribe',
  'autopilot.rcls.title': 'Replies by category',
  'autopilot.rep.actionFailed': 'Action failed — please try again.',
  'autopilot.rep.call': 'Call now',
  'autopilot.rep.contacted': 'Mark as taken over',
  'autopilot.rep.contactedDone': 'Taken over on {date}',
  'autopilot.rep.contactedSet': 'Marked as taken over — thanks, that helps us.',
  'autopilot.rep.contactedShort': 'Taken over',
  'autopilot.rep.dealPlaceholder': 'Deal value',
  'autopilot.rep.emptyHint':
    'Once your campaign is running, replies from contacted companies appear here — with the full thread and our assessment.',
  'autopilot.rep.emptyTitle': 'No replies yet',
  'autopilot.rep.intro': 'Real conversations with the full thread. We clarify, you make the call.',
  'autopilot.rep.gateTitle': 'Screened by us.',
  'autopilot.rep.gateHint':
    'Every incoming reply is read and classified — only what can become a real conversation lands here. Everything else flows quietly into the stats.',
  'autopilot.rep.gateStats':
    '{total} replies total · {interested} interested · {later} later · {noNeed} no need',
  'autopilot.rep.lostPlaceholder': 'Reason (optional)',
  'autopilot.rep.noFit': 'Not a fit',
  'autopilot.rep.noFitSet': 'Marked as not a fit — your engine learns from this.',
  'autopilot.rep.noFitWhy': 'Quick one: why is it not a fit?',
  'autopilot.rep.noFitR.industry': 'Wrong industry',
  'autopilot.rep.noFitR.size': 'Wrong company size',
  'autopilot.rep.noFitR.role': 'Wrong contact person',
  'autopilot.rep.noFitR.other': 'Other reason',
  'autopilot.rep.saveClose': 'Save',
  'autopilot.rep.title': 'Replies',
  'autopilot.rep.viewThread': 'View thread ({n})',
  'autopilot.rep.threadEmpty': 'No conversation history yet.',
  'autopilot.rep.threadSent': 'Sent · {step}',
  'autopilot.rep.threadSentPlain': 'Sent by you',
  'autopilot.rep.threadFoot': 'Sent in your name. Changes go through your account manager.',
  'autopilot.rep.cls.interested': 'Interested',
  'autopilot.rep.cls.later': 'Later',
  'autopilot.rep.cls.noNeed': 'No need',
  'autopilot.rep.cls.referral': 'Referred to the right person',
  'autopilot.rep.cls.question': 'Question',
  'autopilot.rep.cls.outOfOffice': 'Out of office',
  'autopilot.rep.cls.unsubscribed': 'Unsubscribed',
  'autopilot.rep.wonNoValue': 'Won',
  'autopilot.rep.wonSet': 'Won — great! The deal value flows into your results.',
  'autopilot.report.first':
    'Your next report arrives on {date} — sent, delivered, replies, handovers. No sugarcoating.',
  'autopilot.report.title': 'Monthly report',
  'autopilot.res.angles': 'Angles',
  'autopilot.res.anglesHint': 'Which opening starts the conversation.',
  'autopilot.res.emptyHint':
    'Once your campaign runs and the first replies arrive, this shows what resonates and what does not.',
  'autopilot.res.emptyTitle': 'No resonance yet',
  'autopilot.res.footnote':
    'Rates shown from 30 contacted companies upwards — below that, a percentage is chance.',
  'autopilot.res.intro':
    'Where replies come from — and what nobody responds to. Your engine measures every approach and acts on it.',
  'autopilot.res.learnedTitle': 'What your engine does with it',
  'autopilot.res.segments': 'Segments',
  'autopilot.res.segmentsHint': 'Which industries and roles reply.',
  'autopilot.res.subjects': 'Subject lines',
  'autopilot.res.subjectsHint': 'What gets opened and answered.',
  'autopilot.res.thin': 'too little data',
  'autopilot.res.title': 'What resonates',
  'autopilot.spark.empty': 'Appears once sending starts.',
  'autopilot.spark.title': 'Sending activity (4 weeks)',
  'autopilot.stage.clarify': 'Clarifying',
  'autopilot.stage.handover': 'Handed over',
  'autopilot.stage.lost': 'Lost',
  'autopilot.stage.new': 'New',
  'autopilot.stage.won': 'Won',
  'autopilot.status.active': 'Active',
  'autopilot.status.awaiting': 'Awaiting approval',
  'autopilot.status.contract': 'Contract signed',
  'autopilot.status.ended': 'Ended',
  'autopilot.status.offer': 'In preparation',
  'autopilot.status.paused': 'Paused',
  'autopilot.status.setup': 'Setup',
  'autopilot.status.warmup': 'Warmup',
  'autopilot.step.approvals': 'Launch approval',
  'autopilot.step.live': 'Live',
  'autopilot.step.setup': 'Setup',
  'autopilot.step.warmup': 'Warmup',
  'autopilot.talk.all': 'View all',
  'autopilot.talk.empty':
    'Once your campaign is live, you’ll see here who the engine is talking to.',
  'autopilot.talk.emptyLive': 'No open conversations right now — the next reply will show up here.',
  'autopilot.talk.title': 'In conversation right now',
  'autopilot.tasks.approvals': '{n} approvals waiting for you',
  'autopilot.tasks.approvalsOne': 'One approval is waiting for you',
  'autopilot.tasks.call1': 'One warm handover is waiting for your call',
  'autopilot.tasks.calls': '{n} warm handovers waiting for your call',
  'autopilot.tasks.none': 'Nothing to do — the engine is working for you.',
  'autopilot.tasks.title': 'Your tasks',
  'autopilot.tech.inArbeit': 'Setup in progress · {bereit} of {gesamt} mailboxes ready',
  'autopilot.tech.allGreen': 'All operational',
  'autopilot.tech.auto': 'Runs automatically',
  'autopilot.tech.autoHint':
    'These maintenance tasks run in the background — without you ever lifting a finger.',
  'autopilot.tech.blacklists': 'Blacklist monitoring',
  'autopilot.tech.clean': 'clean',
  'autopilot.tech.dmarcReports': 'DMARC aggregate reports active',
  'autopilot.tech.domains': 'Sending domains',
  'autopilot.tech.integrations': 'Connected systems',
  'autopilot.tech.intro':
    'Your complete sending infrastructure at a glance — domains, DNS authentication, mailboxes, monitoring. We set it all up and keep it green; you touch none of it.',
  'autopilot.tech.mailboxes': 'Mailboxes & authentication',
  'autopilot.tech.nis2': 'Domain verified',
  'autopilot.tech.owner': 'Owner: you',
  'autopilot.tech.pending':
    'Your infrastructure is being set up — your full control room appears here soon.',
  'autopilot.tech.pipeline': 'The AI pipeline',
  'autopilot.tech.pipelineHint':
    'Every single email passes through these independent checks before it is ready to send.',
  'autopilot.tech.placement': 'Last placement test: {n}% inbox',
  'autopilot.tech.registrar': 'Registrar: {name}',
  'autopilot.tech.rep': 'Reputation {n}',
  'autopilot.tech.score': 'Deliverability score {n}',
  'autopilot.tech.placementLive': 'Inbox rate in the warmup network (7 days): {n}%',
  'autopilot.tech.replyLogic': 'Reply intelligence',
  'autopilot.tech.reputation': 'Reputation & delivery monitoring',
  'autopilot.tech.ssl': 'TLS/SSL',
  'autopilot.tech.title': 'Tech & deliverability',
  'autopilot.tech.warmup': 'Warmup',
  'autopilot.ov.hero.warmOffen':
    'Your mailboxes are still warming up (day {d} of {total}). Approve now and we’ll start as soon as they’re ready.',
  'autopilot.ov.hero.warmFrei':
    'Everything is approved. Your mailboxes are still warming up (day {d} of {total}), then the first email will go out.',
  'autopilot.ov.hero.fertigOffen':
    'Your mailboxes are warmed up. We’re just waiting for your approvals to start.',
  'autopilot.ov.hero.fertigFrei': 'Warmed up and approved. We’re preparing the first send.',
  'autopilot.ov.hero.startNachFreigabe': 'as soon as you’ve approved',
  'autopilot.ov.hero.startInVorbereitung': 'in preparation',
  'autopilot.mb.st.fertig': 'Warmed up',
  'autopilot.camp.offenDanach': ', then {label}',
  'autopilot.ov.ring.bereit': 'ready',
  'autopilot.ov.hero.bereitOffen':
    'Ready to launch: all {n} mailboxes score at least {s} on deliverability. Only your approvals are missing.',
  'autopilot.ov.hero.bereitFrei':
    'Ready and approved. All {n} mailboxes score at least {s} on deliverability; we are preparing the first send.',
  'autopilot.ov.hero.teilOffen':
    '{bereit} of {n} mailboxes are ready to launch (deliverability score {s}+). Approve now and we start as soon as all of them are.',
  'autopilot.ov.hero.teilFrei':
    '{bereit} of {n} mailboxes are ready to launch (deliverability score {s}+). We start as soon as all of them are.',
  'autopilot.ov.hero.scoreRegel': 'Deliverability score per mailbox · ready from {s}',
  'autopilot.mb.st.bereit': 'Ready to launch',
  'autopilot.mb.st.bereitTeil': '{bereit} of {n} ready',
  'autopilot.mb.st.mbBereit': 'ready · day {d}/{total}',
  'autopilot.warm.regel':
    'A mailbox is ready to launch from a deliverability score of {s}. The {total} days are a guideline, not the condition.',
  'autopilot.camp.vs.wartetTitel':
    'Companies without a researched email address. They join automatically as soon as a contact with an address is found.',
  'autopilot.camp.vs.empfaenger': 'Recipients',
  'autopilot.camp.vs.vorschauFuer': 'Preview for',
  'autopilot.camp.vs.an': 'To',
  'autopilot.camp.vs.platzhalter': 'filled per person at send time',
  'autopilot.erkl.aria': 'How is this calculated?',
  'autopilot.erkl.quelle': 'Source: {q}',
  'autopilot.warm.scoreChart.title': 'Deliverability score by mailbox',
  'autopilot.warm.scoreChart.hint':
    'The band spans all mailboxes, the line follows the weakest. Ready to launch from {s}.',
  'autopilot.warm.scoreChart.perBox': 'by mailbox',
  'autopilot.warm.scoreChart.perDomain': 'by domain',
  'autopilot.warm.scoreChart.schwelle': 'ready to start at {s}',
  'autopilot.warm.scoreChart.xHinweis':
    'Each point is a saved score change, with the current score on the right.',
  'autopilot.warm.scoreChart.messpunkt': 'Point {n}',
  'autopilot.warm.chart.gesendet': 'Sent',
  'autopilot.warm.scoreChart.titleDomain': 'Deliverability score by domain',
  'autopilot.warm.scoreChart.hintDomain':
    'The band spans your domains, the line follows the weakest. A mailbox is ready to launch from {s}.',
  'autopilot.warm.erkl.traffic':
    'These are warmup emails in the lemwarm network. The figures include incoming network traffic and do not show campaign sends.',
  'autopilot.warm.erkl.placement':
    'The figures show where your warmup emails land, including incoming network emails. The inbox rate is inbox divided by the sum of inbox and spam.',
  'autopilot.warm.erkl.tage':
    'The days are a guideline for your warmup period; the requirement is a deliverability score of at least {s} per mailbox.',
  'autopilot.warm.traffic.nochKeineKampagne':
    'This is traffic in the warmup network, not campaign emails yet.',
  'autopilot.warm.placement.vorwoche':
    'Inbox rate for the last 7 recorded days compared with the preceding 7 days.',
  'autopilot.camp.vs.absenderKonto':
    'These mailboxes belong to your account. Which of them sends this campaign is set before launch.',
  'autopilot.camp.vs.quellePruefung': 'email check',
  'autopilot.appr.zf.unvollstaendig':
    'We show the most recent companies up to the display limit. Older ones are not included here.',
  'autopilot.appr.zf.ladeFehler':
    'Some of your companies could not be loaded. Reload the page and we will try again.',
  'autopilot.warm.scoreChart.schwelleKurz': 'ready to launch',
  'autopilot.warm.scoreChart.alle': 'All',
  'autopilot.warm.scoreChart.hintEines': 'History for {adresse}. Ready to launch from {s}.',
  // LEA-505 — Ein-Klick-Nachkauf von Kontakt-Paketen (Bestätigungskarte + Checkout-Einwilligung)
  'refill.checkoutConsent':
    'Your card will be saved for one-click top-ups later. It is only charged when you explicitly confirm a top-up at the amount shown — no subscription, no automatic reload. You can remove the card at any time in the customer portal.',
  'refill.title': 'Buy more contacts',
  'refill.subtitle': 'With your saved card — no detour through checkout.',
  'refill.choose': 'Choose a pack',
  'refill.pack': '{n} contacts',
  'refill.net': '{amount} net',
  'refill.total': 'Total',
  'refill.inclTax': 'incl. {tax} VAT',
  'refill.reverseCharge': 'No VAT — reverse charge, the recipient accounts for the tax.',
  'refill.cardLabel': 'Paid with {brand} •••• {last4}',
  'refill.cta': 'Pay {amount} now',
  'refill.quoting': 'Calculating the amount …',
  'refill.paying': 'Processing payment …',
  'refill.terms': 'One-time payment, no subscription. Your contacts never expire.',
  // LEA-518 — first contact-pack purchase (Checkout) for reveal customers
  'packs.first.title': 'Buy contacts',
  'packs.first.subtitle': 'Choose a pack, then use it to unlock contacts.',
  'packs.first.balance': 'Contacts available: {n}',
  'packs.first.popular': 'Popular',
  'packs.first.cta': 'Continue to payment',
  'packs.first.redirecting': 'Redirecting to Stripe…',
  'packs.first.checkoutNote':
    'You pay securely with Stripe in the next step, where you see the final amount including VAT.',
  'packs.first.error': "The payment couldn't be started. Please try again.",
  'packs.first.loadError': "The packs couldn't be loaded right now.",
  'packs.first.retry': 'Try again',
  'refill.success': '{n} contacts added. New balance: {balance}.',
  'refill.again': 'Buy another pack',
  'refill.amountChanged': 'The amount has changed. Please confirm the new amount.',
  'refill.inProgress': 'A top-up is already running. One moment …',
  'refill.processing': "The payment is still processing. We'll check again in a moment.",
  'refill.failedDeclined': 'Your bank declined the payment. Nothing was charged.',
  'refill.failedAuth': 'The confirmation with your bank was not completed. Nothing was charged.',
  'refill.failed': 'The payment did not go through. Nothing was charged.',
  'refill.error': "That didn't work. Please try again in a moment.",
  'refill.checking': 'Checking the status of your payment …',
  'refill.unknown': "We couldn't confirm the payment yet. Check your balance before buying again.",
  'refill.retryQuote': 'Reload the amount',
  'refill.checkStatus': 'Check payment status',

  'auth.register.errPwPolicy':
    'Password is too weak. Use at least 8 characters with upper and lower case letters, a number and a special character.',
  'auth.err.emailTaken': 'This email is already registered. Please sign in.',
  'auth.err.rateLimited':
    'Too many attempts from this connection. Please try again in {minutes} minutes at the latest.',
  'auth.err.rateLimitedLater': 'Too many attempts from this connection. Please try again later.',
  'auth.err.network': 'Could not reach the server. Please check your internet connection.',
  'auth.err.busy': 'The server is busy right now. Please try again in a moment.',
  'auth.err.signupFailed': 'Sign-up failed. Please try again in a moment.',
  'auth.err.invalidInput': 'Please check your inputs.',
  'auth.err.turnstileFailed':
    'The bot check failed or expired. Please reload the page and try again.',
  'auth.err.turnstileBlocked':
    'The security check could not run. An ad or tracking blocker may be stopping it: allow challenges.cloudflare.com for this page or try another browser.',
  'auth.err.popupBlocked':
    'The sign-in popup was blocked. Please allow popups for this site and try again.',
  'auth.err.popupClosed': 'The sign-in popup was closed before authentication completed.',
  'auth.err.otherProvider':
    'An account with this email already exists. Please sign in with {provider}.',
  'auth.err.otherMethod':
    'An account with this email already exists. Please sign in the way you signed up (Google, Microsoft or email and password).',
  'auth.err.providerPassword': 'email and password',
  'auth.err.firstName': 'Please enter your first name.',
  'auth.err.lastName': 'Please enter your last name.',
  'auth.err.pwLong': 'Password is too long.',
  'auth.err.oauthFailed': 'Sign-in with the identity provider failed. Please try again.',
  'auth.err.noEmailFromProvider':
    'We didn’t receive an email address from your provider. Please use a different login method.',
  'auth.err.ssoUnavailable':
    'Sign-in with Google or Microsoft is temporarily unavailable. Please use email and password.',
  'auth.err.accountGone': 'This account has been deleted or is disabled.',
  'auth.err.sessionFailed': 'Could not create the session. Please try again.',
  'auth.register.next.prism':
    'Next: describe your target audience and see real companies. You only pay when you unlock leads.',
  'auth.register.next.noCard':
    'After signing up you can start right away. No payment details needed.',
  'auth.register.next.trial':
    'Next: choose a plan and try it for 3 days. Card required, €0 today; the plan then continues unless you cancel before the trial ends.',
  'auth.register.next.plan': 'Next: choose a plan. Card payment is due immediately.',
  'auth.register.busyHint': 'Creating your account. This takes a few seconds.',
  'auth.login.legalSso':
    'New here? Signing in with Google or Microsoft creates an account automatically and you accept our {terms}. You can find information about your data in our {privacy}.',
  'auth.r19.form.pw.title': 'Password requirements',
  'auth.r19.form.pw.len': 'At least 8 characters',
  'auth.r19.form.pw.case': 'Upper- and lowercase letters',
  'auth.r19.form.pw.digit': 'A number',
  'auth.r19.form.pw.special': 'A special character',
  'auth.r19.form.pw.met': 'met',
  'auth.r19.form.pw.open': 'not yet met',
  'auth.r19.chat.greeting':
    'Ask your question here. If you include your email address, we can also reply later.',
  'auth.r19.chat.failed': 'The chat can’t be opened right now. Email us instead at',

  'prism.abandon.fit': "The companies don't fit",
  'prism.abandon.fitQ': 'Which companies did you expect?',
  'prism.abandon.freeText': 'Or tell us in one sentence…',
  'prism.abandon.later': "I'll look later",
  'prism.abandon.price': 'The price',
  'prism.abandon.q': "Quick question: what's holding you back?",
  'prism.abandon.send': 'Send',
  'prism.abandon.skip': 'Skip',
  'prism.abandon.thanks': 'Thanks — this really helps.',
  'prism.checkout.autoNote':
    'Turns into the Starter plan (250 credits/month) automatically unless you cancel within the 3 trial days.',
  // Prism-Umsatzpaket (16.10.2026): Abo-Satz, Entscheider vor dem Kauf, Hinweise.
  'prism.abo.line':
    '€49 today · from day 4: €290/month · cancel monthly with one click',
  'prism.abo.afterDelivery':
    'Every week ~{n} new companies. For each one we look for the decision maker, and you only pay if we find them.',
  'prism.abo.afterCredits':
    'After that, {credits} credits every month for new companies and contacts.',
  'prism.teaser.tag':
    'Free decision maker preview',
  'prism.teaser.running':
    'We’re looking up the decision maker at {company} …',
  'prism.teaser.foundShort':
    'Decision maker found: {name}',
  'prism.teaser.noneShort':
    'No decision maker with proof found',
  'prism.teaser.failedShort':
    'Lookup not possible right now',
  'prism.teaser.open':
    'View',
  'prism.teaser.close':
    'Collapse',
  'prism.teaser.role':
    'Role',
  'prism.teaser.source':
    'Proof',
  'prism.teaser.email':
    'Email',
  'prism.teaser.src.impressum':
    'Legal notice of {domain}',
  'prism.teaser.src.handelsregister':
    'Commercial register',
  'prism.teaser.src.website':
    'Website of {domain}',
  'prism.teaser.mail.verified':
    'verified with the mail server',
  'prism.teaser.mail.probable':
    'very likely deliverable',
  'prism.teaser.mail.found':
    'listed like this on their website',
  'prism.teaser.mail.none':
    'no personal email found',
  'prism.teaser.foundNote':
    'This is how we research each of your {n} matching companies. You see the full email after unlocking, plus phone where available.',
  'prism.teaser.noneBody':
    'For {company} we found no decision maker with proof (legal notice, commercial register or their own website). Rather than make something up, we show you nothing.',
  'prism.teaser.noneNote':
    'After unlocking, a credit only counts when we find a contact.',
  'prism.teaser.failedBody':
    'The lookup didn’t work just now. After unlocking it runs for all {n} companies.',
  'prism.teaser.cta':
    'Unlock all {n}',
  'prism.cardHint.body':
    'We research the decision maker at {company} after unlocking: name and role, plus email or phone where publicly available.',
  'prism.cardHint.example':
    'You can see an example above at {top}.',
  'prism.cardHint.cta':
    'Unlock',
  'prism.website.skip':
    'Continue without a website',
  'prism.website.issue.own_product':
    'That’s our site, not yours. Enter your own company’s website so we understand what you sell.',
  'prism.website.issue.ai_chat':
    'That’s a link to an AI chat. We need your own company’s website, e.g. “your-company.com”.',
  'prism.website.issue.social':
    'A social media profile tells us too little about your offer. Do you have your own website? Otherwise just skip this step.',
  'prism.website.issue.redirect':
    'That’s a short or redirect link. Please enter your website’s address directly, e.g. “your-company.com”.',
  'prism.notice.title':
    'A quick note on data',
  'prism.notice.local_b2c':
    'Small shops serving consumers (e.g. hair salons or snack bars) often list only a phone number and the owner online. We find verified decision-maker emails there less often than at companies selling to businesses.',
  'prism.notice.outside_dach':
    'Our data is most complete in Germany, Austria and Switzerland. Outside those countries a legal notice and a commercial register entry are often missing, so we find fewer decision makers.',
  'prism.notice.continue':
    'You can still search.',
  // Gratis-Leads vor dem Kauf + Hinweise für die übrige Liste (16.10.2026).
  'prism.free.tag':
    'Your {n} free leads, ready to use',
  'prism.free.tagRunning':
    'We’re looking for your {n} free leads',
  'prism.free.tagOne':
    'Your free lead, ready to use',
  'prism.free.tagNone':
    'Free leads: none with proof this time',
  'prism.free.tagSlow':
    'Your free leads are taking a bit longer',
  'prism.free.slowBody':
    'The research is taking longer than usual this time. We’ll show your free leads here as soon as they’re ready, even if you come back later.',
  'prism.free.running':
    'We’re looking up the decision makers at your strongest companies … ({found} of {n})',
  'prism.free.noneBody':
    'For your strongest companies we found no decision maker with proof and an email (legal notice, commercial register or their own website). Rather than make something up, we show you nothing. After unlocking, a credit only counts when we find a contact.',
  'prism.free.fewer':
    '{found} of {n} could be proven. The other top companies had no proof, so we show nothing there.',
  'prism.free.yours':
    'Copy or export them, they’re yours.',
  'prism.free.export':
    'Export as CSV',
  'prism.free.copy':
    'Copy',
  'prism.free.copied':
    'Copied',
  'prism.free.cta':
    'Unlock all {n}',
  'prism.free.usedNote':
    'Free leads are available once per account and company. You see this decision maker here as a preview.',
  'prism.free.csv.company':
    'Company',
  'prism.free.csv.domain':
    'Domain',
  'prism.free.csv.name':
    'Name',
  'prism.free.csv.role':
    'Role',
  'prism.free.csv.email':
    'Email',
  'prism.free.csv.phone':
    'Phone',
  'prism.free.csv.source':
    'Proof',
  'prism.pattern.first':
    'first',
  'prism.pattern.last':
    'last',
  'prism.pattern.f':
    'f',
  'prism.hint.freeAbove':
    'Unlocked for free, see above',
  'prism.hint.dmsOne':
    '1 decision maker: {roles}',
  'prism.hint.dmsMany':
    '{count} decision makers: {roles}',
  'prism.hint.dmsNoRole':
    '{count} decision makers proven',
  'prism.hint.pattern':
    'Email pattern found:',
  'prism.hint.src.impressum':
    'Legal notice',
  'prism.hint.src.handelsregister':
    'Commercial register',
  'prism.hint.src.website':
    'Website',
  'prism.hint.unlock':
    'Unlock',
  'prism.hint.unlockSub':
    'contact',
  'prism.freelead.tagTop': 'Your strongest match',
  'prism.rail.label': 'Progress',
  'prism.rail.audience': 'Audience',
  'prism.rail.website': 'Website',
  'prism.rail.refine': 'Refine',
  'prism.rail.result': 'Results',
  'prism.rail.done': 'done',
  'prism.steps.earlier': '{n} earlier steps done',
  'prism.lead.evidenceTag': 'On their website:',
  'prism.plan.termsStrong': 'From day 4: €290/month.',
  'prism.plan.termsBody':
    'After the 3 trial days your access automatically becomes the Starter plan (250 credits/month). Cancel before then in your account and you pay only the €49.',
  'prism.rateLimited.body':
    'You’ve used up your searches for today. We’ll pick back up tomorrow — your inputs are saved.',
  'prism.rateLimited.title': 'Daily limit reached',
  'prism.results.queriesLabel': 'How we searched:',
  'prism.results.queriesMore': '+{count} more',
  'prism.score.possible': 'Possible fit',
  'prism.target.errEmpty': 'Tell us who you want to reach first — e.g. “dentists in Berlin”.',
  // LEA-595: Setup-Lieferungen freischalten (für jedes Offer).
  'ld.reveal.title': 'Contacts found, still locked',
  'ld.reveal.hint':
    "You'll see the name, email and phone once you unlock. One unlock opens all of this company's contacts.",
  'ld.reveal.cta': 'Unlock contacts',
  'ld.reveal.confirm':
    "This uses 1 credit. You'll then see this company's contacts in full, and the acquisition plan costs nothing extra.",
  'ld.reveal.confirmCta': 'Unlock for 1 credit',
  'ld.reveal.busy': 'Unlocking…',
  'ld.reveal.done': 'Contacts unlocked, 1 credit used.',
  'ld.reveal.already': 'Already unlocked, nothing was charged again.',
  'ld.reveal.notEligible':
    'No reachable contact person, so there is nothing to unlock and nothing is charged.',
  'ld.reveal.verificationPending':
    'The contacts are still being checked. Try again in a minute; nothing was charged.',
  'ld.reveal.researchRunning':
    'The contact search is still running. You can unlock once it has finished.',
  'ld.reveal.failed': "Unlocking didn't work. Please try again; you're never charged twice.",
  'ld.reveal.noCredits': 'You need 1 credit to unlock.',
  'ld.reveal.buyContacts': 'Your balance is empty – you can top up contacts here',
  'ld.reveal.planLocked': 'Unlock the contacts first',
  'ld.reveal.planNoContact': 'No reachable contact person, so no acquisition plan',
  'ld.contact.lockedEmailPhone': 'Email and phone after unlocking',
  'ld.contact.lockedEmail': 'Email after unlocking',
  'ld.contact.lockedPhone': 'Phone after unlocking',
  // Wöchentliche Lieferung, Etappe B (16.10.2026) — Kundenseite + Assistant.
  'delivery.card.title': 'Weekly delivery',
  'delivery.card.badgeNew': 'New',
  'delivery.card.forAudience': 'for {name}',
  'delivery.card.amount': 'Every week ~{n} new companies. For each one we look for the decision maker, and you only pay if we find them.',
  'delivery.card.credits': 'Up to {credits} credits per delivery: 1 per company, 1 per decision maker found',
  'delivery.card.switchLabel': 'Turn weekly delivery on or off',
  'delivery.card.on': 'On',
  'delivery.card.off': 'Off',
  'delivery.card.offHint': 'Turn it on and the first delivery starts right away.',
  'delivery.card.next.label': 'Next delivery',
  'delivery.card.next.afterRating': 'once you have rated the current one, by {date} at the latest',
  'delivery.card.next.soon': 'starts shortly',
  'delivery.card.running': 'Delivery {no} in progress: {delivered} of {target} companies',
  'delivery.card.runningConnect': 'Delivery {no}: {delivered} companies in, finding the decision makers now',
  'delivery.card.lowCredits': 'You have {credits} credits, a full delivery needs {need}.',
  'delivery.card.topUp': 'Top up credits',
  'delivery.card.loadFailed': 'The delivery could not be loaded.',
  'delivery.pause.out_of_credits.title': 'Paused: out of credits',
  'delivery.pause.out_of_credits.body': 'With new credits the delivery picks up again by itself.',
  'delivery.pause.niche_exhausted.title': 'Paused: your audience is used up',
  'delivery.pause.niche_exhausted.body': 'We find no new companies here. Widen it with one click:',
  'delivery.pause.subscription_ended.title': 'Paused: your subscription has ended',
  'delivery.pause.subscription_ended.body': 'With an active plan the delivery continues.',
  'delivery.pause.subscription_ended.cta': 'Choose a plan',
  'delivery.pause.subscription_paused.title': 'Paused: your subscription is on hold',
  'delivery.pause.subscription_paused.body': 'Once your subscription runs again, the delivery continues.',
  'delivery.pause.payment_issue.title': 'Paused: payment outstanding',
  'delivery.pause.payment_issue.body': 'Update your payment method and the delivery continues.',
  'delivery.pause.payment_issue.cta': 'Update payment',
  'delivery.pause.other.title': 'Paused',
  'delivery.pause.other.body': 'Send us a short message and we\'ll look into it.',
  'delivery.expand.hint': 'This changes your audience, for your manual searches too.',
  'delivery.pause.profile_missing.title': 'Paused: this audience no longer exists',
  'delivery.pause.profile_missing.body': 'Create a new audience and switch the delivery on there.',
  'delivery.pause.profile_missing.cta': 'Create audience',
  'delivery.pause.not_self_service.title': 'Paused: our team looks after your account',
  'delivery.pause.not_self_service.body': 'You get your companies through Autopilot.',
  'delivery.pause.account_closed.title': 'Paused: deletion requested',
  'delivery.pause.account_closed.body': 'We don\'t deliver to an account that is being deleted.',
  'delivery.pause.unsupported_model.title': 'Paused: not included in your plan',
  'delivery.pause.unsupported_model.body': 'The delivery is part of Basic, Starter and Growth.',
  'delivery.short.title': 'Last delivery: {delivered} of {target} companies',
  'delivery.short.body': 'Your audience has nothing more right now. Widen it with one click:',
  'delivery.expand.loading': 'Checking suggestions …',
  'delivery.expand.none': 'Describe your audience more broadly to continue.',
  'delivery.expand.edit': 'Edit audience',
  'delivery.expand.applied': 'Audience widened. The next delivery starts shortly.',
  'delivery.expand.opt.area': 'Widen to all of {area} instead of {from} and start the delivery',
  'delivery.expand.opt.dach': 'Widen to Germany, Austria and Switzerland and start the delivery',
  'delivery.expand.opt.industry': 'Add {industry} to your audience and start the delivery',
  'delivery.expand.opt.size': 'Allow all company sizes instead of {from} employees and start the delivery',
  'delivery.toast.on': 'Delivery is on. The first one starts shortly.',
  'delivery.toast.off': 'Delivery is off.',
  'delivery.toast.failed': 'That did not work. Please try again.',
  'delivery.toast.planRequired': 'You need an active plan for the delivery.',
  'delivery.history.title': 'Past deliveries',
  'delivery.history.cycle': 'Delivery {no}',
  'delivery.history.companies': '{n} companies',
  'delivery.history.withContact': '{n} with decision maker',
  'delivery.history.acceptRate': '{pct} % fit',
  'delivery.history.noRating': 'not rated yet',
  'delivery.history.review': 'Rate now ({n} open)',
  'delivery.history.show': 'View',
  'delivery.history.empty': 'Your first delivery will appear here.',
  'delivery.history.more': 'Show all',
  'delivery.history.less': 'Show less',
  'delivery.filter.prefix': 'Filtered to:',
  'delivery.notif.ready.title': 'Your delivery is here: {n} companies',
  'delivery.notif.ready.body': '{connected} of them with a decision maker, for {name}. Rate them and the next one follows.',
  'delivery.notif.paused.out_of_credits.title': 'Delivery paused: out of credits',
  'delivery.notif.paused.out_of_credits.body': 'With new credits it picks up again by itself.',
  'delivery.notif.paused.niche_exhausted.title': 'Delivery paused: audience used up',
  'delivery.notif.paused.niche_exhausted.body': 'Widen {name} with one click to continue.',
  'agent.delivery.tool.status': 'Check delivery',
  'agent.delivery.tool.set': 'Weekly delivery',
  'agent.delivery.cost.enable': 'Up to {credits} credits per delivery: every week ~{n} new companies, and for each one we look for the decision maker. You only pay that credit if we find them. You can switch it off any time.',
};

export default en;
